import type { ODataModelResponseV4 } from '@odata2ts/odata-core'
import type { ODataHttpClient, ODataHttpClientConfig, HttpResponseModel } from '@odata2ts/http-client-api'
import {
  ODataService,
  EntityTypeServiceV4,
  ODataServiceOptionsInternal,
  EntitySetServiceV4,
} from '@odata2ts/odata-service'
import type {
  BaseObjectId,
  ad_csnId,
  ad_incentivoId,
  ad_percentualeId,
  ad_product_catalogId,
  ad_promotionId,
  ad_quoteId,
  ad_quote_historyId,
  ad_subscriptionId,
  agenteId,
  analisiId,
  argomento_problemaId,
  assistenzaId,
  attivita_commId,
  attivita_lavorativaId,
  autoId,
  aziendaId,
  badgeId,
  causale_centro_costoId,
  centro_costoId,
  centro_costo_visibilityId,
  commessaId,
  commissioneId,
  concorrente_software_featureId,
  constantsId,
  contatto_aziendaleId,
  dumpId,
  email_aziendaleId,
  entita_aziendaleId,
  est_licenzaId,
  est_piano_mantenimentoId,
  est_softwareId,
  est_stato_noleggioId,
  eventoId,
  evento_dumpId,
  evento_ticketId,
  fatturazione_interventoId,
  giorno_lavorativoId,
  gruppo_aziendaleId,
  info_impiegatoId,
  interventoId,
  nome_notoId,
  nota_ticketId,
  notificaId,
  offertaId,
  ordineId,
  pacchetto_utilizzoId,
  pacchetto_venditaId,
  partecipante_eventoId,
  personalizzazioneId,
  piattaforma_attivita_lavorativaId,
  piattaforma_ticketId,
  promemoriaId,
  promemoria_taskId,
  punto_fatturazione_ordineId,
  qs_applicazioneId,
  qs_licenzaId,
  qs_licenza_applicazioneId,
  qs_licenza_hotfixId,
  qs_licenza_updateId,
  qs_storico_licenzaId,
  qs_supporto_applicazioneId,
  qs_versioneId,
  rapportoId,
  repartoId,
  riunioneId,
  sedeId,
  software_concorrenteId,
  spesaId,
  stato_acconto_ordineId,
  stato_analisiId,
  stato_att_commId,
  stato_commessaId,
  stato_condivisioneId,
  stato_dumpId,
  stato_fatturazione_ordineId,
  stato_offertaId,
  stato_ordineId,
  stato_promemoria_taskId,
  stato_punto_fatturazioneId,
  stato_qs_licenzaId,
  stato_taskId,
  stato_ticketId,
  stato_ticket_messaggioId,
  storico_agenteId,
  storico_contatto_aziendaleId,
  taskId,
  telefonataId,
  template_offertaId,
  ticketId,
  ticket_corrispondenteId,
  ticket_messaggioId,
  tipologia_assistenzaId,
  tipologia_assistenza_telefonicaId,
  tipologia_attivita_commId,
  tipologia_corpo_nota_ticketId,
  tipologia_dumpId,
  tipologia_durata_pacchettoId,
  tipologia_evento_dumpId,
  tipologia_evento_ticketId,
  tipologia_nota_ticketId,
  tipologia_notificaId,
  tipologia_pagamentoId,
  tipologia_problemaId,
  tipologia_qs_licenzaId,
  tipologia_rapporto_aziendaId,
  tipologia_riunioneId,
  tipologia_spesaId,
  tipologia_ticketId,
  tipologia_ticket_messaggioId,
  userId,
  SecuredActionDescriptor,
  EditableSecuredActionDescriptor,
  SecuredActionDescriptorId,
  BaseObject,
  EditableBaseObject,
  PermissionPolicyUser,
  EditablePermissionPolicyUser,
  PermissionPolicyRoleBase,
  EditablePermissionPolicyRoleBase,
  PermissionPolicyRole,
  EditablePermissionPolicyRole,
  PermissionPolicyTypePermissionObject,
  EditablePermissionPolicyTypePermissionObject,
  PermissionPolicyMemberPermissionsObject,
  EditablePermissionPolicyMemberPermissionsObject,
  PermissionPolicyObjectPermissionsObject,
  EditablePermissionPolicyObjectPermissionsObject,
  PermissionPolicyNavigationPermissionObject,
  EditablePermissionPolicyNavigationPermissionObject,
  PermissionPolicyActionPermissionObject,
  EditablePermissionPolicyActionPermissionObject,
  ApplicationUser,
  EditableApplicationUser,
  user,
  Editableuser,
  reparto,
  Editablereparto,
  centro_costo_visibility,
  Editablecentro_costo_visibility,
  centro_costo,
  Editablecentro_costo,
  attivita_lavorativa,
  Editableattivita_lavorativa,
  piattaforma_attivita_lavorativa,
  Editablepiattaforma_attivita_lavorativa,
  causale_centro_costo,
  Editablecausale_centro_costo,
  task,
  Editabletask,
  ordine,
  Editableordine,
  stato_ordine,
  Editablestato_ordine,
  offerta,
  Editableofferta,
  stato_offerta,
  Editablestato_offerta,
  commessa,
  Editablecommessa,
  stato_commessa,
  Editablestato_commessa,
  sede,
  Editablesede,
  azienda,
  Editableazienda,
  agente,
  Editableagente,
  storico_agente,
  Editablestorico_agente,
  gruppo_aziendale,
  Editablegruppo_aziendale,
  tipologia_rapporto_azienda,
  Editabletipologia_rapporto_azienda,
  tipologia_pagamento,
  Editabletipologia_pagamento,
  nome_noto,
  Editablenome_noto,
  software_concorrente,
  Editablesoftware_concorrente,
  concorrente_software_feature,
  Editableconcorrente_software_feature,
  ad_csn,
  Editablead_csn,
  contatto_aziendale,
  Editablecontatto_aziendale,
  rapporto,
  Editablerapporto,
  analisi,
  Editableanalisi,
  stato_analisi,
  Editablestato_analisi,
  stato_condivisione,
  Editablestato_condivisione,
  pacchetto_vendita,
  Editablepacchetto_vendita,
  tipologia_durata_pacchetto,
  Editabletipologia_durata_pacchetto,
  pacchetto_utilizzo,
  Editablepacchetto_utilizzo,
  intervento,
  Editableintervento,
  fatturazione_intervento,
  Editablefatturazione_intervento,
  entita_aziendale,
  Editableentita_aziendale,
  email_aziendale,
  Editableemail_aziendale,
  ticket,
  Editableticket,
  tipologia_ticket,
  Editabletipologia_ticket,
  tipologia_problema,
  Editabletipologia_problema,
  argomento_problema,
  Editableargomento_problema,
  qs_supporto_applicazione,
  Editableqs_supporto_applicazione,
  piattaforma_ticket,
  Editablepiattaforma_ticket,
  stato_ticket,
  Editablestato_ticket,
  ticket_corrispondente,
  Editableticket_corrispondente,
  ticket_messaggio,
  Editableticket_messaggio,
  nota_ticket,
  Editablenota_ticket,
  tipologia_nota_ticket,
  Editabletipologia_nota_ticket,
  tipologia_corpo_nota_ticket,
  Editabletipologia_corpo_nota_ticket,
  tipologia_ticket_messaggio,
  Editabletipologia_ticket_messaggio,
  stato_ticket_messaggio,
  Editablestato_ticket_messaggio,
  dump,
  Editabledump,
  qs_licenza,
  Editableqs_licenza,
  qs_versione,
  Editableqs_versione,
  qs_storico_licenza,
  Editableqs_storico_licenza,
  qs_licenza_update,
  Editableqs_licenza_update,
  qs_licenza_hotfix,
  Editableqs_licenza_hotfix,
  stato_qs_licenza,
  Editablestato_qs_licenza,
  qs_licenza_applicazione,
  Editableqs_licenza_applicazione,
  tipologia_qs_licenza,
  Editabletipologia_qs_licenza,
  qs_applicazione,
  Editableqs_applicazione,
  stato_dump,
  Editablestato_dump,
  tipologia_dump,
  Editabletipologia_dump,
  evento_dump,
  Editableevento_dump,
  tipologia_evento_dump,
  Editabletipologia_evento_dump,
  evento_ticket,
  Editableevento_ticket,
  tipologia_evento_ticket,
  Editabletipologia_evento_ticket,
  personalizzazione,
  Editablepersonalizzazione,
  ad_quote,
  Editablead_quote,
  ad_subscription,
  Editablead_subscription,
  ad_quote_history,
  Editablead_quote_history,
  attivita_comm,
  Editableattivita_comm,
  tipologia_attivita_comm,
  Editabletipologia_attivita_comm,
  stato_att_comm,
  Editablestato_att_comm,
  evento,
  Editableevento,
  promemoria,
  Editablepromemoria,
  partecipante_evento,
  Editablepartecipante_evento,
  storico_contatto_aziendale,
  Editablestorico_contatto_aziendale,
  est_licenza,
  Editableest_licenza,
  est_software,
  Editableest_software,
  est_piano_mantenimento,
  Editableest_piano_mantenimento,
  est_stato_noleggio,
  Editableest_stato_noleggio,
  assistenza,
  Editableassistenza,
  tipologia_assistenza,
  Editabletipologia_assistenza,
  tipologia_assistenza_telefonica,
  Editabletipologia_assistenza_telefonica,
  template_offerta,
  Editabletemplate_offerta,
  stato_fatturazione_ordine,
  Editablestato_fatturazione_ordine,
  stato_acconto_ordine,
  Editablestato_acconto_ordine,
  punto_fatturazione_ordine,
  Editablepunto_fatturazione_ordine,
  stato_punto_fatturazione,
  Editablestato_punto_fatturazione,
  stato_task,
  Editablestato_task,
  promemoria_task,
  Editablepromemoria_task,
  stato_promemoria_task,
  Editablestato_promemoria_task,
  info_impiegato,
  Editableinfo_impiegato,
  auto,
  Editableauto,
  giorno_lavorativo,
  Editablegiorno_lavorativo,
  riunione,
  Editableriunione,
  tipologia_riunione,
  Editabletipologia_riunione,
  telefonata,
  Editabletelefonata,
  spesa,
  Editablespesa,
  tipologia_spesa,
  Editabletipologia_spesa,
  ApplicationUserLoginInfo,
  EditableApplicationUserLoginInfo,
  ad_incentivo,
  Editablead_incentivo,
  commissione,
  Editablecommissione,
  ad_percentuale,
  Editablead_percentuale,
  ad_product_catalog,
  Editablead_product_catalog,
  ad_promotion,
  Editablead_promotion,
  badge,
  Editablebadge,
  constants,
  Editableconstants,
  notifica,
  Editablenotifica,
  tipologia_notifica,
  Editabletipologia_notifica,
  ticket_attivo,
  Editableticket_attivo,
} from './QsAdminApiModuleModel'
import type {
  QSecuredActionDescriptor,
  QBaseObject,
  QPermissionPolicyUser,
  QPermissionPolicyRoleBase,
  QPermissionPolicyRole,
  QPermissionPolicyTypePermissionObject,
  QPermissionPolicyMemberPermissionsObject,
  QPermissionPolicyObjectPermissionsObject,
  QPermissionPolicyNavigationPermissionObject,
  QPermissionPolicyActionPermissionObject,
  QApplicationUser,
  Quser,
  Qreparto,
  Qcentro_costo_visibility,
  Qcentro_costo,
  Qattivita_lavorativa,
  Qpiattaforma_attivita_lavorativa,
  Qcausale_centro_costo,
  Qtask,
  Qordine,
  Qstato_ordine,
  Qofferta,
  Qstato_offerta,
  Qcommessa,
  Qstato_commessa,
  Qsede,
  Qazienda,
  Qagente,
  Qstorico_agente,
  Qgruppo_aziendale,
  Qtipologia_rapporto_azienda,
  Qtipologia_pagamento,
  Qnome_noto,
  Qsoftware_concorrente,
  Qconcorrente_software_feature,
  Qad_csn,
  Qcontatto_aziendale,
  Qrapporto,
  Qanalisi,
  Qstato_analisi,
  Qstato_condivisione,
  Qpacchetto_vendita,
  Qtipologia_durata_pacchetto,
  Qpacchetto_utilizzo,
  Qintervento,
  Qfatturazione_intervento,
  Qentita_aziendale,
  Qemail_aziendale,
  Qticket,
  Qtipologia_ticket,
  Qtipologia_problema,
  Qargomento_problema,
  Qqs_supporto_applicazione,
  Qpiattaforma_ticket,
  Qstato_ticket,
  Qticket_corrispondente,
  Qticket_messaggio,
  Qnota_ticket,
  Qtipologia_nota_ticket,
  Qtipologia_corpo_nota_ticket,
  Qtipologia_ticket_messaggio,
  Qstato_ticket_messaggio,
  Qdump,
  Qqs_licenza,
  Qqs_versione,
  Qqs_storico_licenza,
  Qqs_licenza_update,
  Qqs_licenza_hotfix,
  Qstato_qs_licenza,
  Qqs_licenza_applicazione,
  Qtipologia_qs_licenza,
  Qqs_applicazione,
  Qstato_dump,
  Qtipologia_dump,
  Qevento_dump,
  Qtipologia_evento_dump,
  Qevento_ticket,
  Qtipologia_evento_ticket,
  Qpersonalizzazione,
  Qad_quote,
  Qad_subscription,
  Qad_quote_history,
  Qattivita_comm,
  Qtipologia_attivita_comm,
  Qstato_att_comm,
  Qevento,
  Qpromemoria,
  Qpartecipante_evento,
  Qstorico_contatto_aziendale,
  Qest_licenza,
  Qest_software,
  Qest_piano_mantenimento,
  Qest_stato_noleggio,
  Qassistenza,
  Qtipologia_assistenza,
  Qtipologia_assistenza_telefonica,
  Qtemplate_offerta,
  Qstato_fatturazione_ordine,
  Qstato_acconto_ordine,
  Qpunto_fatturazione_ordine,
  Qstato_punto_fatturazione,
  Qstato_task,
  Qpromemoria_task,
  Qstato_promemoria_task,
  Qinfo_impiegato,
  Qauto,
  Qgiorno_lavorativo,
  Qriunione,
  Qtipologia_riunione,
  Qtelefonata,
  Qspesa,
  Qtipologia_spesa,
  QApplicationUserLoginInfo,
  Qad_incentivo,
  Qcommissione,
  Qad_percentuale,
  Qad_product_catalog,
  Qad_promotion,
  Qbadge,
  Qconstants,
  Qnotifica,
  Qtipologia_notifica,
  Qticket_attivo,
} from './QQsAdminApiModule'
import {
  QBaseObjectId,
  Qad_csnId,
  Qad_incentivoId,
  Qad_percentualeId,
  Qad_product_catalogId,
  Qad_promotionId,
  Qad_quoteId,
  Qad_quote_historyId,
  Qad_subscriptionId,
  QagenteId,
  QanalisiId,
  Qargomento_problemaId,
  QassistenzaId,
  Qattivita_commId,
  Qattivita_lavorativaId,
  QautoId,
  QaziendaId,
  QbadgeId,
  Qcausale_centro_costoId,
  Qcentro_costoId,
  Qcentro_costo_visibilityId,
  QcommessaId,
  QcommissioneId,
  Qconcorrente_software_featureId,
  QconstantsId,
  Qcontatto_aziendaleId,
  QdumpId,
  Qemail_aziendaleId,
  Qentita_aziendaleId,
  Qest_licenzaId,
  Qest_piano_mantenimentoId,
  Qest_softwareId,
  Qest_stato_noleggioId,
  QeventoId,
  Qevento_dumpId,
  Qevento_ticketId,
  Qfatturazione_interventoId,
  Qgiorno_lavorativoId,
  Qgruppo_aziendaleId,
  Qinfo_impiegatoId,
  QinterventoId,
  Qnome_notoId,
  Qnota_ticketId,
  QnotificaId,
  QoffertaId,
  QordineId,
  Qpacchetto_utilizzoId,
  Qpacchetto_venditaId,
  Qpartecipante_eventoId,
  QpersonalizzazioneId,
  Qpiattaforma_attivita_lavorativaId,
  Qpiattaforma_ticketId,
  QpromemoriaId,
  Qpromemoria_taskId,
  Qpunto_fatturazione_ordineId,
  Qqs_applicazioneId,
  Qqs_licenzaId,
  Qqs_licenza_applicazioneId,
  Qqs_licenza_hotfixId,
  Qqs_licenza_updateId,
  Qqs_storico_licenzaId,
  Qqs_supporto_applicazioneId,
  Qqs_versioneId,
  QrapportoId,
  QrepartoId,
  QriunioneId,
  QsedeId,
  Qsoftware_concorrenteId,
  QspesaId,
  Qstato_acconto_ordineId,
  Qstato_analisiId,
  Qstato_att_commId,
  Qstato_commessaId,
  Qstato_condivisioneId,
  Qstato_dumpId,
  Qstato_fatturazione_ordineId,
  Qstato_offertaId,
  Qstato_ordineId,
  Qstato_promemoria_taskId,
  Qstato_punto_fatturazioneId,
  Qstato_qs_licenzaId,
  Qstato_taskId,
  Qstato_ticketId,
  Qstato_ticket_messaggioId,
  Qstorico_agenteId,
  Qstorico_contatto_aziendaleId,
  QtaskId,
  QtelefonataId,
  Qtemplate_offertaId,
  QticketId,
  Qticket_corrispondenteId,
  Qticket_messaggioId,
  Qtipologia_assistenzaId,
  Qtipologia_assistenza_telefonicaId,
  Qtipologia_attivita_commId,
  Qtipologia_corpo_nota_ticketId,
  Qtipologia_dumpId,
  Qtipologia_durata_pacchettoId,
  Qtipologia_evento_dumpId,
  Qtipologia_evento_ticketId,
  Qtipologia_nota_ticketId,
  Qtipologia_notificaId,
  Qtipologia_pagamentoId,
  Qtipologia_problemaId,
  Qtipologia_qs_licenzaId,
  Qtipologia_rapporto_aziendaId,
  Qtipologia_riunioneId,
  Qtipologia_spesaId,
  Qtipologia_ticketId,
  Qtipologia_ticket_messaggioId,
  QuserId,
  qSecuredActionDescriptor,
  QSecuredActionDescriptorId,
  qBaseObject,
  qPermissionPolicyUser,
  qPermissionPolicyRoleBase,
  qPermissionPolicyRole,
  qPermissionPolicyTypePermissionObject,
  qPermissionPolicyMemberPermissionsObject,
  qPermissionPolicyObjectPermissionsObject,
  qPermissionPolicyNavigationPermissionObject,
  qPermissionPolicyActionPermissionObject,
  qApplicationUser,
  quser,
  qreparto,
  qcentro_costo_visibility,
  qcentro_costo,
  qattivita_lavorativa,
  qpiattaforma_attivita_lavorativa,
  qcausale_centro_costo,
  qtask,
  qordine,
  ordine_QProcessingOrder,
  ordine_QRestoreOrder,
  ordine_QCancelOrder,
  ordine_QRemoveAssignee,
  qstato_ordine,
  qofferta,
  offerta_QCreateDocument,
  qstato_offerta,
  qcommessa,
  qstato_commessa,
  qsede,
  qazienda,
  qagente,
  qstorico_agente,
  qgruppo_aziendale,
  qtipologia_rapporto_azienda,
  qtipologia_pagamento,
  qnome_noto,
  qsoftware_concorrente,
  qconcorrente_software_feature,
  qad_csn,
  qcontatto_aziendale,
  qrapporto,
  qanalisi,
  analisi_QCreateDocument,
  qstato_analisi,
  qstato_condivisione,
  qpacchetto_vendita,
  qtipologia_durata_pacchetto,
  qpacchetto_utilizzo,
  qintervento,
  qfatturazione_intervento,
  qentita_aziendale,
  qemail_aziendale,
  qticket,
  ticket_QRemoveAssignee,
  ticket_QSetUrgent,
  ticket_QSetWait,
  ticket_QClearWait,
  ticket_QIncrementCallNumber,
  ticket_QCancel,
  ticket_QTakeCharge,
  ticket_QRelease,
  ticket_QReopen,
  ticket_QSetActivityRequest,
  qtipologia_ticket,
  qtipologia_problema,
  qargomento_problema,
  qqs_supporto_applicazione,
  qpiattaforma_ticket,
  qstato_ticket,
  qticket_corrispondente,
  qticket_messaggio,
  qnota_ticket,
  qtipologia_nota_ticket,
  qtipologia_corpo_nota_ticket,
  qtipologia_ticket_messaggio,
  qstato_ticket_messaggio,
  qdump,
  qqs_licenza,
  qqs_versione,
  qqs_storico_licenza,
  qqs_licenza_update,
  qqs_licenza_hotfix,
  qstato_qs_licenza,
  qqs_licenza_applicazione,
  qtipologia_qs_licenza,
  qqs_applicazione,
  qstato_dump,
  qtipologia_dump,
  qevento_dump,
  qtipologia_evento_dump,
  qevento_ticket,
  qtipologia_evento_ticket,
  qpersonalizzazione,
  qad_quote,
  qad_subscription,
  qad_quote_history,
  qattivita_comm,
  qtipologia_attivita_comm,
  qstato_att_comm,
  qevento,
  qpromemoria,
  qpartecipante_evento,
  qstorico_contatto_aziendale,
  qest_licenza,
  qest_software,
  qest_piano_mantenimento,
  qest_stato_noleggio,
  qassistenza,
  qtipologia_assistenza,
  qtipologia_assistenza_telefonica,
  qtemplate_offerta,
  qstato_fatturazione_ordine,
  qstato_acconto_ordine,
  qpunto_fatturazione_ordine,
  qstato_punto_fatturazione,
  qstato_task,
  qpromemoria_task,
  qstato_promemoria_task,
  qinfo_impiegato,
  qauto,
  qgiorno_lavorativo,
  qriunione,
  riunione_QCreateDocument,
  qtipologia_riunione,
  qtelefonata,
  qspesa,
  qtipologia_spesa,
  qApplicationUserLoginInfo,
  qad_incentivo,
  qcommissione,
  qad_percentuale,
  qad_product_catalog,
  qad_promotion,
  qbadge,
  qconstants,
  qnotifica,
  qtipologia_notifica,
  qticket_attivo,
  ticket_attivo_QRemoveAssignee,
  ticket_attivo_QSetUrgent,
  ticket_attivo_QSetWait,
  ticket_attivo_QClearWait,
  ticket_attivo_QIncrementCallNumber,
  ticket_attivo_QCancel,
  ticket_attivo_QTakeCharge,
  ticket_attivo_QRelease,
  ticket_attivo_QReopen,
  ticket_attivo_QSetActivityRequest,
} from './QQsAdminApiModule'

export class QsAdminApiModuleService<in out ClientType extends ODataHttpClient> extends ODataService<ClientType> {
  public PermissionPolicyRole(): PermissionPolicyRoleCollectionService<ClientType>
  public PermissionPolicyRole(id: BaseObjectId): PermissionPolicyRoleService<ClientType>
  public PermissionPolicyRole(id?: BaseObjectId | undefined) {
    const fieldName = 'PermissionPolicyRole'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyRoleCollectionService(client, path, fieldName, options)
      : new PermissionPolicyRoleService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public PermissionPolicyTypePermissionObject(): PermissionPolicyTypePermissionObjectCollectionService<ClientType>
  public PermissionPolicyTypePermissionObject(id: BaseObjectId): PermissionPolicyTypePermissionObjectService<ClientType>
  public PermissionPolicyTypePermissionObject(id?: BaseObjectId | undefined) {
    const fieldName = 'PermissionPolicyTypePermissionObject'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyTypePermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyTypePermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public PermissionPolicyMemberPermissionsObject(): PermissionPolicyMemberPermissionsObjectCollectionService<ClientType>
  public PermissionPolicyMemberPermissionsObject(
    id: BaseObjectId,
  ): PermissionPolicyMemberPermissionsObjectService<ClientType>
  public PermissionPolicyMemberPermissionsObject(id?: BaseObjectId | undefined) {
    const fieldName = 'PermissionPolicyMemberPermissionsObject'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyMemberPermissionsObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyMemberPermissionsObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public PermissionPolicyObjectPermissionsObject(): PermissionPolicyObjectPermissionsObjectCollectionService<ClientType>
  public PermissionPolicyObjectPermissionsObject(
    id: BaseObjectId,
  ): PermissionPolicyObjectPermissionsObjectService<ClientType>
  public PermissionPolicyObjectPermissionsObject(id?: BaseObjectId | undefined) {
    const fieldName = 'PermissionPolicyObjectPermissionsObject'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyObjectPermissionsObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyObjectPermissionsObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public PermissionPolicyNavigationPermissionObject(): PermissionPolicyNavigationPermissionObjectCollectionService<ClientType>
  public PermissionPolicyNavigationPermissionObject(
    id: BaseObjectId,
  ): PermissionPolicyNavigationPermissionObjectService<ClientType>
  public PermissionPolicyNavigationPermissionObject(id?: BaseObjectId | undefined) {
    const fieldName = 'PermissionPolicyNavigationPermissionObject'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyNavigationPermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyNavigationPermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public PermissionPolicyActionPermissionObject(): PermissionPolicyActionPermissionObjectCollectionService<ClientType>
  public PermissionPolicyActionPermissionObject(
    id: BaseObjectId,
  ): PermissionPolicyActionPermissionObjectService<ClientType>
  public PermissionPolicyActionPermissionObject(id?: BaseObjectId | undefined) {
    const fieldName = 'PermissionPolicyActionPermissionObject'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyActionPermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyActionPermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ApplicationUser(): ApplicationUserCollectionService<ClientType>
  public ApplicationUser(id: BaseObjectId): ApplicationUserService<ClientType>
  public ApplicationUser(id?: BaseObjectId | undefined) {
    const fieldName = 'ApplicationUser'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ApplicationUserCollectionService(client, path, fieldName, options)
      : new ApplicationUserService(client, path, new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ApplicationUserLoginInfo(): ApplicationUserLoginInfoCollectionService<ClientType>
  public ApplicationUserLoginInfo(id: BaseObjectId): ApplicationUserLoginInfoService<ClientType>
  public ApplicationUserLoginInfo(id?: BaseObjectId | undefined) {
    const fieldName = 'ApplicationUserLoginInfo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ApplicationUserLoginInfoCollectionService(client, path, fieldName, options)
      : new ApplicationUserLoginInfoService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_csn(): ad_csnCollectionService<ClientType>
  public ad_csn(id: ad_csnId): ad_csnService<ClientType>
  public ad_csn(id?: ad_csnId | undefined) {
    const fieldName = 'ad_csn'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_csnCollectionService(client, path, fieldName, options)
      : new ad_csnService(client, path, new Qad_csnId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_incentivo(): ad_incentivoCollectionService<ClientType>
  public ad_incentivo(id: ad_incentivoId): ad_incentivoService<ClientType>
  public ad_incentivo(id?: ad_incentivoId | undefined) {
    const fieldName = 'ad_incentivo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_incentivoCollectionService(client, path, fieldName, options)
      : new ad_incentivoService(client, path, new Qad_incentivoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_percentuale(): ad_percentualeCollectionService<ClientType>
  public ad_percentuale(id: ad_percentualeId): ad_percentualeService<ClientType>
  public ad_percentuale(id?: ad_percentualeId | undefined) {
    const fieldName = 'ad_percentuale'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_percentualeCollectionService(client, path, fieldName, options)
      : new ad_percentualeService(
          client,
          path,
          new Qad_percentualeId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_product_catalog(): ad_product_catalogCollectionService<ClientType>
  public ad_product_catalog(id: ad_product_catalogId): ad_product_catalogService<ClientType>
  public ad_product_catalog(id?: ad_product_catalogId | undefined) {
    const fieldName = 'ad_product_catalog'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_product_catalogCollectionService(client, path, fieldName, options)
      : new ad_product_catalogService(
          client,
          path,
          new Qad_product_catalogId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_promotion(): ad_promotionCollectionService<ClientType>
  public ad_promotion(id: ad_promotionId): ad_promotionService<ClientType>
  public ad_promotion(id?: ad_promotionId | undefined) {
    const fieldName = 'ad_promotion'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_promotionCollectionService(client, path, fieldName, options)
      : new ad_promotionService(client, path, new Qad_promotionId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_quote(): ad_quoteCollectionService<ClientType>
  public ad_quote(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quote(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quote'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_quote_history(): ad_quote_historyCollectionService<ClientType>
  public ad_quote_history(id: ad_quote_historyId): ad_quote_historyService<ClientType>
  public ad_quote_history(id?: ad_quote_historyId | undefined) {
    const fieldName = 'ad_quote_history'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quote_historyCollectionService(client, path, fieldName, options)
      : new ad_quote_historyService(
          client,
          path,
          new Qad_quote_historyId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_subscription(): ad_subscriptionCollectionService<ClientType>
  public ad_subscription(id: ad_subscriptionId): ad_subscriptionService<ClientType>
  public ad_subscription(id?: ad_subscriptionId | undefined) {
    const fieldName = 'ad_subscription'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_subscriptionCollectionService(client, path, fieldName, options)
      : new ad_subscriptionService(
          client,
          path,
          new Qad_subscriptionId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public agente(): agenteCollectionService<ClientType>
  public agente(id: agenteId): agenteService<ClientType>
  public agente(id?: agenteId | undefined) {
    const fieldName = 'agente'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new agenteCollectionService(client, path, fieldName, options)
      : new agenteService(client, path, new QagenteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public analisi(): analisiCollectionService<ClientType>
  public analisi(id: analisiId): analisiService<ClientType>
  public analisi(id?: analisiId | undefined) {
    const fieldName = 'analisi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public argomento_problema(): argomento_problemaCollectionService<ClientType>
  public argomento_problema(id: argomento_problemaId): argomento_problemaService<ClientType>
  public argomento_problema(id?: argomento_problemaId | undefined) {
    const fieldName = 'argomento_problema'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new argomento_problemaCollectionService(client, path, fieldName, options)
      : new argomento_problemaService(
          client,
          path,
          new Qargomento_problemaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public assistenza(): assistenzaCollectionService<ClientType>
  public assistenza(id: assistenzaId): assistenzaService<ClientType>
  public assistenza(id?: assistenzaId | undefined) {
    const fieldName = 'assistenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new assistenzaCollectionService(client, path, fieldName, options)
      : new assistenzaService(client, path, new QassistenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public attivita_comm(): attivita_commCollectionService<ClientType>
  public attivita_comm(id: attivita_commId): attivita_commService<ClientType>
  public attivita_comm(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_comm'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public attivita_lavorativa(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorativa(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorativa(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorativa'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public auto(): autoCollectionService<ClientType>
  public auto(id: autoId): autoService<ClientType>
  public auto(id?: autoId | undefined) {
    const fieldName = 'auto'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new autoCollectionService(client, path, fieldName, options)
      : new autoService(client, path, new QautoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public azienda(): aziendaCollectionService<ClientType>
  public azienda(id: aziendaId): aziendaService<ClientType>
  public azienda(id?: aziendaId | undefined) {
    const fieldName = 'azienda'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new aziendaCollectionService(client, path, fieldName, options)
      : new aziendaService(client, path, new QaziendaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public badge(): badgeCollectionService<ClientType>
  public badge(id: badgeId): badgeService<ClientType>
  public badge(id?: badgeId | undefined) {
    const fieldName = 'badge'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new badgeCollectionService(client, path, fieldName, options)
      : new badgeService(client, path, new QbadgeId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public causale_centro_costo(): causale_centro_costoCollectionService<ClientType>
  public causale_centro_costo(id: causale_centro_costoId): causale_centro_costoService<ClientType>
  public causale_centro_costo(id?: causale_centro_costoId | undefined) {
    const fieldName = 'causale_centro_costo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new causale_centro_costoCollectionService(client, path, fieldName, options)
      : new causale_centro_costoService(
          client,
          path,
          new Qcausale_centro_costoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public centro_costo(): centro_costoCollectionService<ClientType>
  public centro_costo(id: centro_costoId): centro_costoService<ClientType>
  public centro_costo(id?: centro_costoId | undefined) {
    const fieldName = 'centro_costo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new centro_costoCollectionService(client, path, fieldName, options)
      : new centro_costoService(client, path, new Qcentro_costoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public centro_costo_visibility(): centro_costo_visibilityCollectionService<ClientType>
  public centro_costo_visibility(id: centro_costo_visibilityId): centro_costo_visibilityService<ClientType>
  public centro_costo_visibility(id?: centro_costo_visibilityId | undefined) {
    const fieldName = 'centro_costo_visibility'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new centro_costo_visibilityCollectionService(client, path, fieldName, options)
      : new centro_costo_visibilityService(
          client,
          path,
          new Qcentro_costo_visibilityId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public commessa(): commessaCollectionService<ClientType>
  public commessa(id: commessaId): commessaService<ClientType>
  public commessa(id?: commessaId | undefined) {
    const fieldName = 'commessa'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commessaCollectionService(client, path, fieldName, options)
      : new commessaService(client, path, new QcommessaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public commissione(): commissioneCollectionService<ClientType>
  public commissione(id: commissioneId): commissioneService<ClientType>
  public commissione(id?: commissioneId | undefined) {
    const fieldName = 'commissione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commissioneCollectionService(client, path, fieldName, options)
      : new commissioneService(client, path, new QcommissioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public concorrente_software_feature(): concorrente_software_featureCollectionService<ClientType>
  public concorrente_software_feature(
    id: concorrente_software_featureId,
  ): concorrente_software_featureService<ClientType>
  public concorrente_software_feature(id?: concorrente_software_featureId | undefined) {
    const fieldName = 'concorrente_software_feature'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new concorrente_software_featureCollectionService(client, path, fieldName, options)
      : new concorrente_software_featureService(
          client,
          path,
          new Qconcorrente_software_featureId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public constants(): constantsCollectionService<ClientType>
  public constants(id: constantsId): constantsService<ClientType>
  public constants(id?: constantsId | undefined) {
    const fieldName = 'constants'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new constantsCollectionService(client, path, fieldName, options)
      : new constantsService(client, path, new QconstantsId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public contatto_aziendale(): contatto_aziendaleCollectionService<ClientType>
  public contatto_aziendale(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public contatto_aziendale(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'contatto_aziendale'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public dump(): dumpCollectionService<ClientType>
  public dump(id: dumpId): dumpService<ClientType>
  public dump(id?: dumpId | undefined) {
    const fieldName = 'dump'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public email_aziendale(): email_aziendaleCollectionService<ClientType>
  public email_aziendale(id: email_aziendaleId): email_aziendaleService<ClientType>
  public email_aziendale(id?: email_aziendaleId | undefined) {
    const fieldName = 'email_aziendale'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new email_aziendaleCollectionService(client, path, fieldName, options)
      : new email_aziendaleService(
          client,
          path,
          new Qemail_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public entita_aziendale(): entita_aziendaleCollectionService<ClientType>
  public entita_aziendale(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public entita_aziendale(id?: entita_aziendaleId | undefined) {
    const fieldName = 'entita_aziendale'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public est_licenza(): est_licenzaCollectionService<ClientType>
  public est_licenza(id: est_licenzaId): est_licenzaService<ClientType>
  public est_licenza(id?: est_licenzaId | undefined) {
    const fieldName = 'est_licenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_licenzaCollectionService(client, path, fieldName, options)
      : new est_licenzaService(client, path, new Qest_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public est_piano_mantenimento(): est_piano_mantenimentoCollectionService<ClientType>
  public est_piano_mantenimento(id: est_piano_mantenimentoId): est_piano_mantenimentoService<ClientType>
  public est_piano_mantenimento(id?: est_piano_mantenimentoId | undefined) {
    const fieldName = 'est_piano_mantenimento'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_piano_mantenimentoCollectionService(client, path, fieldName, options)
      : new est_piano_mantenimentoService(
          client,
          path,
          new Qest_piano_mantenimentoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public est_software(): est_softwareCollectionService<ClientType>
  public est_software(id: est_softwareId): est_softwareService<ClientType>
  public est_software(id?: est_softwareId | undefined) {
    const fieldName = 'est_software'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_softwareCollectionService(client, path, fieldName, options)
      : new est_softwareService(client, path, new Qest_softwareId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public est_stato_noleggio(): est_stato_noleggioCollectionService<ClientType>
  public est_stato_noleggio(id: est_stato_noleggioId): est_stato_noleggioService<ClientType>
  public est_stato_noleggio(id?: est_stato_noleggioId | undefined) {
    const fieldName = 'est_stato_noleggio'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_stato_noleggioCollectionService(client, path, fieldName, options)
      : new est_stato_noleggioService(
          client,
          path,
          new Qest_stato_noleggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public evento(): eventoCollectionService<ClientType>
  public evento(id: eventoId): eventoService<ClientType>
  public evento(id?: eventoId | undefined) {
    const fieldName = 'evento'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new eventoCollectionService(client, path, fieldName, options)
      : new eventoService(client, path, new QeventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public evento_dump(): evento_dumpCollectionService<ClientType>
  public evento_dump(id: evento_dumpId): evento_dumpService<ClientType>
  public evento_dump(id?: evento_dumpId | undefined) {
    const fieldName = 'evento_dump'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_dumpCollectionService(client, path, fieldName, options)
      : new evento_dumpService(client, path, new Qevento_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public evento_ticket(): evento_ticketCollectionService<ClientType>
  public evento_ticket(id: evento_ticketId): evento_ticketService<ClientType>
  public evento_ticket(id?: evento_ticketId | undefined) {
    const fieldName = 'evento_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_ticketCollectionService(client, path, fieldName, options)
      : new evento_ticketService(client, path, new Qevento_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public fatturazione_intervento(): fatturazione_interventoCollectionService<ClientType>
  public fatturazione_intervento(id: fatturazione_interventoId): fatturazione_interventoService<ClientType>
  public fatturazione_intervento(id?: fatturazione_interventoId | undefined) {
    const fieldName = 'fatturazione_intervento'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new fatturazione_interventoCollectionService(client, path, fieldName, options)
      : new fatturazione_interventoService(
          client,
          path,
          new Qfatturazione_interventoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public giorno_lavorativo(): giorno_lavorativoCollectionService<ClientType>
  public giorno_lavorativo(id: giorno_lavorativoId): giorno_lavorativoService<ClientType>
  public giorno_lavorativo(id?: giorno_lavorativoId | undefined) {
    const fieldName = 'giorno_lavorativo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new giorno_lavorativoCollectionService(client, path, fieldName, options)
      : new giorno_lavorativoService(
          client,
          path,
          new Qgiorno_lavorativoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public gruppo_aziendale(): gruppo_aziendaleCollectionService<ClientType>
  public gruppo_aziendale(id: gruppo_aziendaleId): gruppo_aziendaleService<ClientType>
  public gruppo_aziendale(id?: gruppo_aziendaleId | undefined) {
    const fieldName = 'gruppo_aziendale'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new gruppo_aziendaleCollectionService(client, path, fieldName, options)
      : new gruppo_aziendaleService(
          client,
          path,
          new Qgruppo_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public info_impiegato(): info_impiegatoCollectionService<ClientType>
  public info_impiegato(id: info_impiegatoId): info_impiegatoService<ClientType>
  public info_impiegato(id?: info_impiegatoId | undefined) {
    const fieldName = 'info_impiegato'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new info_impiegatoCollectionService(client, path, fieldName, options)
      : new info_impiegatoService(
          client,
          path,
          new Qinfo_impiegatoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public intervento(): interventoCollectionService<ClientType>
  public intervento(id: interventoId): interventoService<ClientType>
  public intervento(id?: interventoId | undefined) {
    const fieldName = 'intervento'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new interventoCollectionService(client, path, fieldName, options)
      : new interventoService(client, path, new QinterventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public nome_noto(): nome_notoCollectionService<ClientType>
  public nome_noto(id: nome_notoId): nome_notoService<ClientType>
  public nome_noto(id?: nome_notoId | undefined) {
    const fieldName = 'nome_noto'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nome_notoCollectionService(client, path, fieldName, options)
      : new nome_notoService(client, path, new Qnome_notoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public nota_ticket(): nota_ticketCollectionService<ClientType>
  public nota_ticket(id: nota_ticketId): nota_ticketService<ClientType>
  public nota_ticket(id?: nota_ticketId | undefined) {
    const fieldName = 'nota_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nota_ticketCollectionService(client, path, fieldName, options)
      : new nota_ticketService(client, path, new Qnota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public notifica(): notificaCollectionService<ClientType>
  public notifica(id: notificaId): notificaService<ClientType>
  public notifica(id?: notificaId | undefined) {
    const fieldName = 'notifica'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new notificaCollectionService(client, path, fieldName, options)
      : new notificaService(client, path, new QnotificaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public offerta(): offertaCollectionService<ClientType>
  public offerta(id: offertaId): offertaService<ClientType>
  public offerta(id?: offertaId | undefined) {
    const fieldName = 'offerta'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ordine(): ordineCollectionService<ClientType>
  public ordine(id: ordineId): ordineService<ClientType>
  public ordine(id?: ordineId | undefined) {
    const fieldName = 'ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public pacchetto_utilizzo(): pacchetto_utilizzoCollectionService<ClientType>
  public pacchetto_utilizzo(id: pacchetto_utilizzoId): pacchetto_utilizzoService<ClientType>
  public pacchetto_utilizzo(id?: pacchetto_utilizzoId | undefined) {
    const fieldName = 'pacchetto_utilizzo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_utilizzoCollectionService(client, path, fieldName, options)
      : new pacchetto_utilizzoService(
          client,
          path,
          new Qpacchetto_utilizzoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public pacchetto_vendita(): pacchetto_venditaCollectionService<ClientType>
  public pacchetto_vendita(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetto_vendita(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetto_vendita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public partecipante_evento(): partecipante_eventoCollectionService<ClientType>
  public partecipante_evento(id: partecipante_eventoId): partecipante_eventoService<ClientType>
  public partecipante_evento(id?: partecipante_eventoId | undefined) {
    const fieldName = 'partecipante_evento'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new partecipante_eventoCollectionService(client, path, fieldName, options)
      : new partecipante_eventoService(
          client,
          path,
          new Qpartecipante_eventoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public personalizzazione(): personalizzazioneCollectionService<ClientType>
  public personalizzazione(id: personalizzazioneId): personalizzazioneService<ClientType>
  public personalizzazione(id?: personalizzazioneId | undefined) {
    const fieldName = 'personalizzazione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new personalizzazioneCollectionService(client, path, fieldName, options)
      : new personalizzazioneService(
          client,
          path,
          new QpersonalizzazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public piattaforma_attivita_lavorativa(): piattaforma_attivita_lavorativaCollectionService<ClientType>
  public piattaforma_attivita_lavorativa(
    id: piattaforma_attivita_lavorativaId,
  ): piattaforma_attivita_lavorativaService<ClientType>
  public piattaforma_attivita_lavorativa(id?: piattaforma_attivita_lavorativaId | undefined) {
    const fieldName = 'piattaforma_attivita_lavorativa'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new piattaforma_attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new piattaforma_attivita_lavorativaService(
          client,
          path,
          new Qpiattaforma_attivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public piattaforma_ticket(): piattaforma_ticketCollectionService<ClientType>
  public piattaforma_ticket(id: piattaforma_ticketId): piattaforma_ticketService<ClientType>
  public piattaforma_ticket(id?: piattaforma_ticketId | undefined) {
    const fieldName = 'piattaforma_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new piattaforma_ticketCollectionService(client, path, fieldName, options)
      : new piattaforma_ticketService(
          client,
          path,
          new Qpiattaforma_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public promemoria(): promemoriaCollectionService<ClientType>
  public promemoria(id: promemoriaId): promemoriaService<ClientType>
  public promemoria(id?: promemoriaId | undefined) {
    const fieldName = 'promemoria'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new promemoriaCollectionService(client, path, fieldName, options)
      : new promemoriaService(client, path, new QpromemoriaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public promemoria_task(): promemoria_taskCollectionService<ClientType>
  public promemoria_task(id: promemoria_taskId): promemoria_taskService<ClientType>
  public promemoria_task(id?: promemoria_taskId | undefined) {
    const fieldName = 'promemoria_task'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new promemoria_taskCollectionService(client, path, fieldName, options)
      : new promemoria_taskService(
          client,
          path,
          new Qpromemoria_taskId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public punto_fatturazione_ordine(): punto_fatturazione_ordineCollectionService<ClientType>
  public punto_fatturazione_ordine(id: punto_fatturazione_ordineId): punto_fatturazione_ordineService<ClientType>
  public punto_fatturazione_ordine(id?: punto_fatturazione_ordineId | undefined) {
    const fieldName = 'punto_fatturazione_ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new punto_fatturazione_ordineCollectionService(client, path, fieldName, options)
      : new punto_fatturazione_ordineService(
          client,
          path,
          new Qpunto_fatturazione_ordineId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_applicazione(): qs_applicazioneCollectionService<ClientType>
  public qs_applicazione(id: qs_applicazioneId): qs_applicazioneService<ClientType>
  public qs_applicazione(id?: qs_applicazioneId | undefined) {
    const fieldName = 'qs_applicazione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_applicazioneCollectionService(client, path, fieldName, options)
      : new qs_applicazioneService(
          client,
          path,
          new Qqs_applicazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_licenza(): qs_licenzaCollectionService<ClientType>
  public qs_licenza(id: qs_licenzaId): qs_licenzaService<ClientType>
  public qs_licenza(id?: qs_licenzaId | undefined) {
    const fieldName = 'qs_licenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenzaCollectionService(client, path, fieldName, options)
      : new qs_licenzaService(client, path, new Qqs_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public qs_licenza_applicazione(): qs_licenza_applicazioneCollectionService<ClientType>
  public qs_licenza_applicazione(id: qs_licenza_applicazioneId): qs_licenza_applicazioneService<ClientType>
  public qs_licenza_applicazione(id?: qs_licenza_applicazioneId | undefined) {
    const fieldName = 'qs_licenza_applicazione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_applicazioneCollectionService(client, path, fieldName, options)
      : new qs_licenza_applicazioneService(
          client,
          path,
          new Qqs_licenza_applicazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_licenza_hotfix(): qs_licenza_hotfixCollectionService<ClientType>
  public qs_licenza_hotfix(id: qs_licenza_hotfixId): qs_licenza_hotfixService<ClientType>
  public qs_licenza_hotfix(id?: qs_licenza_hotfixId | undefined) {
    const fieldName = 'qs_licenza_hotfix'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_hotfixCollectionService(client, path, fieldName, options)
      : new qs_licenza_hotfixService(
          client,
          path,
          new Qqs_licenza_hotfixId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_licenza_update(): qs_licenza_updateCollectionService<ClientType>
  public qs_licenza_update(id: qs_licenza_updateId): qs_licenza_updateService<ClientType>
  public qs_licenza_update(id?: qs_licenza_updateId | undefined) {
    const fieldName = 'qs_licenza_update'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_updateCollectionService(client, path, fieldName, options)
      : new qs_licenza_updateService(
          client,
          path,
          new Qqs_licenza_updateId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_storico_licenza(): qs_storico_licenzaCollectionService<ClientType>
  public qs_storico_licenza(id: qs_storico_licenzaId): qs_storico_licenzaService<ClientType>
  public qs_storico_licenza(id?: qs_storico_licenzaId | undefined) {
    const fieldName = 'qs_storico_licenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_storico_licenzaCollectionService(client, path, fieldName, options)
      : new qs_storico_licenzaService(
          client,
          path,
          new Qqs_storico_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_supporto_applicazione(): qs_supporto_applicazioneCollectionService<ClientType>
  public qs_supporto_applicazione(id: qs_supporto_applicazioneId): qs_supporto_applicazioneService<ClientType>
  public qs_supporto_applicazione(id?: qs_supporto_applicazioneId | undefined) {
    const fieldName = 'qs_supporto_applicazione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_supporto_applicazioneCollectionService(client, path, fieldName, options)
      : new qs_supporto_applicazioneService(
          client,
          path,
          new Qqs_supporto_applicazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_versione(): qs_versioneCollectionService<ClientType>
  public qs_versione(id: qs_versioneId): qs_versioneService<ClientType>
  public qs_versione(id?: qs_versioneId | undefined) {
    const fieldName = 'qs_versione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_versioneCollectionService(client, path, fieldName, options)
      : new qs_versioneService(client, path, new Qqs_versioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public rapporto(): rapportoCollectionService<ClientType>
  public rapporto(id: rapportoId): rapportoService<ClientType>
  public rapporto(id?: rapportoId | undefined) {
    const fieldName = 'rapporto'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new rapportoCollectionService(client, path, fieldName, options)
      : new rapportoService(client, path, new QrapportoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public reparto(): repartoCollectionService<ClientType>
  public reparto(id: repartoId): repartoService<ClientType>
  public reparto(id?: repartoId | undefined) {
    const fieldName = 'reparto'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new repartoCollectionService(client, path, fieldName, options)
      : new repartoService(client, path, new QrepartoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public riunione(): riunioneCollectionService<ClientType>
  public riunione(id: riunioneId): riunioneService<ClientType>
  public riunione(id?: riunioneId | undefined) {
    const fieldName = 'riunione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new riunioneCollectionService(client, path, fieldName, options)
      : new riunioneService(client, path, new QriunioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public sede(): sedeCollectionService<ClientType>
  public sede(id: sedeId): sedeService<ClientType>
  public sede(id?: sedeId | undefined) {
    const fieldName = 'sede'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new sedeCollectionService(client, path, fieldName, options)
      : new sedeService(client, path, new QsedeId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public software_concorrente(): software_concorrenteCollectionService<ClientType>
  public software_concorrente(id: software_concorrenteId): software_concorrenteService<ClientType>
  public software_concorrente(id?: software_concorrenteId | undefined) {
    const fieldName = 'software_concorrente'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new software_concorrenteCollectionService(client, path, fieldName, options)
      : new software_concorrenteService(
          client,
          path,
          new Qsoftware_concorrenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public spesa(): spesaCollectionService<ClientType>
  public spesa(id: spesaId): spesaService<ClientType>
  public spesa(id?: spesaId | undefined) {
    const fieldName = 'spesa'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new spesaCollectionService(client, path, fieldName, options)
      : new spesaService(client, path, new QspesaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_acconto_ordine(): stato_acconto_ordineCollectionService<ClientType>
  public stato_acconto_ordine(id: stato_acconto_ordineId): stato_acconto_ordineService<ClientType>
  public stato_acconto_ordine(id?: stato_acconto_ordineId | undefined) {
    const fieldName = 'stato_acconto_ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_acconto_ordineCollectionService(client, path, fieldName, options)
      : new stato_acconto_ordineService(
          client,
          path,
          new Qstato_acconto_ordineId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_analisi(): stato_analisiCollectionService<ClientType>
  public stato_analisi(id: stato_analisiId): stato_analisiService<ClientType>
  public stato_analisi(id?: stato_analisiId | undefined) {
    const fieldName = 'stato_analisi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_analisiCollectionService(client, path, fieldName, options)
      : new stato_analisiService(client, path, new Qstato_analisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_att_comm(): stato_att_commCollectionService<ClientType>
  public stato_att_comm(id: stato_att_commId): stato_att_commService<ClientType>
  public stato_att_comm(id?: stato_att_commId | undefined) {
    const fieldName = 'stato_att_comm'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_att_commCollectionService(client, path, fieldName, options)
      : new stato_att_commService(
          client,
          path,
          new Qstato_att_commId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_commessa(): stato_commessaCollectionService<ClientType>
  public stato_commessa(id: stato_commessaId): stato_commessaService<ClientType>
  public stato_commessa(id?: stato_commessaId | undefined) {
    const fieldName = 'stato_commessa'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_commessaCollectionService(client, path, fieldName, options)
      : new stato_commessaService(
          client,
          path,
          new Qstato_commessaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_condivisione(): stato_condivisioneCollectionService<ClientType>
  public stato_condivisione(id: stato_condivisioneId): stato_condivisioneService<ClientType>
  public stato_condivisione(id?: stato_condivisioneId | undefined) {
    const fieldName = 'stato_condivisione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_condivisioneCollectionService(client, path, fieldName, options)
      : new stato_condivisioneService(
          client,
          path,
          new Qstato_condivisioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_dump(): stato_dumpCollectionService<ClientType>
  public stato_dump(id: stato_dumpId): stato_dumpService<ClientType>
  public stato_dump(id?: stato_dumpId | undefined) {
    const fieldName = 'stato_dump'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_dumpCollectionService(client, path, fieldName, options)
      : new stato_dumpService(client, path, new Qstato_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_fatturazione_ordine(): stato_fatturazione_ordineCollectionService<ClientType>
  public stato_fatturazione_ordine(id: stato_fatturazione_ordineId): stato_fatturazione_ordineService<ClientType>
  public stato_fatturazione_ordine(id?: stato_fatturazione_ordineId | undefined) {
    const fieldName = 'stato_fatturazione_ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_fatturazione_ordineCollectionService(client, path, fieldName, options)
      : new stato_fatturazione_ordineService(
          client,
          path,
          new Qstato_fatturazione_ordineId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_offerta(): stato_offertaCollectionService<ClientType>
  public stato_offerta(id: stato_offertaId): stato_offertaService<ClientType>
  public stato_offerta(id?: stato_offertaId | undefined) {
    const fieldName = 'stato_offerta'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_offertaCollectionService(client, path, fieldName, options)
      : new stato_offertaService(client, path, new Qstato_offertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_ordine(): stato_ordineCollectionService<ClientType>
  public stato_ordine(id: stato_ordineId): stato_ordineService<ClientType>
  public stato_ordine(id?: stato_ordineId | undefined) {
    const fieldName = 'stato_ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_ordineCollectionService(client, path, fieldName, options)
      : new stato_ordineService(client, path, new Qstato_ordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_promemoria_task(): stato_promemoria_taskCollectionService<ClientType>
  public stato_promemoria_task(id: stato_promemoria_taskId): stato_promemoria_taskService<ClientType>
  public stato_promemoria_task(id?: stato_promemoria_taskId | undefined) {
    const fieldName = 'stato_promemoria_task'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_promemoria_taskCollectionService(client, path, fieldName, options)
      : new stato_promemoria_taskService(
          client,
          path,
          new Qstato_promemoria_taskId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_punto_fatturazione(): stato_punto_fatturazioneCollectionService<ClientType>
  public stato_punto_fatturazione(id: stato_punto_fatturazioneId): stato_punto_fatturazioneService<ClientType>
  public stato_punto_fatturazione(id?: stato_punto_fatturazioneId | undefined) {
    const fieldName = 'stato_punto_fatturazione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_punto_fatturazioneCollectionService(client, path, fieldName, options)
      : new stato_punto_fatturazioneService(
          client,
          path,
          new Qstato_punto_fatturazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_qs_licenza(): stato_qs_licenzaCollectionService<ClientType>
  public stato_qs_licenza(id: stato_qs_licenzaId): stato_qs_licenzaService<ClientType>
  public stato_qs_licenza(id?: stato_qs_licenzaId | undefined) {
    const fieldName = 'stato_qs_licenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_qs_licenzaCollectionService(client, path, fieldName, options)
      : new stato_qs_licenzaService(
          client,
          path,
          new Qstato_qs_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public stato_task(): stato_taskCollectionService<ClientType>
  public stato_task(id: stato_taskId): stato_taskService<ClientType>
  public stato_task(id?: stato_taskId | undefined) {
    const fieldName = 'stato_task'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_taskCollectionService(client, path, fieldName, options)
      : new stato_taskService(client, path, new Qstato_taskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_ticket(): stato_ticketCollectionService<ClientType>
  public stato_ticket(id: stato_ticketId): stato_ticketService<ClientType>
  public stato_ticket(id?: stato_ticketId | undefined) {
    const fieldName = 'stato_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_ticketCollectionService(client, path, fieldName, options)
      : new stato_ticketService(client, path, new Qstato_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public stato_ticket_messaggio(): stato_ticket_messaggioCollectionService<ClientType>
  public stato_ticket_messaggio(id: stato_ticket_messaggioId): stato_ticket_messaggioService<ClientType>
  public stato_ticket_messaggio(id?: stato_ticket_messaggioId | undefined) {
    const fieldName = 'stato_ticket_messaggio'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new stato_ticket_messaggioCollectionService(client, path, fieldName, options)
      : new stato_ticket_messaggioService(
          client,
          path,
          new Qstato_ticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public storico_agente(): storico_agenteCollectionService<ClientType>
  public storico_agente(id: storico_agenteId): storico_agenteService<ClientType>
  public storico_agente(id?: storico_agenteId | undefined) {
    const fieldName = 'storico_agente'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new storico_agenteCollectionService(client, path, fieldName, options)
      : new storico_agenteService(
          client,
          path,
          new Qstorico_agenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public storico_contatto_aziendale(): storico_contatto_aziendaleCollectionService<ClientType>
  public storico_contatto_aziendale(id: storico_contatto_aziendaleId): storico_contatto_aziendaleService<ClientType>
  public storico_contatto_aziendale(id?: storico_contatto_aziendaleId | undefined) {
    const fieldName = 'storico_contatto_aziendale'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new storico_contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new storico_contatto_aziendaleService(
          client,
          path,
          new Qstorico_contatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public task(): taskCollectionService<ClientType>
  public task(id: taskId): taskService<ClientType>
  public task(id?: taskId | undefined) {
    const fieldName = 'task'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public telefonata(): telefonataCollectionService<ClientType>
  public telefonata(id: telefonataId): telefonataService<ClientType>
  public telefonata(id?: telefonataId | undefined) {
    const fieldName = 'telefonata'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new telefonataCollectionService(client, path, fieldName, options)
      : new telefonataService(client, path, new QtelefonataId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public template_offerta(): template_offertaCollectionService<ClientType>
  public template_offerta(id: template_offertaId): template_offertaService<ClientType>
  public template_offerta(id?: template_offertaId | undefined) {
    const fieldName = 'template_offerta'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new template_offertaCollectionService(client, path, fieldName, options)
      : new template_offertaService(
          client,
          path,
          new Qtemplate_offertaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ticket(): ticketCollectionService<ClientType>
  public ticket(id: ticketId): ticketService<ClientType>
  public ticket(id?: ticketId | undefined) {
    const fieldName = 'ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ticket_attivo(): ticket_attivoCollectionService<ClientType>
  public ticket_attivo(id: ticketId): ticket_attivoService<ClientType>
  public ticket_attivo(id?: ticketId | undefined) {
    const fieldName = 'ticket_attivo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_attivoCollectionService(client, path, fieldName, options)
      : new ticket_attivoService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ticket_corrispondente(): ticket_corrispondenteCollectionService<ClientType>
  public ticket_corrispondente(id: ticket_corrispondenteId): ticket_corrispondenteService<ClientType>
  public ticket_corrispondente(id?: ticket_corrispondenteId | undefined) {
    const fieldName = 'ticket_corrispondente'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_corrispondenteCollectionService(client, path, fieldName, options)
      : new ticket_corrispondenteService(
          client,
          path,
          new Qticket_corrispondenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ticket_messaggio(): ticket_messaggioCollectionService<ClientType>
  public ticket_messaggio(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public ticket_messaggio(id?: ticket_messaggioId | undefined) {
    const fieldName = 'ticket_messaggio'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_assistenza(): tipologia_assistenzaCollectionService<ClientType>
  public tipologia_assistenza(id: tipologia_assistenzaId): tipologia_assistenzaService<ClientType>
  public tipologia_assistenza(id?: tipologia_assistenzaId | undefined) {
    const fieldName = 'tipologia_assistenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_assistenzaCollectionService(client, path, fieldName, options)
      : new tipologia_assistenzaService(
          client,
          path,
          new Qtipologia_assistenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_assistenza_telefonica(): tipologia_assistenza_telefonicaCollectionService<ClientType>
  public tipologia_assistenza_telefonica(
    id: tipologia_assistenza_telefonicaId,
  ): tipologia_assistenza_telefonicaService<ClientType>
  public tipologia_assistenza_telefonica(id?: tipologia_assistenza_telefonicaId | undefined) {
    const fieldName = 'tipologia_assistenza_telefonica'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_assistenza_telefonicaCollectionService(client, path, fieldName, options)
      : new tipologia_assistenza_telefonicaService(
          client,
          path,
          new Qtipologia_assistenza_telefonicaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_attivita_comm(): tipologia_attivita_commCollectionService<ClientType>
  public tipologia_attivita_comm(id: tipologia_attivita_commId): tipologia_attivita_commService<ClientType>
  public tipologia_attivita_comm(id?: tipologia_attivita_commId | undefined) {
    const fieldName = 'tipologia_attivita_comm'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_attivita_commCollectionService(client, path, fieldName, options)
      : new tipologia_attivita_commService(
          client,
          path,
          new Qtipologia_attivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_corpo_nota_ticket(): tipologia_corpo_nota_ticketCollectionService<ClientType>
  public tipologia_corpo_nota_ticket(id: tipologia_corpo_nota_ticketId): tipologia_corpo_nota_ticketService<ClientType>
  public tipologia_corpo_nota_ticket(id?: tipologia_corpo_nota_ticketId | undefined) {
    const fieldName = 'tipologia_corpo_nota_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_corpo_nota_ticketCollectionService(client, path, fieldName, options)
      : new tipologia_corpo_nota_ticketService(
          client,
          path,
          new Qtipologia_corpo_nota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_dump(): tipologia_dumpCollectionService<ClientType>
  public tipologia_dump(id: tipologia_dumpId): tipologia_dumpService<ClientType>
  public tipologia_dump(id?: tipologia_dumpId | undefined) {
    const fieldName = 'tipologia_dump'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_dumpCollectionService(client, path, fieldName, options)
      : new tipologia_dumpService(
          client,
          path,
          new Qtipologia_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_durata_pacchetto(): tipologia_durata_pacchettoCollectionService<ClientType>
  public tipologia_durata_pacchetto(id: tipologia_durata_pacchettoId): tipologia_durata_pacchettoService<ClientType>
  public tipologia_durata_pacchetto(id?: tipologia_durata_pacchettoId | undefined) {
    const fieldName = 'tipologia_durata_pacchetto'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_durata_pacchettoCollectionService(client, path, fieldName, options)
      : new tipologia_durata_pacchettoService(
          client,
          path,
          new Qtipologia_durata_pacchettoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_evento_dump(): tipologia_evento_dumpCollectionService<ClientType>
  public tipologia_evento_dump(id: tipologia_evento_dumpId): tipologia_evento_dumpService<ClientType>
  public tipologia_evento_dump(id?: tipologia_evento_dumpId | undefined) {
    const fieldName = 'tipologia_evento_dump'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_evento_dumpCollectionService(client, path, fieldName, options)
      : new tipologia_evento_dumpService(
          client,
          path,
          new Qtipologia_evento_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_evento_ticket(): tipologia_evento_ticketCollectionService<ClientType>
  public tipologia_evento_ticket(id: tipologia_evento_ticketId): tipologia_evento_ticketService<ClientType>
  public tipologia_evento_ticket(id?: tipologia_evento_ticketId | undefined) {
    const fieldName = 'tipologia_evento_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_evento_ticketCollectionService(client, path, fieldName, options)
      : new tipologia_evento_ticketService(
          client,
          path,
          new Qtipologia_evento_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_nota_ticket(): tipologia_nota_ticketCollectionService<ClientType>
  public tipologia_nota_ticket(id: tipologia_nota_ticketId): tipologia_nota_ticketService<ClientType>
  public tipologia_nota_ticket(id?: tipologia_nota_ticketId | undefined) {
    const fieldName = 'tipologia_nota_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_nota_ticketCollectionService(client, path, fieldName, options)
      : new tipologia_nota_ticketService(
          client,
          path,
          new Qtipologia_nota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_notifica(): tipologia_notificaCollectionService<ClientType>
  public tipologia_notifica(id: tipologia_notificaId): tipologia_notificaService<ClientType>
  public tipologia_notifica(id?: tipologia_notificaId | undefined) {
    const fieldName = 'tipologia_notifica'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_notificaCollectionService(client, path, fieldName, options)
      : new tipologia_notificaService(
          client,
          path,
          new Qtipologia_notificaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_pagamento(): tipologia_pagamentoCollectionService<ClientType>
  public tipologia_pagamento(id: tipologia_pagamentoId): tipologia_pagamentoService<ClientType>
  public tipologia_pagamento(id?: tipologia_pagamentoId | undefined) {
    const fieldName = 'tipologia_pagamento'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_pagamentoCollectionService(client, path, fieldName, options)
      : new tipologia_pagamentoService(
          client,
          path,
          new Qtipologia_pagamentoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_problema(): tipologia_problemaCollectionService<ClientType>
  public tipologia_problema(id: tipologia_problemaId): tipologia_problemaService<ClientType>
  public tipologia_problema(id?: tipologia_problemaId | undefined) {
    const fieldName = 'tipologia_problema'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_problemaCollectionService(client, path, fieldName, options)
      : new tipologia_problemaService(
          client,
          path,
          new Qtipologia_problemaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_qs_licenza(): tipologia_qs_licenzaCollectionService<ClientType>
  public tipologia_qs_licenza(id: tipologia_qs_licenzaId): tipologia_qs_licenzaService<ClientType>
  public tipologia_qs_licenza(id?: tipologia_qs_licenzaId | undefined) {
    const fieldName = 'tipologia_qs_licenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_qs_licenzaCollectionService(client, path, fieldName, options)
      : new tipologia_qs_licenzaService(
          client,
          path,
          new Qtipologia_qs_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_rapporto_azienda(): tipologia_rapporto_aziendaCollectionService<ClientType>
  public tipologia_rapporto_azienda(id: tipologia_rapporto_aziendaId): tipologia_rapporto_aziendaService<ClientType>
  public tipologia_rapporto_azienda(id?: tipologia_rapporto_aziendaId | undefined) {
    const fieldName = 'tipologia_rapporto_azienda'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_rapporto_aziendaCollectionService(client, path, fieldName, options)
      : new tipologia_rapporto_aziendaService(
          client,
          path,
          new Qtipologia_rapporto_aziendaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_riunione(): tipologia_riunioneCollectionService<ClientType>
  public tipologia_riunione(id: tipologia_riunioneId): tipologia_riunioneService<ClientType>
  public tipologia_riunione(id?: tipologia_riunioneId | undefined) {
    const fieldName = 'tipologia_riunione'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_riunioneCollectionService(client, path, fieldName, options)
      : new tipologia_riunioneService(
          client,
          path,
          new Qtipologia_riunioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_spesa(): tipologia_spesaCollectionService<ClientType>
  public tipologia_spesa(id: tipologia_spesaId): tipologia_spesaService<ClientType>
  public tipologia_spesa(id?: tipologia_spesaId | undefined) {
    const fieldName = 'tipologia_spesa'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_spesaCollectionService(client, path, fieldName, options)
      : new tipologia_spesaService(
          client,
          path,
          new Qtipologia_spesaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_ticket(): tipologia_ticketCollectionService<ClientType>
  public tipologia_ticket(id: tipologia_ticketId): tipologia_ticketService<ClientType>
  public tipologia_ticket(id?: tipologia_ticketId | undefined) {
    const fieldName = 'tipologia_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_ticketCollectionService(client, path, fieldName, options)
      : new tipologia_ticketService(
          client,
          path,
          new Qtipologia_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tipologia_ticket_messaggio(): tipologia_ticket_messaggioCollectionService<ClientType>
  public tipologia_ticket_messaggio(id: tipologia_ticket_messaggioId): tipologia_ticket_messaggioService<ClientType>
  public tipologia_ticket_messaggio(id?: tipologia_ticket_messaggioId | undefined) {
    const fieldName = 'tipologia_ticket_messaggio'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_ticket_messaggioCollectionService(client, path, fieldName, options)
      : new tipologia_ticket_messaggioService(
          client,
          path,
          new Qtipologia_ticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public user(): userCollectionService<ClientType>
  public user(id: userId): userService<ClientType>
  public user(id?: userId | undefined) {
    const fieldName = 'user'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class SecuredActionDescriptorService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  SecuredActionDescriptor,
  EditableSecuredActionDescriptor,
  QSecuredActionDescriptor
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qSecuredActionDescriptor, options)
  }
}

export class SecuredActionDescriptorCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  SecuredActionDescriptor,
  EditableSecuredActionDescriptor,
  QSecuredActionDescriptor,
  SecuredActionDescriptorId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qSecuredActionDescriptor, new QSecuredActionDescriptorId(name), options)
  }
}

export class BaseObjectService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  BaseObject,
  EditableBaseObject,
  QBaseObject
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qBaseObject, options)
  }

  public asPermissionPolicyUserService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyUserService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyUser',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyRoleBaseService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyRoleBaseService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyRoleBase',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyRoleService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyRoleService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyRole',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyTypePermissionObjectService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyTypePermissionObjectService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyTypePermissionObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyMemberPermissionsObjectService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyMemberPermissionsObjectService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyMemberPermissionsObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyObjectPermissionsObjectService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyObjectPermissionsObjectService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyObjectPermissionsObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyNavigationPermissionObjectService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyNavigationPermissionObjectService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyNavigationPermissionObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyActionPermissionObjectService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyActionPermissionObjectService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyActionPermissionObject',
      { ...options, subtype: true },
    )
  }

  public asApplicationUserService() {
    const { client, path, options } = this.__base
    return new ApplicationUserService(client, path, 'QsAdminApi.WebApi.Model.ApplicationUser', {
      ...options,
      subtype: true,
    })
  }

  public asApplicationUserLoginInfoService() {
    const { client, path, options } = this.__base
    return new ApplicationUserLoginInfoService(client, path, 'QsAdminApi.WebApi.Model.ApplicationUserLoginInfo', {
      ...options,
      subtype: true,
    })
  }
}

export class BaseObjectCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  BaseObject,
  EditableBaseObject,
  QBaseObject,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qBaseObject, new QBaseObjectId(name), options)
  }

  public asPermissionPolicyUserCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyUserCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyUser',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyRoleBaseCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyRoleBaseCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyRoleBase',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyRoleCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyRoleCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyRole',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyTypePermissionObjectCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyTypePermissionObjectCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyTypePermissionObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyMemberPermissionsObjectCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyMemberPermissionsObjectCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyMemberPermissionsObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyObjectPermissionsObjectCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyObjectPermissionsObjectCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyObjectPermissionsObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyNavigationPermissionObjectCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyNavigationPermissionObjectCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyNavigationPermissionObject',
      { ...options, subtype: true },
    )
  }

  public asPermissionPolicyActionPermissionObjectCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyActionPermissionObjectCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyActionPermissionObject',
      { ...options, subtype: true },
    )
  }

  public asApplicationUserCollectionService() {
    const { client, path, options } = this.__base
    return new ApplicationUserCollectionService(client, path, 'QsAdminApi.WebApi.Model.ApplicationUser', {
      ...options,
      subtype: true,
    })
  }

  public asApplicationUserLoginInfoCollectionService() {
    const { client, path, options } = this.__base
    return new ApplicationUserLoginInfoCollectionService(
      client,
      path,
      'QsAdminApi.WebApi.Model.ApplicationUserLoginInfo',
      { ...options, subtype: true },
    )
  }
}

export class PermissionPolicyUserService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyUser,
  EditablePermissionPolicyUser,
  QPermissionPolicyUser
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyUser, options)
  }

  public Roles(): PermissionPolicyRoleCollectionService<ClientType>
  public Roles(id: BaseObjectId): PermissionPolicyRoleService<ClientType>
  public Roles(id?: BaseObjectId | undefined) {
    const fieldName = 'Roles'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyRoleCollectionService(client, path, fieldName, options)
      : new PermissionPolicyRoleService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public asApplicationUserService() {
    const { client, path, options } = this.__base
    return new ApplicationUserService(client, path, 'QsAdminApi.WebApi.Model.ApplicationUser', {
      ...options,
      subtype: true,
    })
  }
}

export class PermissionPolicyUserCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyUser,
  EditablePermissionPolicyUser,
  QPermissionPolicyUser,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyUser, new QBaseObjectId(name), options)
  }

  public asApplicationUserCollectionService() {
    const { client, path, options } = this.__base
    return new ApplicationUserCollectionService(client, path, 'QsAdminApi.WebApi.Model.ApplicationUser', {
      ...options,
      subtype: true,
    })
  }
}

export class PermissionPolicyRoleBaseService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyRoleBase,
  EditablePermissionPolicyRoleBase,
  QPermissionPolicyRoleBase
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyRoleBase, options)
  }

  public TypePermissions(): PermissionPolicyTypePermissionObjectCollectionService<ClientType>
  public TypePermissions(id: BaseObjectId): PermissionPolicyTypePermissionObjectService<ClientType>
  public TypePermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'TypePermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyTypePermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyTypePermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public NavigationPermissions(): PermissionPolicyNavigationPermissionObjectCollectionService<ClientType>
  public NavigationPermissions(id: BaseObjectId): PermissionPolicyNavigationPermissionObjectService<ClientType>
  public NavigationPermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'NavigationPermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyNavigationPermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyNavigationPermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ActionPermissions(): PermissionPolicyActionPermissionObjectCollectionService<ClientType>
  public ActionPermissions(id: BaseObjectId): PermissionPolicyActionPermissionObjectService<ClientType>
  public ActionPermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'ActionPermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyActionPermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyActionPermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public asPermissionPolicyRoleService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyRoleService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyRole',
      { ...options, subtype: true },
    )
  }
}

export class PermissionPolicyRoleBaseCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyRoleBase,
  EditablePermissionPolicyRoleBase,
  QPermissionPolicyRoleBase,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyRoleBase, new QBaseObjectId(name), options)
  }

  public asPermissionPolicyRoleCollectionService() {
    const { client, path, options } = this.__base
    return new PermissionPolicyRoleCollectionService(
      client,
      path,
      'DevExpress.Persistent.BaseImpl.PermissionPolicy.PermissionPolicyRole',
      { ...options, subtype: true },
    )
  }
}

export class PermissionPolicyRoleService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyRole,
  EditablePermissionPolicyRole,
  QPermissionPolicyRole
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyRole, options)
  }

  public TypePermissions(): PermissionPolicyTypePermissionObjectCollectionService<ClientType>
  public TypePermissions(id: BaseObjectId): PermissionPolicyTypePermissionObjectService<ClientType>
  public TypePermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'TypePermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyTypePermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyTypePermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public NavigationPermissions(): PermissionPolicyNavigationPermissionObjectCollectionService<ClientType>
  public NavigationPermissions(id: BaseObjectId): PermissionPolicyNavigationPermissionObjectService<ClientType>
  public NavigationPermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'NavigationPermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyNavigationPermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyNavigationPermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ActionPermissions(): PermissionPolicyActionPermissionObjectCollectionService<ClientType>
  public ActionPermissions(id: BaseObjectId): PermissionPolicyActionPermissionObjectService<ClientType>
  public ActionPermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'ActionPermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyActionPermissionObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyActionPermissionObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public Users(): PermissionPolicyUserCollectionService<ClientType>
  public Users(id: BaseObjectId): PermissionPolicyUserService<ClientType>
  public Users(id?: BaseObjectId | undefined) {
    const fieldName = 'Users'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyUserCollectionService(client, path, fieldName, options)
      : new PermissionPolicyUserService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class PermissionPolicyRoleCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyRole,
  EditablePermissionPolicyRole,
  QPermissionPolicyRole,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyRole, new QBaseObjectId(name), options)
  }
}

export class PermissionPolicyTypePermissionObjectService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyTypePermissionObject,
  EditablePermissionPolicyTypePermissionObject,
  QPermissionPolicyTypePermissionObject
> {
  private _Role?: PermissionPolicyRoleBaseService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyTypePermissionObject, options)
  }

  public Role(): PermissionPolicyRoleBaseService<ClientType> {
    if (!this._Role) {
      const { client, path, options } = this.__base
      this._Role = new PermissionPolicyRoleBaseService(client, path, 'Role', options)
    }

    return this._Role
  }

  public MemberPermissions(): PermissionPolicyMemberPermissionsObjectCollectionService<ClientType>
  public MemberPermissions(id: BaseObjectId): PermissionPolicyMemberPermissionsObjectService<ClientType>
  public MemberPermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'MemberPermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyMemberPermissionsObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyMemberPermissionsObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ObjectPermissions(): PermissionPolicyObjectPermissionsObjectCollectionService<ClientType>
  public ObjectPermissions(id: BaseObjectId): PermissionPolicyObjectPermissionsObjectService<ClientType>
  public ObjectPermissions(id?: BaseObjectId | undefined) {
    const fieldName = 'ObjectPermissions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyObjectPermissionsObjectCollectionService(client, path, fieldName, options)
      : new PermissionPolicyObjectPermissionsObjectService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class PermissionPolicyTypePermissionObjectCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyTypePermissionObject,
  EditablePermissionPolicyTypePermissionObject,
  QPermissionPolicyTypePermissionObject,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyTypePermissionObject, new QBaseObjectId(name), options)
  }
}

export class PermissionPolicyMemberPermissionsObjectService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyMemberPermissionsObject,
  EditablePermissionPolicyMemberPermissionsObject,
  QPermissionPolicyMemberPermissionsObject
> {
  private _TypePermissionObject?: PermissionPolicyTypePermissionObjectService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyMemberPermissionsObject, options)
  }

  public TypePermissionObject(): PermissionPolicyTypePermissionObjectService<ClientType> {
    if (!this._TypePermissionObject) {
      const { client, path, options } = this.__base
      this._TypePermissionObject = new PermissionPolicyTypePermissionObjectService(
        client,
        path,
        'TypePermissionObject',
        options,
      )
    }

    return this._TypePermissionObject
  }
}

export class PermissionPolicyMemberPermissionsObjectCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyMemberPermissionsObject,
  EditablePermissionPolicyMemberPermissionsObject,
  QPermissionPolicyMemberPermissionsObject,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyMemberPermissionsObject, new QBaseObjectId(name), options)
  }
}

export class PermissionPolicyObjectPermissionsObjectService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyObjectPermissionsObject,
  EditablePermissionPolicyObjectPermissionsObject,
  QPermissionPolicyObjectPermissionsObject
> {
  private _TypePermissionObject?: PermissionPolicyTypePermissionObjectService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyObjectPermissionsObject, options)
  }

  public TypePermissionObject(): PermissionPolicyTypePermissionObjectService<ClientType> {
    if (!this._TypePermissionObject) {
      const { client, path, options } = this.__base
      this._TypePermissionObject = new PermissionPolicyTypePermissionObjectService(
        client,
        path,
        'TypePermissionObject',
        options,
      )
    }

    return this._TypePermissionObject
  }
}

export class PermissionPolicyObjectPermissionsObjectCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyObjectPermissionsObject,
  EditablePermissionPolicyObjectPermissionsObject,
  QPermissionPolicyObjectPermissionsObject,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyObjectPermissionsObject, new QBaseObjectId(name), options)
  }
}

export class PermissionPolicyNavigationPermissionObjectService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyNavigationPermissionObject,
  EditablePermissionPolicyNavigationPermissionObject,
  QPermissionPolicyNavigationPermissionObject
> {
  private _Role?: PermissionPolicyRoleBaseService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyNavigationPermissionObject, options)
  }

  public Role(): PermissionPolicyRoleBaseService<ClientType> {
    if (!this._Role) {
      const { client, path, options } = this.__base
      this._Role = new PermissionPolicyRoleBaseService(client, path, 'Role', options)
    }

    return this._Role
  }
}

export class PermissionPolicyNavigationPermissionObjectCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyNavigationPermissionObject,
  EditablePermissionPolicyNavigationPermissionObject,
  QPermissionPolicyNavigationPermissionObject,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyNavigationPermissionObject, new QBaseObjectId(name), options)
  }
}

export class PermissionPolicyActionPermissionObjectService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  PermissionPolicyActionPermissionObject,
  EditablePermissionPolicyActionPermissionObject,
  QPermissionPolicyActionPermissionObject
> {
  private _ActionDescriptor?: SecuredActionDescriptorService<ClientType>
  private _Role?: PermissionPolicyRoleBaseService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyActionPermissionObject, options)
  }

  public ActionDescriptor(): SecuredActionDescriptorService<ClientType> {
    if (!this._ActionDescriptor) {
      const { client, path, options } = this.__base
      this._ActionDescriptor = new SecuredActionDescriptorService(client, path, 'ActionDescriptor', options)
    }

    return this._ActionDescriptor
  }

  public SecuredActionDescriptors(): SecuredActionDescriptorCollectionService<ClientType>
  public SecuredActionDescriptors(id: SecuredActionDescriptorId): SecuredActionDescriptorService<ClientType>
  public SecuredActionDescriptors(id?: SecuredActionDescriptorId | undefined) {
    const fieldName = 'SecuredActionDescriptors'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new SecuredActionDescriptorCollectionService(client, path, fieldName, options)
      : new SecuredActionDescriptorService(
          client,
          path,
          new QSecuredActionDescriptorId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public Role(): PermissionPolicyRoleBaseService<ClientType> {
    if (!this._Role) {
      const { client, path, options } = this.__base
      this._Role = new PermissionPolicyRoleBaseService(client, path, 'Role', options)
    }

    return this._Role
  }
}

export class PermissionPolicyActionPermissionObjectCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  PermissionPolicyActionPermissionObject,
  EditablePermissionPolicyActionPermissionObject,
  QPermissionPolicyActionPermissionObject,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qPermissionPolicyActionPermissionObject, new QBaseObjectId(name), options)
  }
}

export class ApplicationUserService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ApplicationUser,
  EditableApplicationUser,
  QApplicationUser
> {
  private _userData?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qApplicationUser, options)
  }

  public Roles(): PermissionPolicyRoleCollectionService<ClientType>
  public Roles(id: BaseObjectId): PermissionPolicyRoleService<ClientType>
  public Roles(id?: BaseObjectId | undefined) {
    const fieldName = 'Roles'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new PermissionPolicyRoleCollectionService(client, path, fieldName, options)
      : new PermissionPolicyRoleService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public userData(): userService<ClientType> {
    if (!this._userData) {
      const { client, path, options } = this.__base
      this._userData = new userService(client, path, 'userData', options)
    }

    return this._userData
  }

  public LoginInfo(): ApplicationUserLoginInfoCollectionService<ClientType>
  public LoginInfo(id: BaseObjectId): ApplicationUserLoginInfoService<ClientType>
  public LoginInfo(id?: BaseObjectId | undefined) {
    const fieldName = 'LoginInfo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ApplicationUserLoginInfoCollectionService(client, path, fieldName, options)
      : new ApplicationUserLoginInfoService(
          client,
          path,
          new QBaseObjectId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class ApplicationUserCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ApplicationUser,
  EditableApplicationUser,
  QApplicationUser,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qApplicationUser, new QBaseObjectId(name), options)
  }
}

export class userService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  user,
  Editableuser,
  Quser
> {
  private _applicationUser?: ApplicationUserService<ClientType>
  private _reparto?: repartoService<ClientType>
  private _info?: info_impiegatoService<ClientType>
  private _azienda?: aziendaService<ClientType>
  private _manager?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, quser, options)
  }

  public applicationUser(): ApplicationUserService<ClientType> {
    if (!this._applicationUser) {
      const { client, path, options } = this.__base
      this._applicationUser = new ApplicationUserService(client, path, 'applicationUser', options)
    }

    return this._applicationUser
  }

  public reparto(): repartoService<ClientType> {
    if (!this._reparto) {
      const { client, path, options } = this.__base
      this._reparto = new repartoService(client, path, 'reparto', options)
    }

    return this._reparto
  }

  public info(): info_impiegatoService<ClientType> {
    if (!this._info) {
      const { client, path, options } = this.__base
      this._info = new info_impiegatoService(client, path, 'info', options)
    }

    return this._info
  }

  public azienda(): aziendaService<ClientType> {
    if (!this._azienda) {
      const { client, path, options } = this.__base
      this._azienda = new aziendaService(client, path, 'azienda', options)
    }

    return this._azienda
  }

  public manager(): userService<ClientType> {
    if (!this._manager) {
      const { client, path, options } = this.__base
      this._manager = new userService(client, path, 'manager', options)
    }

    return this._manager
  }

  public analisi_tecnico_ausiliario(): analisiCollectionService<ClientType>
  public analisi_tecnico_ausiliario(id: analisiId): analisiService<ClientType>
  public analisi_tecnico_ausiliario(id?: analisiId | undefined) {
    const fieldName = 'analisi_tecnico_ausiliario'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public interventi(): interventoCollectionService<ClientType>
  public interventi(id: interventoId): interventoService<ClientType>
  public interventi(id?: interventoId | undefined) {
    const fieldName = 'interventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new interventoCollectionService(client, path, fieldName, options)
      : new interventoService(client, path, new QinterventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public riunioni_assistite(): riunioneCollectionService<ClientType>
  public riunioni_assistite(id: riunioneId): riunioneService<ClientType>
  public riunioni_assistite(id?: riunioneId | undefined) {
    const fieldName = 'riunioni_assistite'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new riunioneCollectionService(client, path, fieldName, options)
      : new riunioneService(client, path, new QriunioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public tasks_tecnico(): taskCollectionService<ClientType>
  public tasks_tecnico(id: taskId): taskService<ClientType>
  public tasks_tecnico(id?: taskId | undefined) {
    const fieldName = 'tasks_tecnico'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public personalizzazioni(): personalizzazioneCollectionService<ClientType>
  public personalizzazioni(id: personalizzazioneId): personalizzazioneService<ClientType>
  public personalizzazioni(id?: personalizzazioneId | undefined) {
    const fieldName = 'personalizzazioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new personalizzazioneCollectionService(client, path, fieldName, options)
      : new personalizzazioneService(
          client,
          path,
          new QpersonalizzazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public eventi(): eventoCollectionService<ClientType>
  public eventi(id: eventoId): eventoService<ClientType>
  public eventi(id?: eventoId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new eventoCollectionService(client, path, fieldName, options)
      : new eventoService(client, path, new QeventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public riunioni_create(): riunioneCollectionService<ClientType>
  public riunioni_create(id: riunioneId): riunioneService<ClientType>
  public riunioni_create(id?: riunioneId | undefined) {
    const fieldName = 'riunioni_create'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new riunioneCollectionService(client, path, fieldName, options)
      : new riunioneService(client, path, new QriunioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public tasks_create(): taskCollectionService<ClientType>
  public tasks_create(id: taskId): taskService<ClientType>
  public tasks_create(id?: taskId | undefined) {
    const fieldName = 'tasks_create'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public tasks_responsabile_tecnico(): taskCollectionService<ClientType>
  public tasks_responsabile_tecnico(id: taskId): taskService<ClientType>
  public tasks_responsabile_tecnico(id?: taskId | undefined) {
    const fieldName = 'tasks_responsabile_tecnico'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public telefonate_create(): telefonataCollectionService<ClientType>
  public telefonate_create(id: telefonataId): telefonataService<ClientType>
  public telefonate_create(id?: telefonataId | undefined) {
    const fieldName = 'telefonate_create'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new telefonataCollectionService(client, path, fieldName, options)
      : new telefonataService(client, path, new QtelefonataId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public telefonate_ricevute(): telefonataCollectionService<ClientType>
  public telefonate_ricevute(id: telefonataId): telefonataService<ClientType>
  public telefonate_ricevute(id?: telefonataId | undefined) {
    const fieldName = 'telefonate_ricevute'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new telefonataCollectionService(client, path, fieldName, options)
      : new telefonataService(client, path, new QtelefonataId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public eventi_assistiti(): partecipante_eventoCollectionService<ClientType>
  public eventi_assistiti(id: partecipante_eventoId): partecipante_eventoService<ClientType>
  public eventi_assistiti(id?: partecipante_eventoId | undefined) {
    const fieldName = 'eventi_assistiti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new partecipante_eventoCollectionService(client, path, fieldName, options)
      : new partecipante_eventoService(
          client,
          path,
          new Qpartecipante_eventoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public commesse_create(): commessaCollectionService<ClientType>
  public commesse_create(id: commessaId): commessaService<ClientType>
  public commesse_create(id?: commessaId | undefined) {
    const fieldName = 'commesse_create'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commessaCollectionService(client, path, fieldName, options)
      : new commessaService(client, path, new QcommessaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public spese(): spesaCollectionService<ClientType>
  public spese(id: spesaId): spesaService<ClientType>
  public spese(id?: spesaId | undefined) {
    const fieldName = 'spese'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new spesaCollectionService(client, path, fieldName, options)
      : new spesaService(client, path, new QspesaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public subordinati(): userCollectionService<ClientType>
  public subordinati(id: userId): userService<ClientType>
  public subordinati(id?: userId | undefined) {
    const fieldName = 'subordinati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public analisi_create(): analisiCollectionService<ClientType>
  public analisi_create(id: analisiId): analisiService<ClientType>
  public analisi_create(id?: analisiId | undefined) {
    const fieldName = 'analisi_create'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public agenti(): agenteCollectionService<ClientType>
  public agenti(id: agenteId): agenteService<ClientType>
  public agenti(id?: agenteId | undefined) {
    const fieldName = 'agenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new agenteCollectionService(client, path, fieldName, options)
      : new agenteService(client, path, new QagenteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class userCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  user,
  Editableuser,
  Quser,
  userId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, quser, new QuserId(name), options)
  }
}

export class repartoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  reparto,
  Editablereparto,
  Qreparto
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qreparto, options)
  }

  public impiegati(): userCollectionService<ClientType>
  public impiegati(id: userId): userService<ClientType>
  public impiegati(id?: userId | undefined) {
    const fieldName = 'impiegati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public centri_costo(): centro_costo_visibilityCollectionService<ClientType>
  public centri_costo(id: centro_costo_visibilityId): centro_costo_visibilityService<ClientType>
  public centri_costo(id?: centro_costo_visibilityId | undefined) {
    const fieldName = 'centri_costo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new centro_costo_visibilityCollectionService(client, path, fieldName, options)
      : new centro_costo_visibilityService(
          client,
          path,
          new Qcentro_costo_visibilityId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class repartoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  reparto,
  Editablereparto,
  Qreparto,
  repartoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qreparto, new QrepartoId(name), options)
  }
}

export class centro_costo_visibilityService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  centro_costo_visibility,
  Editablecentro_costo_visibility,
  Qcentro_costo_visibility
> {
  private _centro_costo?: centro_costoService<ClientType>
  private _reparto?: repartoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcentro_costo_visibility, options)
  }

  public centro_costo(): centro_costoService<ClientType> {
    if (!this._centro_costo) {
      const { client, path, options } = this.__base
      this._centro_costo = new centro_costoService(client, path, 'centro_costo', options)
    }

    return this._centro_costo
  }

  public reparto(): repartoService<ClientType> {
    if (!this._reparto) {
      const { client, path, options } = this.__base
      this._reparto = new repartoService(client, path, 'reparto', options)
    }

    return this._reparto
  }
}

export class centro_costo_visibilityCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  centro_costo_visibility,
  Editablecentro_costo_visibility,
  Qcentro_costo_visibility,
  centro_costo_visibilityId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcentro_costo_visibility, new Qcentro_costo_visibilityId(name), options)
  }
}

export class centro_costoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  centro_costo,
  Editablecentro_costo,
  Qcentro_costo
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcentro_costo, options)
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public causali_centro_costo(): causale_centro_costoCollectionService<ClientType>
  public causali_centro_costo(id: causale_centro_costoId): causale_centro_costoService<ClientType>
  public causali_centro_costo(id?: causale_centro_costoId | undefined) {
    const fieldName = 'causali_centro_costo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new causale_centro_costoCollectionService(client, path, fieldName, options)
      : new causale_centro_costoService(
          client,
          path,
          new Qcausale_centro_costoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public visibility(): centro_costo_visibilityCollectionService<ClientType>
  public visibility(id: centro_costo_visibilityId): centro_costo_visibilityService<ClientType>
  public visibility(id?: centro_costo_visibilityId | undefined) {
    const fieldName = 'visibility'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new centro_costo_visibilityCollectionService(client, path, fieldName, options)
      : new centro_costo_visibilityService(
          client,
          path,
          new Qcentro_costo_visibilityId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class centro_costoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  centro_costo,
  Editablecentro_costo,
  Qcentro_costo,
  centro_costoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcentro_costo, new Qcentro_costoId(name), options)
  }
}

export class attivita_lavorativaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  attivita_lavorativa,
  Editableattivita_lavorativa,
  Qattivita_lavorativa
> {
  private _impiegato?: userService<ClientType>
  private _centro_costo?: centro_costoService<ClientType>
  private _piattaforma?: piattaforma_attivita_lavorativaService<ClientType>
  private _causale?: causale_centro_costoService<ClientType>
  private _task?: taskService<ClientType>
  private _intervento?: interventoService<ClientType>
  private _sede?: sedeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qattivita_lavorativa, options)
  }

  public impiegato(): userService<ClientType> {
    if (!this._impiegato) {
      const { client, path, options } = this.__base
      this._impiegato = new userService(client, path, 'impiegato', options)
    }

    return this._impiegato
  }

  public centro_costo(): centro_costoService<ClientType> {
    if (!this._centro_costo) {
      const { client, path, options } = this.__base
      this._centro_costo = new centro_costoService(client, path, 'centro_costo', options)
    }

    return this._centro_costo
  }

  public piattaforma(): piattaforma_attivita_lavorativaService<ClientType> {
    if (!this._piattaforma) {
      const { client, path, options } = this.__base
      this._piattaforma = new piattaforma_attivita_lavorativaService(client, path, 'piattaforma', options)
    }

    return this._piattaforma
  }

  public causale(): causale_centro_costoService<ClientType> {
    if (!this._causale) {
      const { client, path, options } = this.__base
      this._causale = new causale_centro_costoService(client, path, 'causale', options)
    }

    return this._causale
  }

  public task(): taskService<ClientType> {
    if (!this._task) {
      const { client, path, options } = this.__base
      this._task = new taskService(client, path, 'task', options)
    }

    return this._task
  }

  public intervento(): interventoService<ClientType> {
    if (!this._intervento) {
      const { client, path, options } = this.__base
      this._intervento = new interventoService(client, path, 'intervento', options)
    }

    return this._intervento
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }
}

export class attivita_lavorativaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  attivita_lavorativa,
  Editableattivita_lavorativa,
  Qattivita_lavorativa,
  attivita_lavorativaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qattivita_lavorativa, new Qattivita_lavorativaId(name), options)
  }
}

export class piattaforma_attivita_lavorativaService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  piattaforma_attivita_lavorativa,
  Editablepiattaforma_attivita_lavorativa,
  Qpiattaforma_attivita_lavorativa
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpiattaforma_attivita_lavorativa, options)
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class piattaforma_attivita_lavorativaCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  piattaforma_attivita_lavorativa,
  Editablepiattaforma_attivita_lavorativa,
  Qpiattaforma_attivita_lavorativa,
  piattaforma_attivita_lavorativaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(
      client,
      basePath,
      name,
      qpiattaforma_attivita_lavorativa,
      new Qpiattaforma_attivita_lavorativaId(name),
      options,
    )
  }
}

export class causale_centro_costoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  causale_centro_costo,
  Editablecausale_centro_costo,
  Qcausale_centro_costo
> {
  private _centro_costo?: centro_costoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcausale_centro_costo, options)
  }

  public centro_costo(): centro_costoService<ClientType> {
    if (!this._centro_costo) {
      const { client, path, options } = this.__base
      this._centro_costo = new centro_costoService(client, path, 'centro_costo', options)
    }

    return this._centro_costo
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class causale_centro_costoCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  causale_centro_costo,
  Editablecausale_centro_costo,
  Qcausale_centro_costo,
  causale_centro_costoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcausale_centro_costo, new Qcausale_centro_costoId(name), options)
  }
}

export class taskService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  task,
  Editabletask,
  Qtask
> {
  private _resp_tecnico?: userService<ClientType>
  private _ordine?: ordineService<ClientType>
  private _commessa?: commessaService<ClientType>
  private _proprietario?: userService<ClientType>
  private _stato?: stato_taskService<ClientType>
  private _sede?: sedeService<ClientType>
  private _punto_fatturazione?: punto_fatturazione_ordineService<ClientType>
  private _attivita_comm?: attivita_commService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtask, options)
  }

  public resp_tecnico(): userService<ClientType> {
    if (!this._resp_tecnico) {
      const { client, path, options } = this.__base
      this._resp_tecnico = new userService(client, path, 'resp_tecnico', options)
    }

    return this._resp_tecnico
  }

  public ordine(): ordineService<ClientType> {
    if (!this._ordine) {
      const { client, path, options } = this.__base
      this._ordine = new ordineService(client, path, 'ordine', options)
    }

    return this._ordine
  }

  public commessa(): commessaService<ClientType> {
    if (!this._commessa) {
      const { client, path, options } = this.__base
      this._commessa = new commessaService(client, path, 'commessa', options)
    }

    return this._commessa
  }

  public proprietario(): userService<ClientType> {
    if (!this._proprietario) {
      const { client, path, options } = this.__base
      this._proprietario = new userService(client, path, 'proprietario', options)
    }

    return this._proprietario
  }

  public stato(): stato_taskService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_taskService(client, path, 'stato', options)
    }

    return this._stato
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public punto_fatturazione(): punto_fatturazione_ordineService<ClientType> {
    if (!this._punto_fatturazione) {
      const { client, path, options } = this.__base
      this._punto_fatturazione = new punto_fatturazione_ordineService(client, path, 'punto_fatturazione', options)
    }

    return this._punto_fatturazione
  }

  public attivita_comm(): attivita_commService<ClientType> {
    if (!this._attivita_comm) {
      const { client, path, options } = this.__base
      this._attivita_comm = new attivita_commService(client, path, 'attivita_comm', options)
    }

    return this._attivita_comm
  }

  public tecnici(): userCollectionService<ClientType>
  public tecnici(id: userId): userService<ClientType>
  public tecnici(id?: userId | undefined) {
    const fieldName = 'tecnici'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public eventi(): eventoCollectionService<ClientType>
  public eventi(id: eventoId): eventoService<ClientType>
  public eventi(id?: eventoId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new eventoCollectionService(client, path, fieldName, options)
      : new eventoService(client, path, new QeventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public interventi(): interventoCollectionService<ClientType>
  public interventi(id: interventoId): interventoService<ClientType>
  public interventi(id?: interventoId | undefined) {
    const fieldName = 'interventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new interventoCollectionService(client, path, fieldName, options)
      : new interventoService(client, path, new QinterventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public pacchetti_venduti(): pacchetto_venditaCollectionService<ClientType>
  public pacchetti_venduti(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetti_venduti(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetti_venduti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public promemoria(): promemoria_taskCollectionService<ClientType>
  public promemoria(id: promemoria_taskId): promemoria_taskService<ClientType>
  public promemoria(id?: promemoria_taskId | undefined) {
    const fieldName = 'promemoria'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new promemoria_taskCollectionService(client, path, fieldName, options)
      : new promemoria_taskService(
          client,
          path,
          new Qpromemoria_taskId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class taskCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  task,
  Editabletask,
  Qtask,
  taskId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtask, new QtaskId(name), options)
  }
}

export class ordineService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ordine,
  Editableordine,
  Qordine
> {
  private _stato?: stato_ordineService<ClientType>
  private _offerta?: offertaService<ClientType>
  private _quota?: ad_quoteService<ClientType>
  private _condivisione?: stato_condivisioneService<ClientType>
  private _commessa?: commessaService<ClientType>
  private _fatturazione?: stato_fatturazione_ordineService<ClientType>
  private _acconto?: stato_acconto_ordineService<ClientType>
  private _assegnato?: userService<ClientType>
  private _ordine_QProcessingOrder?: ordine_QProcessingOrder
  private _ordine_QRestoreOrder?: ordine_QRestoreOrder
  private _ordine_QCancelOrder?: ordine_QCancelOrder
  private _ordine_QRemoveAssignee?: ordine_QRemoveAssignee

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qordine, options)
  }

  public stato(): stato_ordineService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_ordineService(client, path, 'stato', options)
    }

    return this._stato
  }

  public offerta(): offertaService<ClientType> {
    if (!this._offerta) {
      const { client, path, options } = this.__base
      this._offerta = new offertaService(client, path, 'offerta', options)
    }

    return this._offerta
  }

  public quota(): ad_quoteService<ClientType> {
    if (!this._quota) {
      const { client, path, options } = this.__base
      this._quota = new ad_quoteService(client, path, 'quota', options)
    }

    return this._quota
  }

  public condivisione(): stato_condivisioneService<ClientType> {
    if (!this._condivisione) {
      const { client, path, options } = this.__base
      this._condivisione = new stato_condivisioneService(client, path, 'condivisione', options)
    }

    return this._condivisione
  }

  public commessa(): commessaService<ClientType> {
    if (!this._commessa) {
      const { client, path, options } = this.__base
      this._commessa = new commessaService(client, path, 'commessa', options)
    }

    return this._commessa
  }

  public fatturazione(): stato_fatturazione_ordineService<ClientType> {
    if (!this._fatturazione) {
      const { client, path, options } = this.__base
      this._fatturazione = new stato_fatturazione_ordineService(client, path, 'fatturazione', options)
    }

    return this._fatturazione
  }

  public acconto(): stato_acconto_ordineService<ClientType> {
    if (!this._acconto) {
      const { client, path, options } = this.__base
      this._acconto = new stato_acconto_ordineService(client, path, 'acconto', options)
    }

    return this._acconto
  }

  public assegnato(): userService<ClientType> {
    if (!this._assegnato) {
      const { client, path, options } = this.__base
      this._assegnato = new userService(client, path, 'assegnato', options)
    }

    return this._assegnato
  }

  public tasks(): taskCollectionService<ClientType>
  public tasks(id: taskId): taskService<ClientType>
  public tasks(id?: taskId | undefined) {
    const fieldName = 'tasks'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public punti_fatturazione_ordine(): punto_fatturazione_ordineCollectionService<ClientType>
  public punti_fatturazione_ordine(id: punto_fatturazione_ordineId): punto_fatturazione_ordineService<ClientType>
  public punti_fatturazione_ordine(id?: punto_fatturazione_ordineId | undefined) {
    const fieldName = 'punti_fatturazione_ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new punto_fatturazione_ordineCollectionService(client, path, fieldName, options)
      : new punto_fatturazione_ordineService(
          client,
          path,
          new Qpunto_fatturazione_ordineId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public pacchetti_vendita(): pacchetto_venditaCollectionService<ClientType>
  public pacchetti_vendita(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetti_vendita(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetti_vendita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public async ProcessingOrder(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ordine_QProcessingOrder) {
      this._ordine_QProcessingOrder = new ordine_QProcessingOrder()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ordine_QProcessingOrder.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async RestoreOrder(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ordine_QRestoreOrder) {
      this._ordine_QRestoreOrder = new ordine_QRestoreOrder()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ordine_QRestoreOrder.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async CancelOrder(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ordine_QCancelOrder) {
      this._ordine_QCancelOrder = new ordine_QCancelOrder()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ordine_QCancelOrder.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async RemoveAssignee(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ordine_QRemoveAssignee) {
      this._ordine_QRemoveAssignee = new ordine_QRemoveAssignee()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ordine_QRemoveAssignee.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }
}

export class ordineCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ordine,
  Editableordine,
  Qordine,
  ordineId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qordine, new QordineId(name), options)
  }
}

export class stato_ordineService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_ordine,
  Editablestato_ordine,
  Qstato_ordine
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_ordine, options)
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_ordineCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_ordine,
  Editablestato_ordine,
  Qstato_ordine,
  stato_ordineId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_ordine, new Qstato_ordineId(name), options)
  }
}

export class offertaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  offerta,
  Editableofferta,
  Qofferta
> {
  private _stato?: stato_offertaService<ClientType>
  private _autore?: userService<ClientType>
  private _commessa?: commessaService<ClientType>
  private _analisi?: analisiService<ClientType>
  private _tipologia_pagamento?: tipologia_pagamentoService<ClientType>
  private _sede?: sedeService<ClientType>
  private _condivisione?: stato_condivisioneService<ClientType>
  private _template?: template_offertaService<ClientType>
  private _offerta_QCreateDocument?: offerta_QCreateDocument

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qofferta, options)
  }

  public stato(): stato_offertaService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_offertaService(client, path, 'stato', options)
    }

    return this._stato
  }

  public autore(): userService<ClientType> {
    if (!this._autore) {
      const { client, path, options } = this.__base
      this._autore = new userService(client, path, 'autore', options)
    }

    return this._autore
  }

  public commessa(): commessaService<ClientType> {
    if (!this._commessa) {
      const { client, path, options } = this.__base
      this._commessa = new commessaService(client, path, 'commessa', options)
    }

    return this._commessa
  }

  public analisi(): analisiService<ClientType> {
    if (!this._analisi) {
      const { client, path, options } = this.__base
      this._analisi = new analisiService(client, path, 'analisi', options)
    }

    return this._analisi
  }

  public tipologia_pagamento(): tipologia_pagamentoService<ClientType> {
    if (!this._tipologia_pagamento) {
      const { client, path, options } = this.__base
      this._tipologia_pagamento = new tipologia_pagamentoService(client, path, 'tipologia_pagamento', options)
    }

    return this._tipologia_pagamento
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public condivisione(): stato_condivisioneService<ClientType> {
    if (!this._condivisione) {
      const { client, path, options } = this.__base
      this._condivisione = new stato_condivisioneService(client, path, 'condivisione', options)
    }

    return this._condivisione
  }

  public template(): template_offertaService<ClientType> {
    if (!this._template) {
      const { client, path, options } = this.__base
      this._template = new template_offertaService(client, path, 'template', options)
    }

    return this._template
  }

  public riferimenti(): contatto_aziendaleCollectionService<ClientType>
  public riferimenti(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public riferimenti(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'riferimenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public riferimenti_entita(): entita_aziendaleCollectionService<ClientType>
  public riferimenti_entita(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public riferimenti_entita(id?: entita_aziendaleId | undefined) {
    const fieldName = 'riferimenti_entita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public async CreateDocument(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._offerta_QCreateDocument) {
      this._offerta_QCreateDocument = new offerta_QCreateDocument()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._offerta_QCreateDocument.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }
}

export class offertaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  offerta,
  Editableofferta,
  Qofferta,
  offertaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qofferta, new QoffertaId(name), options)
  }
}

export class stato_offertaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_offerta,
  Editablestato_offerta,
  Qstato_offerta
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_offerta, options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_offertaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_offerta,
  Editablestato_offerta,
  Qstato_offerta,
  stato_offertaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_offerta, new Qstato_offertaId(name), options)
  }
}

export class commessaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  commessa,
  Editablecommessa,
  Qcommessa
> {
  private _stato?: stato_commessaService<ClientType>
  private _sede?: sedeService<ClientType>
  private _autore?: userService<ClientType>
  private _condivisione?: stato_condivisioneService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcommessa, options)
  }

  public stato(): stato_commessaService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_commessaService(client, path, 'stato', options)
    }

    return this._stato
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public autore(): userService<ClientType> {
    if (!this._autore) {
      const { client, path, options } = this.__base
      this._autore = new userService(client, path, 'autore', options)
    }

    return this._autore
  }

  public condivisione(): stato_condivisioneService<ClientType> {
    if (!this._condivisione) {
      const { client, path, options } = this.__base
      this._condivisione = new stato_condivisioneService(client, path, 'condivisione', options)
    }

    return this._condivisione
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public pacchetti_vendita(): pacchetto_venditaCollectionService<ClientType>
  public pacchetti_vendita(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetti_vendita(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetti_vendita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tasks(): taskCollectionService<ClientType>
  public tasks(id: taskId): taskService<ClientType>
  public tasks(id?: taskId | undefined) {
    const fieldName = 'tasks'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_quotes(): ad_quoteCollectionService<ClientType>
  public ad_quotes(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quotes(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quotes'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class commessaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  commessa,
  Editablecommessa,
  Qcommessa,
  commessaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcommessa, new QcommessaId(name), options)
  }
}

export class stato_commessaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_commessa,
  Editablestato_commessa,
  Qstato_commessa
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_commessa, options)
  }

  public commesse(): commessaCollectionService<ClientType>
  public commesse(id: commessaId): commessaService<ClientType>
  public commesse(id?: commessaId | undefined) {
    const fieldName = 'commesse'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commessaCollectionService(client, path, fieldName, options)
      : new commessaService(client, path, new QcommessaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_commessaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_commessa,
  Editablestato_commessa,
  Qstato_commessa,
  stato_commessaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_commessa, new Qstato_commessaId(name), options)
  }
}

export class sedeService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  sede,
  Editablesede,
  Qsede
> {
  private _azienda?: aziendaService<ClientType>
  private _resp_tecnico?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qsede, options)
  }

  public azienda(): aziendaService<ClientType> {
    if (!this._azienda) {
      const { client, path, options } = this.__base
      this._azienda = new aziendaService(client, path, 'azienda', options)
    }

    return this._azienda
  }

  public resp_tecnico(): userService<ClientType> {
    if (!this._resp_tecnico) {
      const { client, path, options } = this.__base
      this._resp_tecnico = new userService(client, path, 'resp_tecnico', options)
    }

    return this._resp_tecnico
  }

  public pacchetti_vendita(): pacchetto_venditaCollectionService<ClientType>
  public pacchetti_vendita(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetti_vendita(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetti_vendita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public contatti_aziendali(): contatto_aziendaleCollectionService<ClientType>
  public contatti_aziendali(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public contatti_aziendali(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'contatti_aziendali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public interventi(): interventoCollectionService<ClientType>
  public interventi(id: interventoId): interventoService<ClientType>
  public interventi(id?: interventoId | undefined) {
    const fieldName = 'interventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new interventoCollectionService(client, path, fieldName, options)
      : new interventoService(client, path, new QinterventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public commesse(): commessaCollectionService<ClientType>
  public commesse(id: commessaId): commessaService<ClientType>
  public commesse(id?: commessaId | undefined) {
    const fieldName = 'commesse'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commessaCollectionService(client, path, fieldName, options)
      : new commessaService(client, path, new QcommessaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public analisi(): analisiCollectionService<ClientType>
  public analisi(id: analisiId): analisiService<ClientType>
  public analisi(id?: analisiId | undefined) {
    const fieldName = 'analisi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public licenze_esterne(): est_licenzaCollectionService<ClientType>
  public licenze_esterne(id: est_licenzaId): est_licenzaService<ClientType>
  public licenze_esterne(id?: est_licenzaId | undefined) {
    const fieldName = 'licenze_esterne'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_licenzaCollectionService(client, path, fieldName, options)
      : new est_licenzaService(client, path, new Qest_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public assistenze(): assistenzaCollectionService<ClientType>
  public assistenze(id: assistenzaId): assistenzaService<ClientType>
  public assistenze(id?: assistenzaId | undefined) {
    const fieldName = 'assistenze'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new assistenzaCollectionService(client, path, fieldName, options)
      : new assistenzaService(client, path, new QassistenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public licenze_qs(): qs_licenzaCollectionService<ClientType>
  public licenze_qs(id: qs_licenzaId): qs_licenzaService<ClientType>
  public licenze_qs(id?: qs_licenzaId | undefined) {
    const fieldName = 'licenze_qs'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenzaCollectionService(client, path, fieldName, options)
      : new qs_licenzaService(client, path, new Qqs_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public entita_aziendali(): entita_aziendaleCollectionService<ClientType>
  public entita_aziendali(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public entita_aziendali(id?: entita_aziendaleId | undefined) {
    const fieldName = 'entita_aziendali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public storico_licenza(): qs_storico_licenzaCollectionService<ClientType>
  public storico_licenza(id: qs_storico_licenzaId): qs_storico_licenzaService<ClientType>
  public storico_licenza(id?: qs_storico_licenzaId | undefined) {
    const fieldName = 'storico_licenza'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_storico_licenzaCollectionService(client, path, fieldName, options)
      : new qs_storico_licenzaService(
          client,
          path,
          new Qqs_storico_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tasks(): taskCollectionService<ClientType>
  public tasks(id: taskId): taskService<ClientType>
  public tasks(id?: taskId | undefined) {
    const fieldName = 'tasks'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public personalizzazioni(): personalizzazioneCollectionService<ClientType>
  public personalizzazioni(id: personalizzazioneId): personalizzazioneService<ClientType>
  public personalizzazioni(id?: personalizzazioneId | undefined) {
    const fieldName = 'personalizzazioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new personalizzazioneCollectionService(client, path, fieldName, options)
      : new personalizzazioneService(
          client,
          path,
          new QpersonalizzazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class sedeCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  sede,
  Editablesede,
  Qsede,
  sedeId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qsede, new QsedeId(name), options)
  }
}

export class aziendaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  azienda,
  Editableazienda,
  Qazienda
> {
  private _agente?: agenteService<ClientType>
  private _sede_principale?: sedeService<ClientType>
  private _gruppo_aziendale?: gruppo_aziendaleService<ClientType>
  private _tipologia_rapporto?: tipologia_rapporto_aziendaService<ClientType>
  private _tipologia_pagamento?: tipologia_pagamentoService<ClientType>
  private _rivenditore?: aziendaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qazienda, options)
  }

  public agente(): agenteService<ClientType> {
    if (!this._agente) {
      const { client, path, options } = this.__base
      this._agente = new agenteService(client, path, 'agente', options)
    }

    return this._agente
  }

  public sede_principale(): sedeService<ClientType> {
    if (!this._sede_principale) {
      const { client, path, options } = this.__base
      this._sede_principale = new sedeService(client, path, 'sede_principale', options)
    }

    return this._sede_principale
  }

  public gruppo_aziendale(): gruppo_aziendaleService<ClientType> {
    if (!this._gruppo_aziendale) {
      const { client, path, options } = this.__base
      this._gruppo_aziendale = new gruppo_aziendaleService(client, path, 'gruppo_aziendale', options)
    }

    return this._gruppo_aziendale
  }

  public tipologia_rapporto(): tipologia_rapporto_aziendaService<ClientType> {
    if (!this._tipologia_rapporto) {
      const { client, path, options } = this.__base
      this._tipologia_rapporto = new tipologia_rapporto_aziendaService(client, path, 'tipologia_rapporto', options)
    }

    return this._tipologia_rapporto
  }

  public tipologia_pagamento(): tipologia_pagamentoService<ClientType> {
    if (!this._tipologia_pagamento) {
      const { client, path, options } = this.__base
      this._tipologia_pagamento = new tipologia_pagamentoService(client, path, 'tipologia_pagamento', options)
    }

    return this._tipologia_pagamento
  }

  public rivenditore(): aziendaService<ClientType> {
    if (!this._rivenditore) {
      const { client, path, options } = this.__base
      this._rivenditore = new aziendaService(client, path, 'rivenditore', options)
    }

    return this._rivenditore
  }

  public nomi_noti(): nome_notoCollectionService<ClientType>
  public nomi_noti(id: nome_notoId): nome_notoService<ClientType>
  public nomi_noti(id?: nome_notoId | undefined) {
    const fieldName = 'nomi_noti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nome_notoCollectionService(client, path, fieldName, options)
      : new nome_notoService(client, path, new Qnome_notoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public sedi(): sedeCollectionService<ClientType>
  public sedi(id: sedeId): sedeService<ClientType>
  public sedi(id?: sedeId | undefined) {
    const fieldName = 'sedi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new sedeCollectionService(client, path, fieldName, options)
      : new sedeService(client, path, new QsedeId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public software_concorrenti(): software_concorrenteCollectionService<ClientType>
  public software_concorrenti(id: software_concorrenteId): software_concorrenteService<ClientType>
  public software_concorrenti(id?: software_concorrenteId | undefined) {
    const fieldName = 'software_concorrenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new software_concorrenteCollectionService(client, path, fieldName, options)
      : new software_concorrenteService(
          client,
          path,
          new Qsoftware_concorrenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public rivendite(): aziendaCollectionService<ClientType>
  public rivendite(id: aziendaId): aziendaService<ClientType>
  public rivendite(id?: aziendaId | undefined) {
    const fieldName = 'rivendite'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new aziendaCollectionService(client, path, fieldName, options)
      : new aziendaService(client, path, new QaziendaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_csns(): ad_csnCollectionService<ClientType>
  public ad_csns(id: ad_csnId): ad_csnService<ClientType>
  public ad_csns(id?: ad_csnId | undefined) {
    const fieldName = 'ad_csns'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_csnCollectionService(client, path, fieldName, options)
      : new ad_csnService(client, path, new Qad_csnId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public gruppi_rappresentati(): gruppo_aziendaleCollectionService<ClientType>
  public gruppi_rappresentati(id: gruppo_aziendaleId): gruppo_aziendaleService<ClientType>
  public gruppi_rappresentati(id?: gruppo_aziendaleId | undefined) {
    const fieldName = 'gruppi_rappresentati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new gruppo_aziendaleCollectionService(client, path, fieldName, options)
      : new gruppo_aziendaleService(
          client,
          path,
          new Qgruppo_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_quotes(): ad_quoteCollectionService<ClientType>
  public ad_quotes(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quotes(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quotes'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public storico_agenti(): storico_agenteCollectionService<ClientType>
  public storico_agenti(id: storico_agenteId): storico_agenteService<ClientType>
  public storico_agenti(id?: storico_agenteId | undefined) {
    const fieldName = 'storico_agenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new storico_agenteCollectionService(client, path, fieldName, options)
      : new storico_agenteService(
          client,
          path,
          new Qstorico_agenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class aziendaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  azienda,
  Editableazienda,
  Qazienda,
  aziendaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qazienda, new QaziendaId(name), options)
  }
}

export class agenteService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  agente,
  Editableagente,
  Qagente
> {
  private _commerciale_qs?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qagente, options)
  }

  public commerciale_qs(): userService<ClientType> {
    if (!this._commerciale_qs) {
      const { client, path, options } = this.__base
      this._commerciale_qs = new userService(client, path, 'commerciale_qs', options)
    }

    return this._commerciale_qs
  }

  public storico_agente(): storico_agenteCollectionService<ClientType>
  public storico_agente(id: storico_agenteId): storico_agenteService<ClientType>
  public storico_agente(id?: storico_agenteId | undefined) {
    const fieldName = 'storico_agente'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new storico_agenteCollectionService(client, path, fieldName, options)
      : new storico_agenteService(
          client,
          path,
          new Qstorico_agenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class agenteCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  agente,
  Editableagente,
  Qagente,
  agenteId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qagente, new QagenteId(name), options)
  }
}

export class storico_agenteService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  storico_agente,
  Editablestorico_agente,
  Qstorico_agente
> {
  private _agente?: agenteService<ClientType>
  private _azienda?: aziendaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstorico_agente, options)
  }

  public agente(): agenteService<ClientType> {
    if (!this._agente) {
      const { client, path, options } = this.__base
      this._agente = new agenteService(client, path, 'agente', options)
    }

    return this._agente
  }

  public azienda(): aziendaService<ClientType> {
    if (!this._azienda) {
      const { client, path, options } = this.__base
      this._azienda = new aziendaService(client, path, 'azienda', options)
    }

    return this._azienda
  }
}

export class storico_agenteCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  storico_agente,
  Editablestorico_agente,
  Qstorico_agente,
  storico_agenteId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstorico_agente, new Qstorico_agenteId(name), options)
  }
}

export class gruppo_aziendaleService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  gruppo_aziendale,
  Editablegruppo_aziendale,
  Qgruppo_aziendale
> {
  private _capogruppo?: aziendaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qgruppo_aziendale, options)
  }

  public capogruppo(): aziendaService<ClientType> {
    if (!this._capogruppo) {
      const { client, path, options } = this.__base
      this._capogruppo = new aziendaService(client, path, 'capogruppo', options)
    }

    return this._capogruppo
  }

  public aziende(): aziendaCollectionService<ClientType>
  public aziende(id: aziendaId): aziendaService<ClientType>
  public aziende(id?: aziendaId | undefined) {
    const fieldName = 'aziende'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new aziendaCollectionService(client, path, fieldName, options)
      : new aziendaService(client, path, new QaziendaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class gruppo_aziendaleCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  gruppo_aziendale,
  Editablegruppo_aziendale,
  Qgruppo_aziendale,
  gruppo_aziendaleId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qgruppo_aziendale, new Qgruppo_aziendaleId(name), options)
  }
}

export class tipologia_rapporto_aziendaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_rapporto_azienda,
  Editabletipologia_rapporto_azienda,
  Qtipologia_rapporto_azienda
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_rapporto_azienda, options)
  }

  public aziende(): aziendaCollectionService<ClientType>
  public aziende(id: aziendaId): aziendaService<ClientType>
  public aziende(id?: aziendaId | undefined) {
    const fieldName = 'aziende'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new aziendaCollectionService(client, path, fieldName, options)
      : new aziendaService(client, path, new QaziendaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_rapporto_aziendaCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_rapporto_azienda,
  Editabletipologia_rapporto_azienda,
  Qtipologia_rapporto_azienda,
  tipologia_rapporto_aziendaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_rapporto_azienda, new Qtipologia_rapporto_aziendaId(name), options)
  }
}

export class tipologia_pagamentoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_pagamento,
  Editabletipologia_pagamento,
  Qtipologia_pagamento
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_pagamento, options)
  }

  public aziende(): aziendaCollectionService<ClientType>
  public aziende(id: aziendaId): aziendaService<ClientType>
  public aziende(id?: aziendaId | undefined) {
    const fieldName = 'aziende'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new aziendaCollectionService(client, path, fieldName, options)
      : new aziendaService(client, path, new QaziendaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_pagamentoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_pagamento,
  Editabletipologia_pagamento,
  Qtipologia_pagamento,
  tipologia_pagamentoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_pagamento, new Qtipologia_pagamentoId(name), options)
  }
}

export class nome_notoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  nome_noto,
  Editablenome_noto,
  Qnome_noto
> {
  private _azienda?: aziendaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qnome_noto, options)
  }

  public azienda(): aziendaService<ClientType> {
    if (!this._azienda) {
      const { client, path, options } = this.__base
      this._azienda = new aziendaService(client, path, 'azienda', options)
    }

    return this._azienda
  }
}

export class nome_notoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  nome_noto,
  Editablenome_noto,
  Qnome_noto,
  nome_notoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qnome_noto, new Qnome_notoId(name), options)
  }
}

export class software_concorrenteService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  software_concorrente,
  Editablesoftware_concorrente,
  Qsoftware_concorrente
> {
  private _concorrente?: aziendaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qsoftware_concorrente, options)
  }

  public concorrente(): aziendaService<ClientType> {
    if (!this._concorrente) {
      const { client, path, options } = this.__base
      this._concorrente = new aziendaService(client, path, 'concorrente', options)
    }

    return this._concorrente
  }

  public features(): concorrente_software_featureCollectionService<ClientType>
  public features(id: concorrente_software_featureId): concorrente_software_featureService<ClientType>
  public features(id?: concorrente_software_featureId | undefined) {
    const fieldName = 'features'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new concorrente_software_featureCollectionService(client, path, fieldName, options)
      : new concorrente_software_featureService(
          client,
          path,
          new Qconcorrente_software_featureId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class software_concorrenteCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  software_concorrente,
  Editablesoftware_concorrente,
  Qsoftware_concorrente,
  software_concorrenteId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qsoftware_concorrente, new Qsoftware_concorrenteId(name), options)
  }
}

export class concorrente_software_featureService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  concorrente_software_feature,
  Editableconcorrente_software_feature,
  Qconcorrente_software_feature
> {
  private _software?: software_concorrenteService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qconcorrente_software_feature, options)
  }

  public software(): software_concorrenteService<ClientType> {
    if (!this._software) {
      const { client, path, options } = this.__base
      this._software = new software_concorrenteService(client, path, 'software', options)
    }

    return this._software
  }
}

export class concorrente_software_featureCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  concorrente_software_feature,
  Editableconcorrente_software_feature,
  Qconcorrente_software_feature,
  concorrente_software_featureId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qconcorrente_software_feature, new Qconcorrente_software_featureId(name), options)
  }
}

export class ad_csnService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_csn,
  Editablead_csn,
  Qad_csn
> {
  private _admin?: contatto_aziendaleService<ClientType>
  private _quoteContact?: contatto_aziendaleService<ClientType>
  private _azienda?: aziendaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_csn, options)
  }

  public admin(): contatto_aziendaleService<ClientType> {
    if (!this._admin) {
      const { client, path, options } = this.__base
      this._admin = new contatto_aziendaleService(client, path, 'admin', options)
    }

    return this._admin
  }

  public quoteContact(): contatto_aziendaleService<ClientType> {
    if (!this._quoteContact) {
      const { client, path, options } = this.__base
      this._quoteContact = new contatto_aziendaleService(client, path, 'quoteContact', options)
    }

    return this._quoteContact
  }

  public azienda(): aziendaService<ClientType> {
    if (!this._azienda) {
      const { client, path, options } = this.__base
      this._azienda = new aziendaService(client, path, 'azienda', options)
    }

    return this._azienda
  }

  public ad_subscriptions(): ad_subscriptionCollectionService<ClientType>
  public ad_subscriptions(id: ad_subscriptionId): ad_subscriptionService<ClientType>
  public ad_subscriptions(id?: ad_subscriptionId | undefined) {
    const fieldName = 'ad_subscriptions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_subscriptionCollectionService(client, path, fieldName, options)
      : new ad_subscriptionService(
          client,
          path,
          new Qad_subscriptionId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_quotes(): ad_quoteCollectionService<ClientType>
  public ad_quotes(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quotes(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quotes'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class ad_csnCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_csn,
  Editablead_csn,
  Qad_csn,
  ad_csnId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_csn, new Qad_csnId(name), options)
  }
}

export class contatto_aziendaleService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  contatto_aziendale,
  Editablecontatto_aziendale,
  Qcontatto_aziendale
> {
  private _preposto?: contatto_aziendaleService<ClientType>
  private _rapporto?: rapportoService<ClientType>
  private _sede?: sedeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcontatto_aziendale, options)
  }

  public preposto(): contatto_aziendaleService<ClientType> {
    if (!this._preposto) {
      const { client, path, options } = this.__base
      this._preposto = new contatto_aziendaleService(client, path, 'preposto', options)
    }

    return this._preposto
  }

  public rapporto(): rapportoService<ClientType> {
    if (!this._rapporto) {
      const { client, path, options } = this.__base
      this._rapporto = new rapportoService(client, path, 'rapporto', options)
    }

    return this._rapporto
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public analisi_assegnate(): analisiCollectionService<ClientType>
  public analisi_assegnate(id: analisiId): analisiService<ClientType>
  public analisi_assegnate(id?: analisiId | undefined) {
    const fieldName = 'analisi_assegnate'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public interventi(): interventoCollectionService<ClientType>
  public interventi(id: interventoId): interventoService<ClientType>
  public interventi(id?: interventoId | undefined) {
    const fieldName = 'interventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new interventoCollectionService(client, path, fieldName, options)
      : new interventoService(client, path, new QinterventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public emails(): email_aziendaleCollectionService<ClientType>
  public emails(id: email_aziendaleId): email_aziendaleService<ClientType>
  public emails(id?: email_aziendaleId | undefined) {
    const fieldName = 'emails'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new email_aziendaleCollectionService(client, path, fieldName, options)
      : new email_aziendaleService(
          client,
          path,
          new Qemail_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public entita_aziendali(): entita_aziendaleCollectionService<ClientType>
  public entita_aziendali(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public entita_aziendali(id?: entita_aziendaleId | undefined) {
    const fieldName = 'entita_aziendali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_quotes_contatti_addizionali(): ad_quoteCollectionService<ClientType>
  public ad_quotes_contatti_addizionali(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quotes_contatti_addizionali(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quotes_contatti_addizionali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public staff(): contatto_aziendaleCollectionService<ClientType>
  public staff(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public staff(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'staff'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public eventi(): partecipante_eventoCollectionService<ClientType>
  public eventi(id: partecipante_eventoId): partecipante_eventoService<ClientType>
  public eventi(id?: partecipante_eventoId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new partecipante_eventoCollectionService(client, path, fieldName, options)
      : new partecipante_eventoService(
          client,
          path,
          new Qpartecipante_eventoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_quotes(): ad_quoteCollectionService<ClientType>
  public ad_quotes(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quotes(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quotes'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public ad_csns(): ad_csnCollectionService<ClientType>
  public ad_csns(id: ad_csnId): ad_csnService<ClientType>
  public ad_csns(id?: ad_csnId | undefined) {
    const fieldName = 'ad_csns'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_csnCollectionService(client, path, fieldName, options)
      : new ad_csnService(client, path, new Qad_csnId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public storico_spostamenti_nuovo(): storico_contatto_aziendaleCollectionService<ClientType>
  public storico_spostamenti_nuovo(id: storico_contatto_aziendaleId): storico_contatto_aziendaleService<ClientType>
  public storico_spostamenti_nuovo(id?: storico_contatto_aziendaleId | undefined) {
    const fieldName = 'storico_spostamenti_nuovo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new storico_contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new storico_contatto_aziendaleService(
          client,
          path,
          new Qstorico_contatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public storico_spostamenti_vecchio(): storico_contatto_aziendaleCollectionService<ClientType>
  public storico_spostamenti_vecchio(id: storico_contatto_aziendaleId): storico_contatto_aziendaleService<ClientType>
  public storico_spostamenti_vecchio(id?: storico_contatto_aziendaleId | undefined) {
    const fieldName = 'storico_spostamenti_vecchio'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new storico_contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new storico_contatto_aziendaleService(
          client,
          path,
          new Qstorico_contatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ticket_corrispondenti(): ticket_corrispondenteCollectionService<ClientType>
  public ticket_corrispondenti(id: ticket_corrispondenteId): ticket_corrispondenteService<ClientType>
  public ticket_corrispondenti(id?: ticket_corrispondenteId | undefined) {
    const fieldName = 'ticket_corrispondenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_corrispondenteCollectionService(client, path, fieldName, options)
      : new ticket_corrispondenteService(
          client,
          path,
          new Qticket_corrispondenteId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class contatto_aziendaleCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  contatto_aziendale,
  Editablecontatto_aziendale,
  Qcontatto_aziendale,
  contatto_aziendaleId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcontatto_aziendale, new Qcontatto_aziendaleId(name), options)
  }
}

export class rapportoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  rapporto,
  Editablerapporto,
  Qrapporto
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qrapporto, options)
  }

  public impiegati(): contatto_aziendaleCollectionService<ClientType>
  public impiegati(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public impiegati(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'impiegati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class rapportoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  rapporto,
  Editablerapporto,
  Qrapporto,
  rapportoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qrapporto, new QrapportoId(name), options)
  }
}

export class analisiService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  analisi,
  Editableanalisi,
  Qanalisi
> {
  private _stato?: stato_analisiService<ClientType>
  private _creatore?: userService<ClientType>
  private _sede?: sedeService<ClientType>
  private _condivisione?: stato_condivisioneService<ClientType>
  private _analisi_QCreateDocument?: analisi_QCreateDocument

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qanalisi, options)
  }

  public stato(): stato_analisiService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_analisiService(client, path, 'stato', options)
    }

    return this._stato
  }

  public creatore(): userService<ClientType> {
    if (!this._creatore) {
      const { client, path, options } = this.__base
      this._creatore = new userService(client, path, 'creatore', options)
    }

    return this._creatore
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public condivisione(): stato_condivisioneService<ClientType> {
    if (!this._condivisione) {
      const { client, path, options } = this.__base
      this._condivisione = new stato_condivisioneService(client, path, 'condivisione', options)
    }

    return this._condivisione
  }

  public riferimenti_entita(): entita_aziendaleCollectionService<ClientType>
  public riferimenti_entita(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public riferimenti_entita(id?: entita_aziendaleId | undefined) {
    const fieldName = 'riferimenti_entita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public riferimenti(): contatto_aziendaleCollectionService<ClientType>
  public riferimenti(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public riferimenti(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'riferimenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tecnici_ausiliari(): userCollectionService<ClientType>
  public tecnici_ausiliari(id: userId): userService<ClientType>
  public tecnici_ausiliari(id?: userId | undefined) {
    const fieldName = 'tecnici_ausiliari'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public personalizzazioni(): personalizzazioneCollectionService<ClientType>
  public personalizzazioni(id: personalizzazioneId): personalizzazioneService<ClientType>
  public personalizzazioni(id?: personalizzazioneId | undefined) {
    const fieldName = 'personalizzazioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new personalizzazioneCollectionService(client, path, fieldName, options)
      : new personalizzazioneService(
          client,
          path,
          new QpersonalizzazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public async CreateDocument(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._analisi_QCreateDocument) {
      this._analisi_QCreateDocument = new analisi_QCreateDocument()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._analisi_QCreateDocument.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }
}

export class analisiCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  analisi,
  Editableanalisi,
  Qanalisi,
  analisiId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qanalisi, new QanalisiId(name), options)
  }
}

export class stato_analisiService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_analisi,
  Editablestato_analisi,
  Qstato_analisi
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_analisi, options)
  }

  public analisi(): analisiCollectionService<ClientType>
  public analisi(id: analisiId): analisiService<ClientType>
  public analisi(id?: analisiId | undefined) {
    const fieldName = 'analisi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_analisiCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_analisi,
  Editablestato_analisi,
  Qstato_analisi,
  stato_analisiId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_analisi, new Qstato_analisiId(name), options)
  }
}

export class stato_condivisioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_condivisione,
  Editablestato_condivisione,
  Qstato_condivisione
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_condivisione, options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public analisi(): analisiCollectionService<ClientType>
  public analisi(id: analisiId): analisiService<ClientType>
  public analisi(id?: analisiId | undefined) {
    const fieldName = 'analisi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public commesse(): commessaCollectionService<ClientType>
  public commesse(id: commessaId): commessaService<ClientType>
  public commesse(id?: commessaId | undefined) {
    const fieldName = 'commesse'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commessaCollectionService(client, path, fieldName, options)
      : new commessaService(client, path, new QcommessaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public pacchetti_vendita(): pacchetto_venditaCollectionService<ClientType>
  public pacchetti_vendita(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetti_vendita(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetti_vendita'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_condivisioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_condivisione,
  Editablestato_condivisione,
  Qstato_condivisione,
  stato_condivisioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_condivisione, new Qstato_condivisioneId(name), options)
  }
}

export class pacchetto_venditaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  pacchetto_vendita,
  Editablepacchetto_vendita,
  Qpacchetto_vendita
> {
  private _commessa?: commessaService<ClientType>
  private _tipologia_unita?: tipologia_durata_pacchettoService<ClientType>
  private _task?: taskService<ClientType>
  private _sede?: sedeService<ClientType>
  private _condivisione?: stato_condivisioneService<ClientType>
  private _ordine?: ordineService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpacchetto_vendita, options)
  }

  public commessa(): commessaService<ClientType> {
    if (!this._commessa) {
      const { client, path, options } = this.__base
      this._commessa = new commessaService(client, path, 'commessa', options)
    }

    return this._commessa
  }

  public tipologia_unita(): tipologia_durata_pacchettoService<ClientType> {
    if (!this._tipologia_unita) {
      const { client, path, options } = this.__base
      this._tipologia_unita = new tipologia_durata_pacchettoService(client, path, 'tipologia_unita', options)
    }

    return this._tipologia_unita
  }

  public task(): taskService<ClientType> {
    if (!this._task) {
      const { client, path, options } = this.__base
      this._task = new taskService(client, path, 'task', options)
    }

    return this._task
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public condivisione(): stato_condivisioneService<ClientType> {
    if (!this._condivisione) {
      const { client, path, options } = this.__base
      this._condivisione = new stato_condivisioneService(client, path, 'condivisione', options)
    }

    return this._condivisione
  }

  public ordine(): ordineService<ClientType> {
    if (!this._ordine) {
      const { client, path, options } = this.__base
      this._ordine = new ordineService(client, path, 'ordine', options)
    }

    return this._ordine
  }

  public utilizzi(): pacchetto_utilizzoCollectionService<ClientType>
  public utilizzi(id: pacchetto_utilizzoId): pacchetto_utilizzoService<ClientType>
  public utilizzi(id?: pacchetto_utilizzoId | undefined) {
    const fieldName = 'utilizzi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_utilizzoCollectionService(client, path, fieldName, options)
      : new pacchetto_utilizzoService(
          client,
          path,
          new Qpacchetto_utilizzoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class pacchetto_venditaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  pacchetto_vendita,
  Editablepacchetto_vendita,
  Qpacchetto_vendita,
  pacchetto_venditaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpacchetto_vendita, new Qpacchetto_venditaId(name), options)
  }
}

export class tipologia_durata_pacchettoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_durata_pacchetto,
  Editabletipologia_durata_pacchetto,
  Qtipologia_durata_pacchetto
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_durata_pacchetto, options)
  }

  public pacchetto_venditas(): pacchetto_venditaCollectionService<ClientType>
  public pacchetto_venditas(id: pacchetto_venditaId): pacchetto_venditaService<ClientType>
  public pacchetto_venditas(id?: pacchetto_venditaId | undefined) {
    const fieldName = 'pacchetto_venditas'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_venditaCollectionService(client, path, fieldName, options)
      : new pacchetto_venditaService(
          client,
          path,
          new Qpacchetto_venditaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class tipologia_durata_pacchettoCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_durata_pacchetto,
  Editabletipologia_durata_pacchetto,
  Qtipologia_durata_pacchetto,
  tipologia_durata_pacchettoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_durata_pacchetto, new Qtipologia_durata_pacchettoId(name), options)
  }
}

export class pacchetto_utilizzoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  pacchetto_utilizzo,
  Editablepacchetto_utilizzo,
  Qpacchetto_utilizzo
> {
  private _pacchetto_vendita?: pacchetto_venditaService<ClientType>
  private _intervento?: interventoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpacchetto_utilizzo, options)
  }

  public pacchetto_vendita(): pacchetto_venditaService<ClientType> {
    if (!this._pacchetto_vendita) {
      const { client, path, options } = this.__base
      this._pacchetto_vendita = new pacchetto_venditaService(client, path, 'pacchetto_vendita', options)
    }

    return this._pacchetto_vendita
  }

  public intervento(): interventoService<ClientType> {
    if (!this._intervento) {
      const { client, path, options } = this.__base
      this._intervento = new interventoService(client, path, 'intervento', options)
    }

    return this._intervento
  }
}

export class pacchetto_utilizzoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  pacchetto_utilizzo,
  Editablepacchetto_utilizzo,
  Qpacchetto_utilizzo,
  pacchetto_utilizzoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpacchetto_utilizzo, new Qpacchetto_utilizzoId(name), options)
  }
}

export class interventoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  intervento,
  Editableintervento,
  Qintervento
> {
  private _task?: taskService<ClientType>
  private _stato_fatturazione?: fatturazione_interventoService<ClientType>
  private _sede?: sedeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qintervento, options)
  }

  public task(): taskService<ClientType> {
    if (!this._task) {
      const { client, path, options } = this.__base
      this._task = new taskService(client, path, 'task', options)
    }

    return this._task
  }

  public stato_fatturazione(): fatturazione_interventoService<ClientType> {
    if (!this._stato_fatturazione) {
      const { client, path, options } = this.__base
      this._stato_fatturazione = new fatturazione_interventoService(client, path, 'stato_fatturazione', options)
    }

    return this._stato_fatturazione
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public impiegati(): userCollectionService<ClientType>
  public impiegati(id: userId): userService<ClientType>
  public impiegati(id?: userId | undefined) {
    const fieldName = 'impiegati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public riferimenti_cliente(): contatto_aziendaleCollectionService<ClientType>
  public riferimenti_cliente(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public riferimenti_cliente(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'riferimenti_cliente'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public pacchetti_utilizzo(): pacchetto_utilizzoCollectionService<ClientType>
  public pacchetti_utilizzo(id: pacchetto_utilizzoId): pacchetto_utilizzoService<ClientType>
  public pacchetti_utilizzo(id?: pacchetto_utilizzoId | undefined) {
    const fieldName = 'pacchetti_utilizzo'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new pacchetto_utilizzoCollectionService(client, path, fieldName, options)
      : new pacchetto_utilizzoService(
          client,
          path,
          new Qpacchetto_utilizzoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public attivita_lavorative(): attivita_lavorativaCollectionService<ClientType>
  public attivita_lavorative(id: attivita_lavorativaId): attivita_lavorativaService<ClientType>
  public attivita_lavorative(id?: attivita_lavorativaId | undefined) {
    const fieldName = 'attivita_lavorative'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_lavorativaCollectionService(client, path, fieldName, options)
      : new attivita_lavorativaService(
          client,
          path,
          new Qattivita_lavorativaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class interventoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  intervento,
  Editableintervento,
  Qintervento,
  interventoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qintervento, new QinterventoId(name), options)
  }
}

export class fatturazione_interventoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  fatturazione_intervento,
  Editablefatturazione_intervento,
  Qfatturazione_intervento
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qfatturazione_intervento, options)
  }

  public interventi(): interventoCollectionService<ClientType>
  public interventi(id: interventoId): interventoService<ClientType>
  public interventi(id?: interventoId | undefined) {
    const fieldName = 'interventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new interventoCollectionService(client, path, fieldName, options)
      : new interventoService(client, path, new QinterventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class fatturazione_interventoCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  fatturazione_intervento,
  Editablefatturazione_intervento,
  Qfatturazione_intervento,
  fatturazione_interventoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qfatturazione_intervento, new Qfatturazione_interventoId(name), options)
  }
}

export class entita_aziendaleService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  entita_aziendale,
  Editableentita_aziendale,
  Qentita_aziendale
> {
  private _sede?: sedeService<ClientType>
  private _parent?: entita_aziendaleService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qentita_aziendale, options)
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public parent(): entita_aziendaleService<ClientType> {
    if (!this._parent) {
      const { client, path, options } = this.__base
      this._parent = new entita_aziendaleService(client, path, 'parent', options)
    }

    return this._parent
  }

  public analisi_assegnate(): analisiCollectionService<ClientType>
  public analisi_assegnate(id: analisiId): analisiService<ClientType>
  public analisi_assegnate(id?: analisiId | undefined) {
    const fieldName = 'analisi_assegnate'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public emails(): email_aziendaleCollectionService<ClientType>
  public emails(id: email_aziendaleId): email_aziendaleService<ClientType>
  public emails(id?: email_aziendaleId | undefined) {
    const fieldName = 'emails'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new email_aziendaleCollectionService(client, path, fieldName, options)
      : new email_aziendaleService(
          client,
          path,
          new Qemail_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public contatti_aziendali(): contatto_aziendaleCollectionService<ClientType>
  public contatti_aziendali(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public contatti_aziendali(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'contatti_aziendali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public entita_dipendenti(): entita_aziendaleCollectionService<ClientType>
  public entita_dipendenti(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public entita_dipendenti(id?: entita_aziendaleId | undefined) {
    const fieldName = 'entita_dipendenti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class entita_aziendaleCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  entita_aziendale,
  Editableentita_aziendale,
  Qentita_aziendale,
  entita_aziendaleId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qentita_aziendale, new Qentita_aziendaleId(name), options)
  }
}

export class email_aziendaleService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  email_aziendale,
  Editableemail_aziendale,
  Qemail_aziendale
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qemail_aziendale, options)
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public contatti_aziendali(): contatto_aziendaleCollectionService<ClientType>
  public contatti_aziendali(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public contatti_aziendali(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'contatti_aziendali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public entita_aziendali(): entita_aziendaleCollectionService<ClientType>
  public entita_aziendali(id: entita_aziendaleId): entita_aziendaleService<ClientType>
  public entita_aziendali(id?: entita_aziendaleId | undefined) {
    const fieldName = 'entita_aziendali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new entita_aziendaleCollectionService(client, path, fieldName, options)
      : new entita_aziendaleService(
          client,
          path,
          new Qentita_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public dumps(): dumpCollectionService<ClientType>
  public dumps(id: dumpId): dumpService<ClientType>
  public dumps(id?: dumpId | undefined) {
    const fieldName = 'dumps'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class email_aziendaleCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  email_aziendale,
  Editableemail_aziendale,
  Qemail_aziendale,
  email_aziendaleId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qemail_aziendale, new Qemail_aziendaleId(name), options)
  }
}

export class ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ticket,
  Editableticket,
  Qticket
> {
  private _tipologia_ticket?: tipologia_ticketService<ClientType>
  private _assegnato?: userService<ClientType>
  private _tipologia_problema?: tipologia_problemaService<ClientType>
  private _argomento_problema?: argomento_problemaService<ClientType>
  private _stato?: stato_ticketService<ClientType>
  private _piattaforma?: piattaforma_ticketService<ClientType>
  private _applicazione?: qs_supporto_applicazioneService<ClientType>
  private _creatore?: userService<ClientType>
  private _incaricato?: userService<ClientType>
  private _sede?: sedeService<ClientType>
  private _corrispondente_principale?: ticket_corrispondenteService<ClientType>
  private _ticket_QRemoveAssignee?: ticket_QRemoveAssignee
  private _ticket_QSetUrgent?: ticket_QSetUrgent
  private _ticket_QSetWait?: ticket_QSetWait
  private _ticket_QClearWait?: ticket_QClearWait
  private _ticket_QIncrementCallNumber?: ticket_QIncrementCallNumber
  private _ticket_QCancel?: ticket_QCancel
  private _ticket_QTakeCharge?: ticket_QTakeCharge
  private _ticket_QRelease?: ticket_QRelease
  private _ticket_QReopen?: ticket_QReopen
  private _ticket_QSetActivityRequest?: ticket_QSetActivityRequest

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket, options)
  }

  public tipologia_ticket(): tipologia_ticketService<ClientType> {
    if (!this._tipologia_ticket) {
      const { client, path, options } = this.__base
      this._tipologia_ticket = new tipologia_ticketService(client, path, 'tipologia_ticket', options)
    }

    return this._tipologia_ticket
  }

  public assegnato(): userService<ClientType> {
    if (!this._assegnato) {
      const { client, path, options } = this.__base
      this._assegnato = new userService(client, path, 'assegnato', options)
    }

    return this._assegnato
  }

  public tipologia_problema(): tipologia_problemaService<ClientType> {
    if (!this._tipologia_problema) {
      const { client, path, options } = this.__base
      this._tipologia_problema = new tipologia_problemaService(client, path, 'tipologia_problema', options)
    }

    return this._tipologia_problema
  }

  public argomento_problema(): argomento_problemaService<ClientType> {
    if (!this._argomento_problema) {
      const { client, path, options } = this.__base
      this._argomento_problema = new argomento_problemaService(client, path, 'argomento_problema', options)
    }

    return this._argomento_problema
  }

  public stato(): stato_ticketService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_ticketService(client, path, 'stato', options)
    }

    return this._stato
  }

  public piattaforma(): piattaforma_ticketService<ClientType> {
    if (!this._piattaforma) {
      const { client, path, options } = this.__base
      this._piattaforma = new piattaforma_ticketService(client, path, 'piattaforma', options)
    }

    return this._piattaforma
  }

  public applicazione(): qs_supporto_applicazioneService<ClientType> {
    if (!this._applicazione) {
      const { client, path, options } = this.__base
      this._applicazione = new qs_supporto_applicazioneService(client, path, 'applicazione', options)
    }

    return this._applicazione
  }

  public creatore(): userService<ClientType> {
    if (!this._creatore) {
      const { client, path, options } = this.__base
      this._creatore = new userService(client, path, 'creatore', options)
    }

    return this._creatore
  }

  public incaricato(): userService<ClientType> {
    if (!this._incaricato) {
      const { client, path, options } = this.__base
      this._incaricato = new userService(client, path, 'incaricato', options)
    }

    return this._incaricato
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public corrispondente_principale(): ticket_corrispondenteService<ClientType> {
    if (!this._corrispondente_principale) {
      const { client, path, options } = this.__base
      this._corrispondente_principale = new ticket_corrispondenteService(
        client,
        path,
        'corrispondente_principale',
        options,
      )
    }

    return this._corrispondente_principale
  }

  public email_addizionali(): email_aziendaleCollectionService<ClientType>
  public email_addizionali(id: email_aziendaleId): email_aziendaleService<ClientType>
  public email_addizionali(id?: email_aziendaleId | undefined) {
    const fieldName = 'email_addizionali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new email_aziendaleCollectionService(client, path, fieldName, options)
      : new email_aziendaleService(
          client,
          path,
          new Qemail_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public dumps(): dumpCollectionService<ClientType>
  public dumps(id: dumpId): dumpService<ClientType>
  public dumps(id?: dumpId | undefined) {
    const fieldName = 'dumps'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public note_ticket(): nota_ticketCollectionService<ClientType>
  public note_ticket(id: nota_ticketId): nota_ticketService<ClientType>
  public note_ticket(id?: nota_ticketId | undefined) {
    const fieldName = 'note_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nota_ticketCollectionService(client, path, fieldName, options)
      : new nota_ticketService(client, path, new Qnota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public eventi(): evento_ticketCollectionService<ClientType>
  public eventi(id: evento_ticketId): evento_ticketService<ClientType>
  public eventi(id?: evento_ticketId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_ticketCollectionService(client, path, fieldName, options)
      : new evento_ticketService(client, path, new Qevento_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public messaggi(): ticket_messaggioCollectionService<ClientType>
  public messaggi(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public messaggi(id?: ticket_messaggioId | undefined) {
    const fieldName = 'messaggi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public async RemoveAssignee(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QRemoveAssignee) {
      this._ticket_QRemoveAssignee = new ticket_QRemoveAssignee()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QRemoveAssignee.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async SetUrgent(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QSetUrgent) {
      this._ticket_QSetUrgent = new ticket_QSetUrgent()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QSetUrgent.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async SetWait(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QSetWait) {
      this._ticket_QSetWait = new ticket_QSetWait()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QSetWait.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async ClearWait(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QClearWait) {
      this._ticket_QClearWait = new ticket_QClearWait()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QClearWait.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async IncrementCallNumber(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QIncrementCallNumber) {
      this._ticket_QIncrementCallNumber = new ticket_QIncrementCallNumber()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QIncrementCallNumber.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async Cancel(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QCancel) {
      this._ticket_QCancel = new ticket_QCancel()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QCancel.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async TakeCharge(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QTakeCharge) {
      this._ticket_QTakeCharge = new ticket_QTakeCharge()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QTakeCharge.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async Release(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QRelease) {
      this._ticket_QRelease = new ticket_QRelease()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QRelease.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async Reopen(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QReopen) {
      this._ticket_QReopen = new ticket_QReopen()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QReopen.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async SetActivityRequest(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_QSetActivityRequest) {
      this._ticket_QSetActivityRequest = new ticket_QSetActivityRequest()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_QSetActivityRequest.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public asTicket_attivoService() {
    const { client, path, options } = this.__base
    return new ticket_attivoService(client, path, 'QsAdminApi.WebApi.Model.ticket_attivo', {
      ...options,
      subtype: true,
    })
  }
}

export class ticketCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ticket,
  Editableticket,
  Qticket,
  ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket, new QticketId(name), options)
  }

  public asTicket_attivoCollectionService() {
    const { client, path, options } = this.__base
    return new ticket_attivoCollectionService(client, path, 'QsAdminApi.WebApi.Model.ticket_attivo', {
      ...options,
      subtype: true,
    })
  }
}

export class tipologia_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_ticket,
  Editabletipologia_ticket,
  Qtipologia_ticket
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_ticket, options)
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_ticketCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_ticket,
  Editabletipologia_ticket,
  Qtipologia_ticket,
  tipologia_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_ticket, new Qtipologia_ticketId(name), options)
  }
}

export class tipologia_problemaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_problema,
  Editabletipologia_problema,
  Qtipologia_problema
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_problema, options)
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_problemaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_problema,
  Editabletipologia_problema,
  Qtipologia_problema,
  tipologia_problemaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_problema, new Qtipologia_problemaId(name), options)
  }
}

export class argomento_problemaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  argomento_problema,
  Editableargomento_problema,
  Qargomento_problema
> {
  private _qs_applicazione?: qs_supporto_applicazioneService<ClientType>
  private _piattaforma?: piattaforma_ticketService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qargomento_problema, options)
  }

  public qs_applicazione(): qs_supporto_applicazioneService<ClientType> {
    if (!this._qs_applicazione) {
      const { client, path, options } = this.__base
      this._qs_applicazione = new qs_supporto_applicazioneService(client, path, 'qs_applicazione', options)
    }

    return this._qs_applicazione
  }

  public piattaforma(): piattaforma_ticketService<ClientType> {
    if (!this._piattaforma) {
      const { client, path, options } = this.__base
      this._piattaforma = new piattaforma_ticketService(client, path, 'piattaforma', options)
    }

    return this._piattaforma
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class argomento_problemaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  argomento_problema,
  Editableargomento_problema,
  Qargomento_problema,
  argomento_problemaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qargomento_problema, new Qargomento_problemaId(name), options)
  }
}

export class qs_supporto_applicazioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_supporto_applicazione,
  Editableqs_supporto_applicazione,
  Qqs_supporto_applicazione
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_supporto_applicazione, options)
  }

  public argomenti_problemi(): argomento_problemaCollectionService<ClientType>
  public argomenti_problemi(id: argomento_problemaId): argomento_problemaService<ClientType>
  public argomenti_problemi(id?: argomento_problemaId | undefined) {
    const fieldName = 'argomenti_problemi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new argomento_problemaCollectionService(client, path, fieldName, options)
      : new argomento_problemaService(
          client,
          path,
          new Qargomento_problemaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class qs_supporto_applicazioneCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  qs_supporto_applicazione,
  Editableqs_supporto_applicazione,
  Qqs_supporto_applicazione,
  qs_supporto_applicazioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_supporto_applicazione, new Qqs_supporto_applicazioneId(name), options)
  }
}

export class piattaforma_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  piattaforma_ticket,
  Editablepiattaforma_ticket,
  Qpiattaforma_ticket
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpiattaforma_ticket, options)
  }

  public argomenti_problemi(): argomento_problemaCollectionService<ClientType>
  public argomenti_problemi(id: argomento_problemaId): argomento_problemaService<ClientType>
  public argomenti_problemi(id?: argomento_problemaId | undefined) {
    const fieldName = 'argomenti_problemi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new argomento_problemaCollectionService(client, path, fieldName, options)
      : new argomento_problemaService(
          client,
          path,
          new Qargomento_problemaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class piattaforma_ticketCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  piattaforma_ticket,
  Editablepiattaforma_ticket,
  Qpiattaforma_ticket,
  piattaforma_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpiattaforma_ticket, new Qpiattaforma_ticketId(name), options)
  }
}

export class stato_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_ticket,
  Editablestato_ticket,
  Qstato_ticket
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_ticket, options)
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_ticketCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_ticket,
  Editablestato_ticket,
  Qstato_ticket,
  stato_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_ticket, new Qstato_ticketId(name), options)
  }
}

export class ticket_corrispondenteService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ticket_corrispondente,
  Editableticket_corrispondente,
  Qticket_corrispondente
> {
  private _contatto_aziendale?: contatto_aziendaleService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket_corrispondente, options)
  }

  public contatto_aziendale(): contatto_aziendaleService<ClientType> {
    if (!this._contatto_aziendale) {
      const { client, path, options } = this.__base
      this._contatto_aziendale = new contatto_aziendaleService(client, path, 'contatto_aziendale', options)
    }

    return this._contatto_aziendale
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public messaggi(): ticket_messaggioCollectionService<ClientType>
  public messaggi(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public messaggi(id?: ticket_messaggioId | undefined) {
    const fieldName = 'messaggi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public note(): nota_ticketCollectionService<ClientType>
  public note(id: nota_ticketId): nota_ticketService<ClientType>
  public note(id?: nota_ticketId | undefined) {
    const fieldName = 'note'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nota_ticketCollectionService(client, path, fieldName, options)
      : new nota_ticketService(client, path, new Qnota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class ticket_corrispondenteCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  ticket_corrispondente,
  Editableticket_corrispondente,
  Qticket_corrispondente,
  ticket_corrispondenteId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket_corrispondente, new Qticket_corrispondenteId(name), options)
  }
}

export class ticket_messaggioService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ticket_messaggio,
  Editableticket_messaggio,
  Qticket_messaggio
> {
  private _ticket?: ticketService<ClientType>
  private _nota_ticket?: nota_ticketService<ClientType>
  private _corrispondente?: ticket_corrispondenteService<ClientType>
  private _direzione?: tipologia_ticket_messaggioService<ClientType>
  private _stato_elaborazione?: stato_ticket_messaggioService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket_messaggio, options)
  }

  public ticket(): ticketService<ClientType> {
    if (!this._ticket) {
      const { client, path, options } = this.__base
      this._ticket = new ticketService(client, path, 'ticket', options)
    }

    return this._ticket
  }

  public nota_ticket(): nota_ticketService<ClientType> {
    if (!this._nota_ticket) {
      const { client, path, options } = this.__base
      this._nota_ticket = new nota_ticketService(client, path, 'nota_ticket', options)
    }

    return this._nota_ticket
  }

  public corrispondente(): ticket_corrispondenteService<ClientType> {
    if (!this._corrispondente) {
      const { client, path, options } = this.__base
      this._corrispondente = new ticket_corrispondenteService(client, path, 'corrispondente', options)
    }

    return this._corrispondente
  }

  public direzione(): tipologia_ticket_messaggioService<ClientType> {
    if (!this._direzione) {
      const { client, path, options } = this.__base
      this._direzione = new tipologia_ticket_messaggioService(client, path, 'direzione', options)
    }

    return this._direzione
  }

  public stato_elaborazione(): stato_ticket_messaggioService<ClientType> {
    if (!this._stato_elaborazione) {
      const { client, path, options } = this.__base
      this._stato_elaborazione = new stato_ticket_messaggioService(client, path, 'stato_elaborazione', options)
    }

    return this._stato_elaborazione
  }
}

export class ticket_messaggioCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ticket_messaggio,
  Editableticket_messaggio,
  Qticket_messaggio,
  ticket_messaggioId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket_messaggio, new Qticket_messaggioId(name), options)
  }
}

export class nota_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  nota_ticket,
  Editablenota_ticket,
  Qnota_ticket
> {
  private _applicationUser?: ApplicationUserService<ClientType>
  private _ticket?: ticketService<ClientType>
  private _corrispondente?: ticket_corrispondenteService<ClientType>
  private _origine_nota?: tipologia_nota_ticketService<ClientType>
  private _formato_corpo?: tipologia_corpo_nota_ticketService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qnota_ticket, options)
  }

  public applicationUser(): ApplicationUserService<ClientType> {
    if (!this._applicationUser) {
      const { client, path, options } = this.__base
      this._applicationUser = new ApplicationUserService(client, path, 'applicationUser', options)
    }

    return this._applicationUser
  }

  public ticket(): ticketService<ClientType> {
    if (!this._ticket) {
      const { client, path, options } = this.__base
      this._ticket = new ticketService(client, path, 'ticket', options)
    }

    return this._ticket
  }

  public corrispondente(): ticket_corrispondenteService<ClientType> {
    if (!this._corrispondente) {
      const { client, path, options } = this.__base
      this._corrispondente = new ticket_corrispondenteService(client, path, 'corrispondente', options)
    }

    return this._corrispondente
  }

  public origine_nota(): tipologia_nota_ticketService<ClientType> {
    if (!this._origine_nota) {
      const { client, path, options } = this.__base
      this._origine_nota = new tipologia_nota_ticketService(client, path, 'origine_nota', options)
    }

    return this._origine_nota
  }

  public formato_corpo(): tipologia_corpo_nota_ticketService<ClientType> {
    if (!this._formato_corpo) {
      const { client, path, options } = this.__base
      this._formato_corpo = new tipologia_corpo_nota_ticketService(client, path, 'formato_corpo', options)
    }

    return this._formato_corpo
  }

  public messaggi(): ticket_messaggioCollectionService<ClientType>
  public messaggi(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public messaggi(id?: ticket_messaggioId | undefined) {
    const fieldName = 'messaggi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class nota_ticketCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  nota_ticket,
  Editablenota_ticket,
  Qnota_ticket,
  nota_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qnota_ticket, new Qnota_ticketId(name), options)
  }
}

export class tipologia_nota_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_nota_ticket,
  Editabletipologia_nota_ticket,
  Qtipologia_nota_ticket
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_nota_ticket, options)
  }

  public note_ticket(): nota_ticketCollectionService<ClientType>
  public note_ticket(id: nota_ticketId): nota_ticketService<ClientType>
  public note_ticket(id?: nota_ticketId | undefined) {
    const fieldName = 'note_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nota_ticketCollectionService(client, path, fieldName, options)
      : new nota_ticketService(client, path, new Qnota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_nota_ticketCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_nota_ticket,
  Editabletipologia_nota_ticket,
  Qtipologia_nota_ticket,
  tipologia_nota_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_nota_ticket, new Qtipologia_nota_ticketId(name), options)
  }
}

export class tipologia_corpo_nota_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_corpo_nota_ticket,
  Editabletipologia_corpo_nota_ticket,
  Qtipologia_corpo_nota_ticket
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_corpo_nota_ticket, options)
  }

  public note_ticket(): nota_ticketCollectionService<ClientType>
  public note_ticket(id: nota_ticketId): nota_ticketService<ClientType>
  public note_ticket(id?: nota_ticketId | undefined) {
    const fieldName = 'note_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nota_ticketCollectionService(client, path, fieldName, options)
      : new nota_ticketService(client, path, new Qnota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_corpo_nota_ticketCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_corpo_nota_ticket,
  Editabletipologia_corpo_nota_ticket,
  Qtipologia_corpo_nota_ticket,
  tipologia_corpo_nota_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_corpo_nota_ticket, new Qtipologia_corpo_nota_ticketId(name), options)
  }
}

export class tipologia_ticket_messaggioService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_ticket_messaggio,
  Editabletipologia_ticket_messaggio,
  Qtipologia_ticket_messaggio
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_ticket_messaggio, options)
  }

  public messaggi_ticket(): ticket_messaggioCollectionService<ClientType>
  public messaggi_ticket(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public messaggi_ticket(id?: ticket_messaggioId | undefined) {
    const fieldName = 'messaggi_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class tipologia_ticket_messaggioCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_ticket_messaggio,
  Editabletipologia_ticket_messaggio,
  Qtipologia_ticket_messaggio,
  tipologia_ticket_messaggioId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_ticket_messaggio, new Qtipologia_ticket_messaggioId(name), options)
  }
}

export class stato_ticket_messaggioService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_ticket_messaggio,
  Editablestato_ticket_messaggio,
  Qstato_ticket_messaggio
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_ticket_messaggio, options)
  }

  public messaggi_ticket(): ticket_messaggioCollectionService<ClientType>
  public messaggi_ticket(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public messaggi_ticket(id?: ticket_messaggioId | undefined) {
    const fieldName = 'messaggi_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class stato_ticket_messaggioCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  stato_ticket_messaggio,
  Editablestato_ticket_messaggio,
  Qstato_ticket_messaggio,
  stato_ticket_messaggioId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_ticket_messaggio, new Qstato_ticket_messaggioId(name), options)
  }
}

export class dumpService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  dump,
  Editabledump,
  Qdump
> {
  private _email?: email_aziendaleService<ClientType>
  private _licenza?: qs_licenzaService<ClientType>
  private _stato?: stato_dumpService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qdump, options)
  }

  public email(): email_aziendaleService<ClientType> {
    if (!this._email) {
      const { client, path, options } = this.__base
      this._email = new email_aziendaleService(client, path, 'email', options)
    }

    return this._email
  }

  public licenza(): qs_licenzaService<ClientType> {
    if (!this._licenza) {
      const { client, path, options } = this.__base
      this._licenza = new qs_licenzaService(client, path, 'licenza', options)
    }

    return this._licenza
  }

  public stato(): stato_dumpService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_dumpService(client, path, 'stato', options)
    }

    return this._stato
  }

  public tipologie(): tipologia_dumpCollectionService<ClientType>
  public tipologie(id: tipologia_dumpId): tipologia_dumpService<ClientType>
  public tipologie(id?: tipologia_dumpId | undefined) {
    const fieldName = 'tipologie'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new tipologia_dumpCollectionService(client, path, fieldName, options)
      : new tipologia_dumpService(
          client,
          path,
          new Qtipologia_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public tickets(): ticketCollectionService<ClientType>
  public tickets(id: ticketId): ticketService<ClientType>
  public tickets(id?: ticketId | undefined) {
    const fieldName = 'tickets'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticketCollectionService(client, path, fieldName, options)
      : new ticketService(client, path, new QticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public eventi(): evento_dumpCollectionService<ClientType>
  public eventi(id: evento_dumpId): evento_dumpService<ClientType>
  public eventi(id?: evento_dumpId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_dumpCollectionService(client, path, fieldName, options)
      : new evento_dumpService(client, path, new Qevento_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class dumpCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  dump,
  Editabledump,
  Qdump,
  dumpId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qdump, new QdumpId(name), options)
  }
}

export class qs_licenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_licenza,
  Editableqs_licenza,
  Qqs_licenza
> {
  private _versione_uso?: qs_versioneService<ClientType>
  private _sede?: sedeService<ClientType>
  private _stato_licenza?: stato_qs_licenzaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza, options)
  }

  public versione_uso(): qs_versioneService<ClientType> {
    if (!this._versione_uso) {
      const { client, path, options } = this.__base
      this._versione_uso = new qs_versioneService(client, path, 'versione_uso', options)
    }

    return this._versione_uso
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public stato_licenza(): stato_qs_licenzaService<ClientType> {
    if (!this._stato_licenza) {
      const { client, path, options } = this.__base
      this._stato_licenza = new stato_qs_licenzaService(client, path, 'stato_licenza', options)
    }

    return this._stato_licenza
  }

  public dumps(): dumpCollectionService<ClientType>
  public dumps(id: dumpId): dumpService<ClientType>
  public dumps(id?: dumpId | undefined) {
    const fieldName = 'dumps'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public storico(): qs_storico_licenzaCollectionService<ClientType>
  public storico(id: qs_storico_licenzaId): qs_storico_licenzaService<ClientType>
  public storico(id?: qs_storico_licenzaId | undefined) {
    const fieldName = 'storico'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_storico_licenzaCollectionService(client, path, fieldName, options)
      : new qs_storico_licenzaService(
          client,
          path,
          new Qqs_storico_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public info_applicazioni(): qs_licenza_applicazioneCollectionService<ClientType>
  public info_applicazioni(id: qs_licenza_applicazioneId): qs_licenza_applicazioneService<ClientType>
  public info_applicazioni(id?: qs_licenza_applicazioneId | undefined) {
    const fieldName = 'info_applicazioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_applicazioneCollectionService(client, path, fieldName, options)
      : new qs_licenza_applicazioneService(
          client,
          path,
          new Qqs_licenza_applicazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class qs_licenzaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  qs_licenza,
  Editableqs_licenza,
  Qqs_licenza,
  qs_licenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza, new Qqs_licenzaId(name), options)
  }
}

export class qs_versioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_versione,
  Editableqs_versione,
  Qqs_versione
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_versione, options)
  }

  public licenze(): qs_licenzaCollectionService<ClientType>
  public licenze(id: qs_licenzaId): qs_licenzaService<ClientType>
  public licenze(id?: qs_licenzaId | undefined) {
    const fieldName = 'licenze'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenzaCollectionService(client, path, fieldName, options)
      : new qs_licenzaService(client, path, new Qqs_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public versioni_spedite(): qs_storico_licenzaCollectionService<ClientType>
  public versioni_spedite(id: qs_storico_licenzaId): qs_storico_licenzaService<ClientType>
  public versioni_spedite(id?: qs_storico_licenzaId | undefined) {
    const fieldName = 'versioni_spedite'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_storico_licenzaCollectionService(client, path, fieldName, options)
      : new qs_storico_licenzaService(
          client,
          path,
          new Qqs_storico_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_licenza_updates(): qs_licenza_updateCollectionService<ClientType>
  public qs_licenza_updates(id: qs_licenza_updateId): qs_licenza_updateService<ClientType>
  public qs_licenza_updates(id?: qs_licenza_updateId | undefined) {
    const fieldName = 'qs_licenza_updates'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_updateCollectionService(client, path, fieldName, options)
      : new qs_licenza_updateService(
          client,
          path,
          new Qqs_licenza_updateId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public qs_licenza_hotfixes(): qs_licenza_hotfixCollectionService<ClientType>
  public qs_licenza_hotfixes(id: qs_licenza_hotfixId): qs_licenza_hotfixService<ClientType>
  public qs_licenza_hotfixes(id?: qs_licenza_hotfixId | undefined) {
    const fieldName = 'qs_licenza_hotfixes'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_hotfixCollectionService(client, path, fieldName, options)
      : new qs_licenza_hotfixService(
          client,
          path,
          new Qqs_licenza_hotfixId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class qs_versioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  qs_versione,
  Editableqs_versione,
  Qqs_versione,
  qs_versioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_versione, new Qqs_versioneId(name), options)
  }
}

export class qs_storico_licenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_storico_licenza,
  Editableqs_storico_licenza,
  Qqs_storico_licenza
> {
  private _licenza?: qs_licenzaService<ClientType>
  private _versione?: qs_versioneService<ClientType>
  private _sede?: sedeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_storico_licenza, options)
  }

  public licenza(): qs_licenzaService<ClientType> {
    if (!this._licenza) {
      const { client, path, options } = this.__base
      this._licenza = new qs_licenzaService(client, path, 'licenza', options)
    }

    return this._licenza
  }

  public versione(): qs_versioneService<ClientType> {
    if (!this._versione) {
      const { client, path, options } = this.__base
      this._versione = new qs_versioneService(client, path, 'versione', options)
    }

    return this._versione
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }
}

export class qs_storico_licenzaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  qs_storico_licenza,
  Editableqs_storico_licenza,
  Qqs_storico_licenza,
  qs_storico_licenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_storico_licenza, new Qqs_storico_licenzaId(name), options)
  }
}

export class qs_licenza_updateService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_licenza_update,
  Editableqs_licenza_update,
  Qqs_licenza_update
> {
  private _version?: qs_versioneService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza_update, options)
  }

  public version(): qs_versioneService<ClientType> {
    if (!this._version) {
      const { client, path, options } = this.__base
      this._version = new qs_versioneService(client, path, 'version', options)
    }

    return this._version
  }
}

export class qs_licenza_updateCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  qs_licenza_update,
  Editableqs_licenza_update,
  Qqs_licenza_update,
  qs_licenza_updateId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza_update, new Qqs_licenza_updateId(name), options)
  }
}

export class qs_licenza_hotfixService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_licenza_hotfix,
  Editableqs_licenza_hotfix,
  Qqs_licenza_hotfix
> {
  private _version?: qs_versioneService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza_hotfix, options)
  }

  public version(): qs_versioneService<ClientType> {
    if (!this._version) {
      const { client, path, options } = this.__base
      this._version = new qs_versioneService(client, path, 'version', options)
    }

    return this._version
  }
}

export class qs_licenza_hotfixCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  qs_licenza_hotfix,
  Editableqs_licenza_hotfix,
  Qqs_licenza_hotfix,
  qs_licenza_hotfixId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza_hotfix, new Qqs_licenza_hotfixId(name), options)
  }
}

export class stato_qs_licenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_qs_licenza,
  Editablestato_qs_licenza,
  Qstato_qs_licenza
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_qs_licenza, options)
  }

  public licenze(): qs_licenzaCollectionService<ClientType>
  public licenze(id: qs_licenzaId): qs_licenzaService<ClientType>
  public licenze(id?: qs_licenzaId | undefined) {
    const fieldName = 'licenze'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenzaCollectionService(client, path, fieldName, options)
      : new qs_licenzaService(client, path, new Qqs_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_qs_licenzaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_qs_licenza,
  Editablestato_qs_licenza,
  Qstato_qs_licenza,
  stato_qs_licenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_qs_licenza, new Qstato_qs_licenzaId(name), options)
  }
}

export class qs_licenza_applicazioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_licenza_applicazione,
  Editableqs_licenza_applicazione,
  Qqs_licenza_applicazione
> {
  private _tipologia_licenza?: tipologia_qs_licenzaService<ClientType>
  private _ultima_versione?: qs_versioneService<ClientType>
  private _applicazione?: qs_applicazioneService<ClientType>
  private _licenza?: qs_licenzaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza_applicazione, options)
  }

  public tipologia_licenza(): tipologia_qs_licenzaService<ClientType> {
    if (!this._tipologia_licenza) {
      const { client, path, options } = this.__base
      this._tipologia_licenza = new tipologia_qs_licenzaService(client, path, 'tipologia_licenza', options)
    }

    return this._tipologia_licenza
  }

  public ultima_versione(): qs_versioneService<ClientType> {
    if (!this._ultima_versione) {
      const { client, path, options } = this.__base
      this._ultima_versione = new qs_versioneService(client, path, 'ultima_versione', options)
    }

    return this._ultima_versione
  }

  public applicazione(): qs_applicazioneService<ClientType> {
    if (!this._applicazione) {
      const { client, path, options } = this.__base
      this._applicazione = new qs_applicazioneService(client, path, 'applicazione', options)
    }

    return this._applicazione
  }

  public licenza(): qs_licenzaService<ClientType> {
    if (!this._licenza) {
      const { client, path, options } = this.__base
      this._licenza = new qs_licenzaService(client, path, 'licenza', options)
    }

    return this._licenza
  }
}

export class qs_licenza_applicazioneCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  qs_licenza_applicazione,
  Editableqs_licenza_applicazione,
  Qqs_licenza_applicazione,
  qs_licenza_applicazioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_licenza_applicazione, new Qqs_licenza_applicazioneId(name), options)
  }
}

export class tipologia_qs_licenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_qs_licenza,
  Editabletipologia_qs_licenza,
  Qtipologia_qs_licenza
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_qs_licenza, options)
  }

  public qs_licenza_applicazioni(): qs_licenza_applicazioneCollectionService<ClientType>
  public qs_licenza_applicazioni(id: qs_licenza_applicazioneId): qs_licenza_applicazioneService<ClientType>
  public qs_licenza_applicazioni(id?: qs_licenza_applicazioneId | undefined) {
    const fieldName = 'qs_licenza_applicazioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_applicazioneCollectionService(client, path, fieldName, options)
      : new qs_licenza_applicazioneService(
          client,
          path,
          new Qqs_licenza_applicazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class tipologia_qs_licenzaCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_qs_licenza,
  Editabletipologia_qs_licenza,
  Qtipologia_qs_licenza,
  tipologia_qs_licenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_qs_licenza, new Qtipologia_qs_licenzaId(name), options)
  }
}

export class qs_applicazioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  qs_applicazione,
  Editableqs_applicazione,
  Qqs_applicazione
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_applicazione, options)
  }

  public applicazioni_licenze(): qs_licenza_applicazioneCollectionService<ClientType>
  public applicazioni_licenze(id: qs_licenza_applicazioneId): qs_licenza_applicazioneService<ClientType>
  public applicazioni_licenze(id?: qs_licenza_applicazioneId | undefined) {
    const fieldName = 'applicazioni_licenze'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new qs_licenza_applicazioneCollectionService(client, path, fieldName, options)
      : new qs_licenza_applicazioneService(
          client,
          path,
          new Qqs_licenza_applicazioneId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class qs_applicazioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  qs_applicazione,
  Editableqs_applicazione,
  Qqs_applicazione,
  qs_applicazioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qqs_applicazione, new Qqs_applicazioneId(name), options)
  }
}

export class stato_dumpService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_dump,
  Editablestato_dump,
  Qstato_dump
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_dump, options)
  }

  public dumps(): dumpCollectionService<ClientType>
  public dumps(id: dumpId): dumpService<ClientType>
  public dumps(id?: dumpId | undefined) {
    const fieldName = 'dumps'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_dumpCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_dump,
  Editablestato_dump,
  Qstato_dump,
  stato_dumpId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_dump, new Qstato_dumpId(name), options)
  }
}

export class tipologia_dumpService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_dump,
  Editabletipologia_dump,
  Qtipologia_dump
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_dump, options)
  }

  public dumps(): dumpCollectionService<ClientType>
  public dumps(id: dumpId): dumpService<ClientType>
  public dumps(id?: dumpId | undefined) {
    const fieldName = 'dumps'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_dumpCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_dump,
  Editabletipologia_dump,
  Qtipologia_dump,
  tipologia_dumpId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_dump, new Qtipologia_dumpId(name), options)
  }
}

export class evento_dumpService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  evento_dump,
  Editableevento_dump,
  Qevento_dump
> {
  private _dump?: dumpService<ClientType>
  private _utente?: userService<ClientType>
  private _tipologia?: tipologia_evento_dumpService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qevento_dump, options)
  }

  public dump(): dumpService<ClientType> {
    if (!this._dump) {
      const { client, path, options } = this.__base
      this._dump = new dumpService(client, path, 'dump', options)
    }

    return this._dump
  }

  public utente(): userService<ClientType> {
    if (!this._utente) {
      const { client, path, options } = this.__base
      this._utente = new userService(client, path, 'utente', options)
    }

    return this._utente
  }

  public tipologia(): tipologia_evento_dumpService<ClientType> {
    if (!this._tipologia) {
      const { client, path, options } = this.__base
      this._tipologia = new tipologia_evento_dumpService(client, path, 'tipologia', options)
    }

    return this._tipologia
  }
}

export class evento_dumpCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  evento_dump,
  Editableevento_dump,
  Qevento_dump,
  evento_dumpId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qevento_dump, new Qevento_dumpId(name), options)
  }
}

export class tipologia_evento_dumpService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_evento_dump,
  Editabletipologia_evento_dump,
  Qtipologia_evento_dump
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_evento_dump, options)
  }

  public eventi(): evento_dumpCollectionService<ClientType>
  public eventi(id: evento_dumpId): evento_dumpService<ClientType>
  public eventi(id?: evento_dumpId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_dumpCollectionService(client, path, fieldName, options)
      : new evento_dumpService(client, path, new Qevento_dumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_evento_dumpCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_evento_dump,
  Editabletipologia_evento_dump,
  Qtipologia_evento_dump,
  tipologia_evento_dumpId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_evento_dump, new Qtipologia_evento_dumpId(name), options)
  }
}

export class evento_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  evento_ticket,
  Editableevento_ticket,
  Qevento_ticket
> {
  private _ticket?: ticketService<ClientType>
  private _utente?: userService<ClientType>
  private _tipologia?: tipologia_evento_ticketService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qevento_ticket, options)
  }

  public ticket(): ticketService<ClientType> {
    if (!this._ticket) {
      const { client, path, options } = this.__base
      this._ticket = new ticketService(client, path, 'ticket', options)
    }

    return this._ticket
  }

  public utente(): userService<ClientType> {
    if (!this._utente) {
      const { client, path, options } = this.__base
      this._utente = new userService(client, path, 'utente', options)
    }

    return this._utente
  }

  public tipologia(): tipologia_evento_ticketService<ClientType> {
    if (!this._tipologia) {
      const { client, path, options } = this.__base
      this._tipologia = new tipologia_evento_ticketService(client, path, 'tipologia', options)
    }

    return this._tipologia
  }
}

export class evento_ticketCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  evento_ticket,
  Editableevento_ticket,
  Qevento_ticket,
  evento_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qevento_ticket, new Qevento_ticketId(name), options)
  }
}

export class tipologia_evento_ticketService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_evento_ticket,
  Editabletipologia_evento_ticket,
  Qtipologia_evento_ticket
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_evento_ticket, options)
  }

  public eventi_ticket(): evento_ticketCollectionService<ClientType>
  public eventi_ticket(id: evento_ticketId): evento_ticketService<ClientType>
  public eventi_ticket(id?: evento_ticketId | undefined) {
    const fieldName = 'eventi_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_ticketCollectionService(client, path, fieldName, options)
      : new evento_ticketService(client, path, new Qevento_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_evento_ticketCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_evento_ticket,
  Editabletipologia_evento_ticket,
  Qtipologia_evento_ticket,
  tipologia_evento_ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_evento_ticket, new Qtipologia_evento_ticketId(name), options)
  }
}

export class personalizzazioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  personalizzazione,
  Editablepersonalizzazione,
  Qpersonalizzazione
> {
  private _sede?: sedeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpersonalizzazione, options)
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public analisis(): analisiCollectionService<ClientType>
  public analisis(id: analisiId): analisiService<ClientType>
  public analisis(id?: analisiId | undefined) {
    const fieldName = 'analisis'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new analisiCollectionService(client, path, fieldName, options)
      : new analisiService(client, path, new QanalisiId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public responsabili(): userCollectionService<ClientType>
  public responsabili(id: userId): userService<ClientType>
  public responsabili(id?: userId | undefined) {
    const fieldName = 'responsabili'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class personalizzazioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  personalizzazione,
  Editablepersonalizzazione,
  Qpersonalizzazione,
  personalizzazioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpersonalizzazione, new QpersonalizzazioneId(name), options)
  }
}

export class ad_quoteService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_quote,
  Editablead_quote,
  Qad_quote
> {
  private _csn?: ad_csnService<ClientType>
  private _azienda?: aziendaService<ClientType>
  private _contact?: contatto_aziendaleService<ClientType>
  private _admin?: contatto_aziendaleService<ClientType>
  private _commessa?: commessaService<ClientType>
  private _author?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_quote, options)
  }

  public csn(): ad_csnService<ClientType> {
    if (!this._csn) {
      const { client, path, options } = this.__base
      this._csn = new ad_csnService(client, path, 'csn', options)
    }

    return this._csn
  }

  public azienda(): aziendaService<ClientType> {
    if (!this._azienda) {
      const { client, path, options } = this.__base
      this._azienda = new aziendaService(client, path, 'azienda', options)
    }

    return this._azienda
  }

  public contact(): contatto_aziendaleService<ClientType> {
    if (!this._contact) {
      const { client, path, options } = this.__base
      this._contact = new contatto_aziendaleService(client, path, 'contact', options)
    }

    return this._contact
  }

  public admin(): contatto_aziendaleService<ClientType> {
    if (!this._admin) {
      const { client, path, options } = this.__base
      this._admin = new contatto_aziendaleService(client, path, 'admin', options)
    }

    return this._admin
  }

  public commessa(): commessaService<ClientType> {
    if (!this._commessa) {
      const { client, path, options } = this.__base
      this._commessa = new commessaService(client, path, 'commessa', options)
    }

    return this._commessa
  }

  public author(): userService<ClientType> {
    if (!this._author) {
      const { client, path, options } = this.__base
      this._author = new userService(client, path, 'author', options)
    }

    return this._author
  }

  public ad_subscriptions(): ad_subscriptionCollectionService<ClientType>
  public ad_subscriptions(id: ad_subscriptionId): ad_subscriptionService<ClientType>
  public ad_subscriptions(id?: ad_subscriptionId | undefined) {
    const fieldName = 'ad_subscriptions'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_subscriptionCollectionService(client, path, fieldName, options)
      : new ad_subscriptionService(
          client,
          path,
          new Qad_subscriptionId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public contatti_addizionali(): contatto_aziendaleCollectionService<ClientType>
  public contatti_addizionali(id: contatto_aziendaleId): contatto_aziendaleService<ClientType>
  public contatti_addizionali(id?: contatto_aziendaleId | undefined) {
    const fieldName = 'contatti_addizionali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new contatto_aziendaleCollectionService(client, path, fieldName, options)
      : new contatto_aziendaleService(
          client,
          path,
          new Qcontatto_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ad_quote_histories(): ad_quote_historyCollectionService<ClientType>
  public ad_quote_histories(id: ad_quote_historyId): ad_quote_historyService<ClientType>
  public ad_quote_histories(id?: ad_quote_historyId | undefined) {
    const fieldName = 'ad_quote_histories'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quote_historyCollectionService(client, path, fieldName, options)
      : new ad_quote_historyService(
          client,
          path,
          new Qad_quote_historyId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class ad_quoteCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_quote,
  Editablead_quote,
  Qad_quote,
  ad_quoteId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_quote, new Qad_quoteId(name), options)
  }
}

export class ad_subscriptionService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_subscription,
  Editablead_subscription,
  Qad_subscription
> {
  private _csn?: ad_csnService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_subscription, options)
  }

  public csn(): ad_csnService<ClientType> {
    if (!this._csn) {
      const { client, path, options } = this.__base
      this._csn = new ad_csnService(client, path, 'csn', options)
    }

    return this._csn
  }

  public ad_quotes(): ad_quoteCollectionService<ClientType>
  public ad_quotes(id: ad_quoteId): ad_quoteService<ClientType>
  public ad_quotes(id?: ad_quoteId | undefined) {
    const fieldName = 'ad_quotes'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ad_quoteCollectionService(client, path, fieldName, options)
      : new ad_quoteService(client, path, new Qad_quoteId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class ad_subscriptionCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_subscription,
  Editablead_subscription,
  Qad_subscription,
  ad_subscriptionId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_subscription, new Qad_subscriptionId(name), options)
  }
}

export class ad_quote_historyService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_quote_history,
  Editablead_quote_history,
  Qad_quote_history
> {
  private _quote?: ad_quoteService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_quote_history, options)
  }

  public quote(): ad_quoteService<ClientType> {
    if (!this._quote) {
      const { client, path, options } = this.__base
      this._quote = new ad_quoteService(client, path, 'quote', options)
    }

    return this._quote
  }
}

export class ad_quote_historyCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_quote_history,
  Editablead_quote_history,
  Qad_quote_history,
  ad_quote_historyId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_quote_history, new Qad_quote_historyId(name), options)
  }
}

export class attivita_commService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  attivita_comm,
  Editableattivita_comm,
  Qattivita_comm
> {
  private _autore?: userService<ClientType>
  private _contatto_aziendale?: contatto_aziendaleService<ClientType>
  private _tipologia?: tipologia_attivita_commService<ClientType>
  private _precedente?: attivita_commService<ClientType>
  private _stato?: stato_att_commService<ClientType>
  private _commessa?: commessaService<ClientType>
  private _sede?: sedeService<ClientType>
  private _prodotto?: qs_applicazioneService<ClientType>
  private _piattaforma?: piattaforma_attivita_lavorativaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qattivita_comm, options)
  }

  public autore(): userService<ClientType> {
    if (!this._autore) {
      const { client, path, options } = this.__base
      this._autore = new userService(client, path, 'autore', options)
    }

    return this._autore
  }

  public contatto_aziendale(): contatto_aziendaleService<ClientType> {
    if (!this._contatto_aziendale) {
      const { client, path, options } = this.__base
      this._contatto_aziendale = new contatto_aziendaleService(client, path, 'contatto_aziendale', options)
    }

    return this._contatto_aziendale
  }

  public tipologia(): tipologia_attivita_commService<ClientType> {
    if (!this._tipologia) {
      const { client, path, options } = this.__base
      this._tipologia = new tipologia_attivita_commService(client, path, 'tipologia', options)
    }

    return this._tipologia
  }

  public precedente(): attivita_commService<ClientType> {
    if (!this._precedente) {
      const { client, path, options } = this.__base
      this._precedente = new attivita_commService(client, path, 'precedente', options)
    }

    return this._precedente
  }

  public stato(): stato_att_commService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_att_commService(client, path, 'stato', options)
    }

    return this._stato
  }

  public commessa(): commessaService<ClientType> {
    if (!this._commessa) {
      const { client, path, options } = this.__base
      this._commessa = new commessaService(client, path, 'commessa', options)
    }

    return this._commessa
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public prodotto(): qs_applicazioneService<ClientType> {
    if (!this._prodotto) {
      const { client, path, options } = this.__base
      this._prodotto = new qs_applicazioneService(client, path, 'prodotto', options)
    }

    return this._prodotto
  }

  public piattaforma(): piattaforma_attivita_lavorativaService<ClientType> {
    if (!this._piattaforma) {
      const { client, path, options } = this.__base
      this._piattaforma = new piattaforma_attivita_lavorativaService(client, path, 'piattaforma', options)
    }

    return this._piattaforma
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public eventi(): eventoCollectionService<ClientType>
  public eventi(id: eventoId): eventoService<ClientType>
  public eventi(id?: eventoId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new eventoCollectionService(client, path, fieldName, options)
      : new eventoService(client, path, new QeventoId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class attivita_commCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  attivita_comm,
  Editableattivita_comm,
  Qattivita_comm,
  attivita_commId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qattivita_comm, new Qattivita_commId(name), options)
  }
}

export class tipologia_attivita_commService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_attivita_comm,
  Editabletipologia_attivita_comm,
  Qtipologia_attivita_comm
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_attivita_comm, options)
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_attivita_commCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_attivita_comm,
  Editabletipologia_attivita_comm,
  Qtipologia_attivita_comm,
  tipologia_attivita_commId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_attivita_comm, new Qtipologia_attivita_commId(name), options)
  }
}

export class stato_att_commService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_att_comm,
  Editablestato_att_comm,
  Qstato_att_comm
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_att_comm, options)
  }

  public attivita_commerciali(): attivita_commCollectionService<ClientType>
  public attivita_commerciali(id: attivita_commId): attivita_commService<ClientType>
  public attivita_commerciali(id?: attivita_commId | undefined) {
    const fieldName = 'attivita_commerciali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new attivita_commCollectionService(client, path, fieldName, options)
      : new attivita_commService(client, path, new Qattivita_commId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_att_commCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_att_comm,
  Editablestato_att_comm,
  Qstato_att_comm,
  stato_att_commId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_att_comm, new Qstato_att_commId(name), options)
  }
}

export class eventoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  evento,
  Editableevento,
  Qevento
> {
  private _utente?: userService<ClientType>
  private _attivita_comm?: attivita_commService<ClientType>
  private _task?: taskService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qevento, options)
  }

  public utente(): userService<ClientType> {
    if (!this._utente) {
      const { client, path, options } = this.__base
      this._utente = new userService(client, path, 'utente', options)
    }

    return this._utente
  }

  public attivita_comm(): attivita_commService<ClientType> {
    if (!this._attivita_comm) {
      const { client, path, options } = this.__base
      this._attivita_comm = new attivita_commService(client, path, 'attivita_comm', options)
    }

    return this._attivita_comm
  }

  public task(): taskService<ClientType> {
    if (!this._task) {
      const { client, path, options } = this.__base
      this._task = new taskService(client, path, 'task', options)
    }

    return this._task
  }

  public promemoria(): promemoriaCollectionService<ClientType>
  public promemoria(id: promemoriaId): promemoriaService<ClientType>
  public promemoria(id?: promemoriaId | undefined) {
    const fieldName = 'promemoria'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new promemoriaCollectionService(client, path, fieldName, options)
      : new promemoriaService(client, path, new QpromemoriaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public partecipanti(): partecipante_eventoCollectionService<ClientType>
  public partecipanti(id: partecipante_eventoId): partecipante_eventoService<ClientType>
  public partecipanti(id?: partecipante_eventoId | undefined) {
    const fieldName = 'partecipanti'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new partecipante_eventoCollectionService(client, path, fieldName, options)
      : new partecipante_eventoService(
          client,
          path,
          new Qpartecipante_eventoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class eventoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  evento,
  Editableevento,
  Qevento,
  eventoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qevento, new QeventoId(name), options)
  }
}

export class promemoriaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  promemoria,
  Editablepromemoria,
  Qpromemoria
> {
  private _evento?: eventoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpromemoria, options)
  }

  public evento(): eventoService<ClientType> {
    if (!this._evento) {
      const { client, path, options } = this.__base
      this._evento = new eventoService(client, path, 'evento', options)
    }

    return this._evento
  }
}

export class promemoriaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  promemoria,
  Editablepromemoria,
  Qpromemoria,
  promemoriaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpromemoria, new QpromemoriaId(name), options)
  }
}

export class partecipante_eventoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  partecipante_evento,
  Editablepartecipante_evento,
  Qpartecipante_evento
> {
  private _partecipante_qs?: userService<ClientType>
  private _partecipante_est?: contatto_aziendaleService<ClientType>
  private _evento?: eventoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpartecipante_evento, options)
  }

  public partecipante_qs(): userService<ClientType> {
    if (!this._partecipante_qs) {
      const { client, path, options } = this.__base
      this._partecipante_qs = new userService(client, path, 'partecipante_qs', options)
    }

    return this._partecipante_qs
  }

  public partecipante_est(): contatto_aziendaleService<ClientType> {
    if (!this._partecipante_est) {
      const { client, path, options } = this.__base
      this._partecipante_est = new contatto_aziendaleService(client, path, 'partecipante_est', options)
    }

    return this._partecipante_est
  }

  public evento(): eventoService<ClientType> {
    if (!this._evento) {
      const { client, path, options } = this.__base
      this._evento = new eventoService(client, path, 'evento', options)
    }

    return this._evento
  }
}

export class partecipante_eventoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  partecipante_evento,
  Editablepartecipante_evento,
  Qpartecipante_evento,
  partecipante_eventoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpartecipante_evento, new Qpartecipante_eventoId(name), options)
  }
}

export class storico_contatto_aziendaleService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  storico_contatto_aziendale,
  Editablestorico_contatto_aziendale,
  Qstorico_contatto_aziendale
> {
  private _nuovo?: contatto_aziendaleService<ClientType>
  private _vecchio?: contatto_aziendaleService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstorico_contatto_aziendale, options)
  }

  public nuovo(): contatto_aziendaleService<ClientType> {
    if (!this._nuovo) {
      const { client, path, options } = this.__base
      this._nuovo = new contatto_aziendaleService(client, path, 'nuovo', options)
    }

    return this._nuovo
  }

  public vecchio(): contatto_aziendaleService<ClientType> {
    if (!this._vecchio) {
      const { client, path, options } = this.__base
      this._vecchio = new contatto_aziendaleService(client, path, 'vecchio', options)
    }

    return this._vecchio
  }
}

export class storico_contatto_aziendaleCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  storico_contatto_aziendale,
  Editablestorico_contatto_aziendale,
  Qstorico_contatto_aziendale,
  storico_contatto_aziendaleId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstorico_contatto_aziendale, new Qstorico_contatto_aziendaleId(name), options)
  }
}

export class est_licenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  est_licenza,
  Editableest_licenza,
  Qest_licenza
> {
  private _software?: est_softwareService<ClientType>
  private _piano_mantenimento?: est_piano_mantenimentoService<ClientType>
  private _stato_noleggio?: est_stato_noleggioService<ClientType>
  private _sede?: sedeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_licenza, options)
  }

  public software(): est_softwareService<ClientType> {
    if (!this._software) {
      const { client, path, options } = this.__base
      this._software = new est_softwareService(client, path, 'software', options)
    }

    return this._software
  }

  public piano_mantenimento(): est_piano_mantenimentoService<ClientType> {
    if (!this._piano_mantenimento) {
      const { client, path, options } = this.__base
      this._piano_mantenimento = new est_piano_mantenimentoService(client, path, 'piano_mantenimento', options)
    }

    return this._piano_mantenimento
  }

  public stato_noleggio(): est_stato_noleggioService<ClientType> {
    if (!this._stato_noleggio) {
      const { client, path, options } = this.__base
      this._stato_noleggio = new est_stato_noleggioService(client, path, 'stato_noleggio', options)
    }

    return this._stato_noleggio
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }
}

export class est_licenzaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  est_licenza,
  Editableest_licenza,
  Qest_licenza,
  est_licenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_licenza, new Qest_licenzaId(name), options)
  }
}

export class est_softwareService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  est_software,
  Editableest_software,
  Qest_software
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_software, options)
  }

  public licenze_est(): est_licenzaCollectionService<ClientType>
  public licenze_est(id: est_licenzaId): est_licenzaService<ClientType>
  public licenze_est(id?: est_licenzaId | undefined) {
    const fieldName = 'licenze_est'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_licenzaCollectionService(client, path, fieldName, options)
      : new est_licenzaService(client, path, new Qest_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class est_softwareCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  est_software,
  Editableest_software,
  Qest_software,
  est_softwareId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_software, new Qest_softwareId(name), options)
  }
}

export class est_piano_mantenimentoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  est_piano_mantenimento,
  Editableest_piano_mantenimento,
  Qest_piano_mantenimento
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_piano_mantenimento, options)
  }

  public licenze_est(): est_licenzaCollectionService<ClientType>
  public licenze_est(id: est_licenzaId): est_licenzaService<ClientType>
  public licenze_est(id?: est_licenzaId | undefined) {
    const fieldName = 'licenze_est'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_licenzaCollectionService(client, path, fieldName, options)
      : new est_licenzaService(client, path, new Qest_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class est_piano_mantenimentoCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  est_piano_mantenimento,
  Editableest_piano_mantenimento,
  Qest_piano_mantenimento,
  est_piano_mantenimentoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_piano_mantenimento, new Qest_piano_mantenimentoId(name), options)
  }
}

export class est_stato_noleggioService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  est_stato_noleggio,
  Editableest_stato_noleggio,
  Qest_stato_noleggio
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_stato_noleggio, options)
  }

  public licenze_est(): est_licenzaCollectionService<ClientType>
  public licenze_est(id: est_licenzaId): est_licenzaService<ClientType>
  public licenze_est(id?: est_licenzaId | undefined) {
    const fieldName = 'licenze_est'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new est_licenzaCollectionService(client, path, fieldName, options)
      : new est_licenzaService(client, path, new Qest_licenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class est_stato_noleggioCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  est_stato_noleggio,
  Editableest_stato_noleggio,
  Qest_stato_noleggio,
  est_stato_noleggioId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qest_stato_noleggio, new Qest_stato_noleggioId(name), options)
  }
}

export class assistenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  assistenza,
  Editableassistenza,
  Qassistenza
> {
  private _maintenance?: tipologia_assistenzaService<ClientType>
  private _telefonica?: tipologia_assistenza_telefonicaService<ClientType>
  private _sede?: sedeService<ClientType>
  private _riferimento?: assistenzaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qassistenza, options)
  }

  public maintenance(): tipologia_assistenzaService<ClientType> {
    if (!this._maintenance) {
      const { client, path, options } = this.__base
      this._maintenance = new tipologia_assistenzaService(client, path, 'maintenance', options)
    }

    return this._maintenance
  }

  public telefonica(): tipologia_assistenza_telefonicaService<ClientType> {
    if (!this._telefonica) {
      const { client, path, options } = this.__base
      this._telefonica = new tipologia_assistenza_telefonicaService(client, path, 'telefonica', options)
    }

    return this._telefonica
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public riferimento(): assistenzaService<ClientType> {
    if (!this._riferimento) {
      const { client, path, options } = this.__base
      this._riferimento = new assistenzaService(client, path, 'riferimento', options)
    }

    return this._riferimento
  }

  public contratti_derivati(): assistenzaCollectionService<ClientType>
  public contratti_derivati(id: assistenzaId): assistenzaService<ClientType>
  public contratti_derivati(id?: assistenzaId | undefined) {
    const fieldName = 'contratti_derivati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new assistenzaCollectionService(client, path, fieldName, options)
      : new assistenzaService(client, path, new QassistenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class assistenzaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  assistenza,
  Editableassistenza,
  Qassistenza,
  assistenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qassistenza, new QassistenzaId(name), options)
  }
}

export class tipologia_assistenzaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_assistenza,
  Editabletipologia_assistenza,
  Qtipologia_assistenza
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_assistenza, options)
  }

  public assistenze(): assistenzaCollectionService<ClientType>
  public assistenze(id: assistenzaId): assistenzaService<ClientType>
  public assistenze(id?: assistenzaId | undefined) {
    const fieldName = 'assistenze'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new assistenzaCollectionService(client, path, fieldName, options)
      : new assistenzaService(client, path, new QassistenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_assistenzaCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_assistenza,
  Editabletipologia_assistenza,
  Qtipologia_assistenza,
  tipologia_assistenzaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_assistenza, new Qtipologia_assistenzaId(name), options)
  }
}

export class tipologia_assistenza_telefonicaService<
  in out ClientType extends ODataHttpClient,
> extends EntityTypeServiceV4<
  ClientType,
  tipologia_assistenza_telefonica,
  Editabletipologia_assistenza_telefonica,
  Qtipologia_assistenza_telefonica
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_assistenza_telefonica, options)
  }

  public assistenze(): assistenzaCollectionService<ClientType>
  public assistenze(id: assistenzaId): assistenzaService<ClientType>
  public assistenze(id?: assistenzaId | undefined) {
    const fieldName = 'assistenze'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new assistenzaCollectionService(client, path, fieldName, options)
      : new assistenzaService(client, path, new QassistenzaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_assistenza_telefonicaCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  tipologia_assistenza_telefonica,
  Editabletipologia_assistenza_telefonica,
  Qtipologia_assistenza_telefonica,
  tipologia_assistenza_telefonicaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(
      client,
      basePath,
      name,
      qtipologia_assistenza_telefonica,
      new Qtipologia_assistenza_telefonicaId(name),
      options,
    )
  }
}

export class template_offertaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  template_offerta,
  Editabletemplate_offerta,
  Qtemplate_offerta
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtemplate_offerta, options)
  }

  public offerte(): offertaCollectionService<ClientType>
  public offerte(id: offertaId): offertaService<ClientType>
  public offerte(id?: offertaId | undefined) {
    const fieldName = 'offerte'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new offertaCollectionService(client, path, fieldName, options)
      : new offertaService(client, path, new QoffertaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class template_offertaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  template_offerta,
  Editabletemplate_offerta,
  Qtemplate_offerta,
  template_offertaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtemplate_offerta, new Qtemplate_offertaId(name), options)
  }
}

export class stato_fatturazione_ordineService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_fatturazione_ordine,
  Editablestato_fatturazione_ordine,
  Qstato_fatturazione_ordine
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_fatturazione_ordine, options)
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_fatturazione_ordineCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  stato_fatturazione_ordine,
  Editablestato_fatturazione_ordine,
  Qstato_fatturazione_ordine,
  stato_fatturazione_ordineId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_fatturazione_ordine, new Qstato_fatturazione_ordineId(name), options)
  }
}

export class stato_acconto_ordineService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_acconto_ordine,
  Editablestato_acconto_ordine,
  Qstato_acconto_ordine
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_acconto_ordine, options)
  }

  public ordini(): ordineCollectionService<ClientType>
  public ordini(id: ordineId): ordineService<ClientType>
  public ordini(id?: ordineId | undefined) {
    const fieldName = 'ordini'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ordineCollectionService(client, path, fieldName, options)
      : new ordineService(client, path, new QordineId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_acconto_ordineCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  stato_acconto_ordine,
  Editablestato_acconto_ordine,
  Qstato_acconto_ordine,
  stato_acconto_ordineId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_acconto_ordine, new Qstato_acconto_ordineId(name), options)
  }
}

export class punto_fatturazione_ordineService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  punto_fatturazione_ordine,
  Editablepunto_fatturazione_ordine,
  Qpunto_fatturazione_ordine
> {
  private _ordine?: ordineService<ClientType>
  private _stato?: stato_punto_fatturazioneService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpunto_fatturazione_ordine, options)
  }

  public ordine(): ordineService<ClientType> {
    if (!this._ordine) {
      const { client, path, options } = this.__base
      this._ordine = new ordineService(client, path, 'ordine', options)
    }

    return this._ordine
  }

  public stato(): stato_punto_fatturazioneService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_punto_fatturazioneService(client, path, 'stato', options)
    }

    return this._stato
  }

  public tasks(): taskCollectionService<ClientType>
  public tasks(id: taskId): taskService<ClientType>
  public tasks(id?: taskId | undefined) {
    const fieldName = 'tasks'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class punto_fatturazione_ordineCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  punto_fatturazione_ordine,
  Editablepunto_fatturazione_ordine,
  Qpunto_fatturazione_ordine,
  punto_fatturazione_ordineId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpunto_fatturazione_ordine, new Qpunto_fatturazione_ordineId(name), options)
  }
}

export class stato_punto_fatturazioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_punto_fatturazione,
  Editablestato_punto_fatturazione,
  Qstato_punto_fatturazione
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_punto_fatturazione, options)
  }

  public punti_fatturazione_ordine(): punto_fatturazione_ordineCollectionService<ClientType>
  public punti_fatturazione_ordine(id: punto_fatturazione_ordineId): punto_fatturazione_ordineService<ClientType>
  public punti_fatturazione_ordine(id?: punto_fatturazione_ordineId | undefined) {
    const fieldName = 'punti_fatturazione_ordine'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new punto_fatturazione_ordineCollectionService(client, path, fieldName, options)
      : new punto_fatturazione_ordineService(
          client,
          path,
          new Qpunto_fatturazione_ordineId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class stato_punto_fatturazioneCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  stato_punto_fatturazione,
  Editablestato_punto_fatturazione,
  Qstato_punto_fatturazione,
  stato_punto_fatturazioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_punto_fatturazione, new Qstato_punto_fatturazioneId(name), options)
  }
}

export class stato_taskService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_task,
  Editablestato_task,
  Qstato_task
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_task, options)
  }

  public tasks(): taskCollectionService<ClientType>
  public tasks(id: taskId): taskService<ClientType>
  public tasks(id?: taskId | undefined) {
    const fieldName = 'tasks'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new taskCollectionService(client, path, fieldName, options)
      : new taskService(client, path, new QtaskId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class stato_taskCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  stato_task,
  Editablestato_task,
  Qstato_task,
  stato_taskId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_task, new Qstato_taskId(name), options)
  }
}

export class promemoria_taskService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  promemoria_task,
  Editablepromemoria_task,
  Qpromemoria_task
> {
  private _task?: taskService<ClientType>
  private _stato?: stato_promemoria_taskService<ClientType>
  private _utente?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpromemoria_task, options)
  }

  public task(): taskService<ClientType> {
    if (!this._task) {
      const { client, path, options } = this.__base
      this._task = new taskService(client, path, 'task', options)
    }

    return this._task
  }

  public stato(): stato_promemoria_taskService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_promemoria_taskService(client, path, 'stato', options)
    }

    return this._stato
  }

  public utente(): userService<ClientType> {
    if (!this._utente) {
      const { client, path, options } = this.__base
      this._utente = new userService(client, path, 'utente', options)
    }

    return this._utente
  }
}

export class promemoria_taskCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  promemoria_task,
  Editablepromemoria_task,
  Qpromemoria_task,
  promemoria_taskId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qpromemoria_task, new Qpromemoria_taskId(name), options)
  }
}

export class stato_promemoria_taskService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  stato_promemoria_task,
  Editablestato_promemoria_task,
  Qstato_promemoria_task
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_promemoria_task, options)
  }

  public promemoria(): promemoria_taskCollectionService<ClientType>
  public promemoria(id: promemoria_taskId): promemoria_taskService<ClientType>
  public promemoria(id?: promemoria_taskId | undefined) {
    const fieldName = 'promemoria'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new promemoria_taskCollectionService(client, path, fieldName, options)
      : new promemoria_taskService(
          client,
          path,
          new Qpromemoria_taskId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class stato_promemoria_taskCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  stato_promemoria_task,
  Editablestato_promemoria_task,
  Qstato_promemoria_task,
  stato_promemoria_taskId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qstato_promemoria_task, new Qstato_promemoria_taskId(name), options)
  }
}

export class info_impiegatoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  info_impiegato,
  Editableinfo_impiegato,
  Qinfo_impiegato
> {
  private _auto?: autoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qinfo_impiegato, options)
  }

  public auto(): autoService<ClientType> {
    if (!this._auto) {
      const { client, path, options } = this.__base
      this._auto = new autoService(client, path, 'auto', options)
    }

    return this._auto
  }

  public users(): userCollectionService<ClientType>
  public users(id: userId): userService<ClientType>
  public users(id?: userId | undefined) {
    const fieldName = 'users'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public giorni_lavorativi(): giorno_lavorativoCollectionService<ClientType>
  public giorni_lavorativi(id: giorno_lavorativoId): giorno_lavorativoService<ClientType>
  public giorni_lavorativi(id?: giorno_lavorativoId | undefined) {
    const fieldName = 'giorni_lavorativi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new giorno_lavorativoCollectionService(client, path, fieldName, options)
      : new giorno_lavorativoService(
          client,
          path,
          new Qgiorno_lavorativoId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }
}

export class info_impiegatoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  info_impiegato,
  Editableinfo_impiegato,
  Qinfo_impiegato,
  info_impiegatoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qinfo_impiegato, new Qinfo_impiegatoId(name), options)
  }
}

export class autoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  auto,
  Editableauto,
  Qauto
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qauto, options)
  }
}

export class autoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  auto,
  Editableauto,
  Qauto,
  autoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qauto, new QautoId(name), options)
  }
}

export class giorno_lavorativoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  giorno_lavorativo,
  Editablegiorno_lavorativo,
  Qgiorno_lavorativo
> {
  private _info_impiegato?: info_impiegatoService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qgiorno_lavorativo, options)
  }

  public info_impiegato(): info_impiegatoService<ClientType> {
    if (!this._info_impiegato) {
      const { client, path, options } = this.__base
      this._info_impiegato = new info_impiegatoService(client, path, 'info_impiegato', options)
    }

    return this._info_impiegato
  }
}

export class giorno_lavorativoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  giorno_lavorativo,
  Editablegiorno_lavorativo,
  Qgiorno_lavorativo,
  giorno_lavorativoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qgiorno_lavorativo, new Qgiorno_lavorativoId(name), options)
  }
}

export class riunioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  riunione,
  Editableriunione,
  Qriunione
> {
  private _tipologia?: tipologia_riunioneService<ClientType>
  private _autore?: userService<ClientType>
  private _riunione_QCreateDocument?: riunione_QCreateDocument

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qriunione, options)
  }

  public tipologia(): tipologia_riunioneService<ClientType> {
    if (!this._tipologia) {
      const { client, path, options } = this.__base
      this._tipologia = new tipologia_riunioneService(client, path, 'tipologia', options)
    }

    return this._tipologia
  }

  public autore(): userService<ClientType> {
    if (!this._autore) {
      const { client, path, options } = this.__base
      this._autore = new userService(client, path, 'autore', options)
    }

    return this._autore
  }

  public impiegati(): userCollectionService<ClientType>
  public impiegati(id: userId): userService<ClientType>
  public impiegati(id?: userId | undefined) {
    const fieldName = 'impiegati'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new userCollectionService(client, path, fieldName, options)
      : new userService(client, path, new QuserId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public async CreateDocument(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._riunione_QCreateDocument) {
      this._riunione_QCreateDocument = new riunione_QCreateDocument()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._riunione_QCreateDocument.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }
}

export class riunioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  riunione,
  Editableriunione,
  Qriunione,
  riunioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qriunione, new QriunioneId(name), options)
  }
}

export class tipologia_riunioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_riunione,
  Editabletipologia_riunione,
  Qtipologia_riunione
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_riunione, options)
  }

  public riunioni(): riunioneCollectionService<ClientType>
  public riunioni(id: riunioneId): riunioneService<ClientType>
  public riunioni(id?: riunioneId | undefined) {
    const fieldName = 'riunioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new riunioneCollectionService(client, path, fieldName, options)
      : new riunioneService(client, path, new QriunioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_riunioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_riunione,
  Editabletipologia_riunione,
  Qtipologia_riunione,
  tipologia_riunioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_riunione, new Qtipologia_riunioneId(name), options)
  }
}

export class telefonataService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  telefonata,
  Editabletelefonata,
  Qtelefonata
> {
  private _autore?: userService<ClientType>
  private _destinatario?: userService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtelefonata, options)
  }

  public autore(): userService<ClientType> {
    if (!this._autore) {
      const { client, path, options } = this.__base
      this._autore = new userService(client, path, 'autore', options)
    }

    return this._autore
  }

  public destinatario(): userService<ClientType> {
    if (!this._destinatario) {
      const { client, path, options } = this.__base
      this._destinatario = new userService(client, path, 'destinatario', options)
    }

    return this._destinatario
  }
}

export class telefonataCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  telefonata,
  Editabletelefonata,
  Qtelefonata,
  telefonataId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtelefonata, new QtelefonataId(name), options)
  }
}

export class spesaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  spesa,
  Editablespesa,
  Qspesa
> {
  private _impiegato?: userService<ClientType>
  private _tipologia?: tipologia_spesaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qspesa, options)
  }

  public impiegato(): userService<ClientType> {
    if (!this._impiegato) {
      const { client, path, options } = this.__base
      this._impiegato = new userService(client, path, 'impiegato', options)
    }

    return this._impiegato
  }

  public tipologia(): tipologia_spesaService<ClientType> {
    if (!this._tipologia) {
      const { client, path, options } = this.__base
      this._tipologia = new tipologia_spesaService(client, path, 'tipologia', options)
    }

    return this._tipologia
  }
}

export class spesaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  spesa,
  Editablespesa,
  Qspesa,
  spesaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qspesa, new QspesaId(name), options)
  }
}

export class tipologia_spesaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_spesa,
  Editabletipologia_spesa,
  Qtipologia_spesa
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_spesa, options)
  }

  public spese(): spesaCollectionService<ClientType>
  public spese(id: spesaId): spesaService<ClientType>
  public spese(id?: spesaId | undefined) {
    const fieldName = 'spese'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new spesaCollectionService(client, path, fieldName, options)
      : new spesaService(client, path, new QspesaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_spesaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_spesa,
  Editabletipologia_spesa,
  Qtipologia_spesa,
  tipologia_spesaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_spesa, new Qtipologia_spesaId(name), options)
  }
}

export class ApplicationUserLoginInfoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ApplicationUserLoginInfo,
  EditableApplicationUserLoginInfo,
  QApplicationUserLoginInfo
> {
  private _User?: ApplicationUserService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qApplicationUserLoginInfo, options)
  }

  public User(): ApplicationUserService<ClientType> {
    if (!this._User) {
      const { client, path, options } = this.__base
      this._User = new ApplicationUserService(client, path, 'User', options)
    }

    return this._User
  }
}

export class ApplicationUserLoginInfoCollectionService<
  in out ClientType extends ODataHttpClient,
> extends EntitySetServiceV4<
  ClientType,
  ApplicationUserLoginInfo,
  EditableApplicationUserLoginInfo,
  QApplicationUserLoginInfo,
  BaseObjectId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qApplicationUserLoginInfo, new QBaseObjectId(name), options)
  }
}

export class ad_incentivoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_incentivo,
  Editablead_incentivo,
  Qad_incentivo
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_incentivo, options)
  }

  public commissioni(): commissioneCollectionService<ClientType>
  public commissioni(id: commissioneId): commissioneService<ClientType>
  public commissioni(id?: commissioneId | undefined) {
    const fieldName = 'commissioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commissioneCollectionService(client, path, fieldName, options)
      : new commissioneService(client, path, new QcommissioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class ad_incentivoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_incentivo,
  Editablead_incentivo,
  Qad_incentivo,
  ad_incentivoId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_incentivo, new Qad_incentivoId(name), options)
  }
}

export class commissioneService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  commissione,
  Editablecommissione,
  Qcommissione
> {
  private _rivenditore?: aziendaService<ClientType>
  private _incentivo?: ad_incentivoService<ClientType>
  private _percentuale?: ad_percentualeService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcommissione, options)
  }

  public rivenditore(): aziendaService<ClientType> {
    if (!this._rivenditore) {
      const { client, path, options } = this.__base
      this._rivenditore = new aziendaService(client, path, 'rivenditore', options)
    }

    return this._rivenditore
  }

  public incentivo(): ad_incentivoService<ClientType> {
    if (!this._incentivo) {
      const { client, path, options } = this.__base
      this._incentivo = new ad_incentivoService(client, path, 'incentivo', options)
    }

    return this._incentivo
  }

  public percentuale(): ad_percentualeService<ClientType> {
    if (!this._percentuale) {
      const { client, path, options } = this.__base
      this._percentuale = new ad_percentualeService(client, path, 'percentuale', options)
    }

    return this._percentuale
  }
}

export class commissioneCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  commissione,
  Editablecommissione,
  Qcommissione,
  commissioneId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qcommissione, new QcommissioneId(name), options)
  }
}

export class ad_percentualeService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_percentuale,
  Editablead_percentuale,
  Qad_percentuale
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_percentuale, options)
  }

  public commissioni(): commissioneCollectionService<ClientType>
  public commissioni(id: commissioneId): commissioneService<ClientType>
  public commissioni(id?: commissioneId | undefined) {
    const fieldName = 'commissioni'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new commissioneCollectionService(client, path, fieldName, options)
      : new commissioneService(client, path, new QcommissioneId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class ad_percentualeCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_percentuale,
  Editablead_percentuale,
  Qad_percentuale,
  ad_percentualeId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_percentuale, new Qad_percentualeId(name), options)
  }
}

export class ad_product_catalogService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_product_catalog,
  Editablead_product_catalog,
  Qad_product_catalog
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_product_catalog, options)
  }
}

export class ad_product_catalogCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_product_catalog,
  Editablead_product_catalog,
  Qad_product_catalog,
  ad_product_catalogId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_product_catalog, new Qad_product_catalogId(name), options)
  }
}

export class ad_promotionService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ad_promotion,
  Editablead_promotion,
  Qad_promotion
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_promotion, options)
  }
}

export class ad_promotionCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ad_promotion,
  Editablead_promotion,
  Qad_promotion,
  ad_promotionId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qad_promotion, new Qad_promotionId(name), options)
  }
}

export class badgeService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  badge,
  Editablebadge,
  Qbadge
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qbadge, options)
  }
}

export class badgeCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  badge,
  Editablebadge,
  Qbadge,
  badgeId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qbadge, new QbadgeId(name), options)
  }
}

export class constantsService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  constants,
  Editableconstants,
  Qconstants
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qconstants, options)
  }
}

export class constantsCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  constants,
  Editableconstants,
  Qconstants,
  constantsId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qconstants, new QconstantsId(name), options)
  }
}

export class notificaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  notifica,
  Editablenotifica,
  Qnotifica
> {
  private _user?: userService<ClientType>
  private _tipologia?: tipologia_notificaService<ClientType>

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qnotifica, options)
  }

  public user(): userService<ClientType> {
    if (!this._user) {
      const { client, path, options } = this.__base
      this._user = new userService(client, path, 'user', options)
    }

    return this._user
  }

  public tipologia(): tipologia_notificaService<ClientType> {
    if (!this._tipologia) {
      const { client, path, options } = this.__base
      this._tipologia = new tipologia_notificaService(client, path, 'tipologia', options)
    }

    return this._tipologia
  }
}

export class notificaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  notifica,
  Editablenotifica,
  Qnotifica,
  notificaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qnotifica, new QnotificaId(name), options)
  }
}

export class tipologia_notificaService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  tipologia_notifica,
  Editabletipologia_notifica,
  Qtipologia_notifica
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_notifica, options)
  }

  public notifiche(): notificaCollectionService<ClientType>
  public notifiche(id: notificaId): notificaService<ClientType>
  public notifiche(id?: notificaId | undefined) {
    const fieldName = 'notifiche'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new notificaCollectionService(client, path, fieldName, options)
      : new notificaService(client, path, new QnotificaId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }
}

export class tipologia_notificaCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  tipologia_notifica,
  Editabletipologia_notifica,
  Qtipologia_notifica,
  tipologia_notificaId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qtipologia_notifica, new Qtipologia_notificaId(name), options)
  }
}

export class ticket_attivoService<in out ClientType extends ODataHttpClient> extends EntityTypeServiceV4<
  ClientType,
  ticket_attivo,
  Editableticket_attivo,
  Qticket_attivo
> {
  private _tipologia_ticket?: tipologia_ticketService<ClientType>
  private _assegnato?: userService<ClientType>
  private _tipologia_problema?: tipologia_problemaService<ClientType>
  private _argomento_problema?: argomento_problemaService<ClientType>
  private _stato?: stato_ticketService<ClientType>
  private _piattaforma?: piattaforma_ticketService<ClientType>
  private _applicazione?: qs_supporto_applicazioneService<ClientType>
  private _creatore?: userService<ClientType>
  private _incaricato?: userService<ClientType>
  private _sede?: sedeService<ClientType>
  private _corrispondente_principale?: ticket_corrispondenteService<ClientType>
  private _ticket_attivo_QRemoveAssignee?: ticket_attivo_QRemoveAssignee
  private _ticket_attivo_QSetUrgent?: ticket_attivo_QSetUrgent
  private _ticket_attivo_QSetWait?: ticket_attivo_QSetWait
  private _ticket_attivo_QClearWait?: ticket_attivo_QClearWait
  private _ticket_attivo_QIncrementCallNumber?: ticket_attivo_QIncrementCallNumber
  private _ticket_attivo_QCancel?: ticket_attivo_QCancel
  private _ticket_attivo_QTakeCharge?: ticket_attivo_QTakeCharge
  private _ticket_attivo_QRelease?: ticket_attivo_QRelease
  private _ticket_attivo_QReopen?: ticket_attivo_QReopen
  private _ticket_attivo_QSetActivityRequest?: ticket_attivo_QSetActivityRequest

  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket_attivo, options)
  }

  public tipologia_ticket(): tipologia_ticketService<ClientType> {
    if (!this._tipologia_ticket) {
      const { client, path, options } = this.__base
      this._tipologia_ticket = new tipologia_ticketService(client, path, 'tipologia_ticket', options)
    }

    return this._tipologia_ticket
  }

  public assegnato(): userService<ClientType> {
    if (!this._assegnato) {
      const { client, path, options } = this.__base
      this._assegnato = new userService(client, path, 'assegnato', options)
    }

    return this._assegnato
  }

  public tipologia_problema(): tipologia_problemaService<ClientType> {
    if (!this._tipologia_problema) {
      const { client, path, options } = this.__base
      this._tipologia_problema = new tipologia_problemaService(client, path, 'tipologia_problema', options)
    }

    return this._tipologia_problema
  }

  public argomento_problema(): argomento_problemaService<ClientType> {
    if (!this._argomento_problema) {
      const { client, path, options } = this.__base
      this._argomento_problema = new argomento_problemaService(client, path, 'argomento_problema', options)
    }

    return this._argomento_problema
  }

  public stato(): stato_ticketService<ClientType> {
    if (!this._stato) {
      const { client, path, options } = this.__base
      this._stato = new stato_ticketService(client, path, 'stato', options)
    }

    return this._stato
  }

  public piattaforma(): piattaforma_ticketService<ClientType> {
    if (!this._piattaforma) {
      const { client, path, options } = this.__base
      this._piattaforma = new piattaforma_ticketService(client, path, 'piattaforma', options)
    }

    return this._piattaforma
  }

  public applicazione(): qs_supporto_applicazioneService<ClientType> {
    if (!this._applicazione) {
      const { client, path, options } = this.__base
      this._applicazione = new qs_supporto_applicazioneService(client, path, 'applicazione', options)
    }

    return this._applicazione
  }

  public creatore(): userService<ClientType> {
    if (!this._creatore) {
      const { client, path, options } = this.__base
      this._creatore = new userService(client, path, 'creatore', options)
    }

    return this._creatore
  }

  public incaricato(): userService<ClientType> {
    if (!this._incaricato) {
      const { client, path, options } = this.__base
      this._incaricato = new userService(client, path, 'incaricato', options)
    }

    return this._incaricato
  }

  public sede(): sedeService<ClientType> {
    if (!this._sede) {
      const { client, path, options } = this.__base
      this._sede = new sedeService(client, path, 'sede', options)
    }

    return this._sede
  }

  public corrispondente_principale(): ticket_corrispondenteService<ClientType> {
    if (!this._corrispondente_principale) {
      const { client, path, options } = this.__base
      this._corrispondente_principale = new ticket_corrispondenteService(
        client,
        path,
        'corrispondente_principale',
        options,
      )
    }

    return this._corrispondente_principale
  }

  public email_addizionali(): email_aziendaleCollectionService<ClientType>
  public email_addizionali(id: email_aziendaleId): email_aziendaleService<ClientType>
  public email_addizionali(id?: email_aziendaleId | undefined) {
    const fieldName = 'email_addizionali'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new email_aziendaleCollectionService(client, path, fieldName, options)
      : new email_aziendaleService(
          client,
          path,
          new Qemail_aziendaleId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public dumps(): dumpCollectionService<ClientType>
  public dumps(id: dumpId): dumpService<ClientType>
  public dumps(id?: dumpId | undefined) {
    const fieldName = 'dumps'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new dumpCollectionService(client, path, fieldName, options)
      : new dumpService(client, path, new QdumpId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public note_ticket(): nota_ticketCollectionService<ClientType>
  public note_ticket(id: nota_ticketId): nota_ticketService<ClientType>
  public note_ticket(id?: nota_ticketId | undefined) {
    const fieldName = 'note_ticket'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new nota_ticketCollectionService(client, path, fieldName, options)
      : new nota_ticketService(client, path, new Qnota_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public eventi(): evento_ticketCollectionService<ClientType>
  public eventi(id: evento_ticketId): evento_ticketService<ClientType>
  public eventi(id?: evento_ticketId | undefined) {
    const fieldName = 'eventi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new evento_ticketCollectionService(client, path, fieldName, options)
      : new evento_ticketService(client, path, new Qevento_ticketId(fieldName).buildUrl(id, isUrlNotEncoded()), options)
  }

  public messaggi(): ticket_messaggioCollectionService<ClientType>
  public messaggi(id: ticket_messaggioId): ticket_messaggioService<ClientType>
  public messaggi(id?: ticket_messaggioId | undefined) {
    const fieldName = 'messaggi'
    const { client, path, options, isUrlNotEncoded } = this.__base
    return typeof id === 'undefined' || id === null
      ? new ticket_messaggioCollectionService(client, path, fieldName, options)
      : new ticket_messaggioService(
          client,
          path,
          new Qticket_messaggioId(fieldName).buildUrl(id, isUrlNotEncoded()),
          options,
        )
  }

  public async RemoveAssignee(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QRemoveAssignee) {
      this._ticket_attivo_QRemoveAssignee = new ticket_attivo_QRemoveAssignee()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QRemoveAssignee.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async SetUrgent(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QSetUrgent) {
      this._ticket_attivo_QSetUrgent = new ticket_attivo_QSetUrgent()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QSetUrgent.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async SetWait(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QSetWait) {
      this._ticket_attivo_QSetWait = new ticket_attivo_QSetWait()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QSetWait.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async ClearWait(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QClearWait) {
      this._ticket_attivo_QClearWait = new ticket_attivo_QClearWait()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QClearWait.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async IncrementCallNumber(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QIncrementCallNumber) {
      this._ticket_attivo_QIncrementCallNumber = new ticket_attivo_QIncrementCallNumber()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QIncrementCallNumber.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async Cancel(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QCancel) {
      this._ticket_attivo_QCancel = new ticket_attivo_QCancel()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QCancel.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async TakeCharge(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QTakeCharge) {
      this._ticket_attivo_QTakeCharge = new ticket_attivo_QTakeCharge()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QTakeCharge.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async Release(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QRelease) {
      this._ticket_attivo_QRelease = new ticket_attivo_QRelease()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QRelease.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async Reopen(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QReopen) {
      this._ticket_attivo_QReopen = new ticket_attivo_QReopen()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QReopen.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }

  public async SetActivityRequest(
    requestConfig?: ODataHttpClientConfig<ClientType>,
  ): Promise<HttpResponseModel<ODataModelResponseV4<void>>> {
    if (!this._ticket_attivo_QSetActivityRequest) {
      this._ticket_attivo_QSetActivityRequest = new ticket_attivo_QSetActivityRequest()
    }

    const { addFullPath, client, getDefaultHeaders, isUrlNotEncoded } = this.__base
    const url = addFullPath(this._ticket_attivo_QSetActivityRequest.buildUrl())
    return client.post(url, {}, requestConfig, getDefaultHeaders())
  }
}

export class ticket_attivoCollectionService<in out ClientType extends ODataHttpClient> extends EntitySetServiceV4<
  ClientType,
  ticket_attivo,
  Editableticket_attivo,
  Qticket_attivo,
  ticketId
> {
  constructor(client: ClientType, basePath: string, name: string, options?: ODataServiceOptionsInternal) {
    super(client, basePath, name, qticket_attivo, new QticketId(name), options)
  }
}
